/* eslint-disable */
/* tslint:disable */
// @ts-nocheck
/*
 * ---------------------------------------------------------------
 * ## THIS FILE WAS GENERATED VIA SWAGGER-TYPESCRIPT-API        ##
 * ##                                                           ##
 * ## AUTHOR: acacode                                           ##
 * ## SOURCE: https://github.com/acacode/swagger-typescript-api ##
 * ---------------------------------------------------------------
 */

type UtilRequiredKeys<T, K extends keyof T> = Omit<T, K> & Required<Pick<T, K>>;

/**
 * <p>Members:</p><ul><li>0: Unknown</li><li>1: Heating</li><li>2: Cooling</li></ul>
 * @format int32
 */
export type WorkingModeTypeInternal = 0 | 1 | 2;

/**
 * <p>Members:</p><ul><li>1: StateCondition</li><li>2: Action</li></ul>
 * @format int32
 */
export type TriggerValidationPartType = 1 | 2;

/**
 * <p>Members:</p><ul><li>0: General</li><li>1: ChannelNotFound</li><li>2: CircularExecution</li></ul>
 * @format int32
 */
export type TriggerValidationErrorType = 0 | 1 | 2;

/**
 * <p>Members:</p><ul><li>0: Undefined</li><li>1: Continue</li><li>2: StopExecution</li></ul>
 * @format int32
 */
export type TriggerOnFailureMode = 0 | 1 | 2;

/**
 * <p>Members:</p><ul><li>1: BlindDirectionIs</li><li>2: BlindPositionIsGreaterThanOrEqualTo</li><li>3: BlindPositionIsLessThanOrEqualTo</li><li>4: GateDirectionIs</li><li>5: LightStateIs</li><li>6: SwitchStateIs</li><li>7: IsInTimeInterval</li><li>8: GatePositionIsGreaterThanOrEqualTo</li><li>9: GatePositionIsLessThanOrEqualTo</li></ul>
 * @format int32
 */
export type TriggerConditionType = 1 | 2 | 3 | 4 | 5 | 6 | 7 | 8 | 9;

/**
 * <p>Members:</p><ul><li>1: SetBlindPosition</li><li>2: SetBlindDirection</li><li>3: SetGateStepByStep</li><li>4: SetLightState</li><li>5: SetLightColor</li><li>6: SetLightBrightness</li><li>7: SetLightSetOnTime</li><li>8: SetSwitchState</li><li>9: SetSwitchSetOnTime</li><li>10: DelayInSeconds</li><li>11: GateSetPosition</li><li>12: GateSetDirection</li><li>13: GateTilt</li></ul>
 * @format int32
 */
export type TriggerActionType =
  | 1
  | 2
  | 3
  | 4
  | 5
  | 6
  | 7
  | 8
  | 9
  | 10
  | 11
  | 12
  | 13;

/**
 * <p>Members:</p><ul><li>0: Unknown</li><li>1: Summer</li><li>2: Winter</li><li>3: All</li></ul>
 * @format int32
 */
export type TimeZoneKindInternal = 0 | 1 | 2 | 3;

/**
 * <p>Members:</p><ul><li>0: Unknown</li><li>1: Celsius</li><li>2: Fahrenheit</li></ul>
 * @format int32
 */
export type TemperatureUnitTypeInternal = 0 | 1 | 2;

/**
 * <p>Members:</p><ul><li>0: None</li><li>1: Custom</li><li>2: TauronG11</li><li>3: TauronG12</li><li>4: TauronG12W</li><li>5: TauronG13</li><li>6: EneaG11</li><li>7: EneaG12</li><li>8: EneaG12W</li><li>9: PgeG11</li><li>10: PgeG12</li><li>11: PgeG12W</li><li>12: PgeG12As</li><li>13: EonG11</li><li>14: EonG12</li><li>15: EonG12W</li><li>16: EonG12As</li><li>17: EnergaG11</li><li>18: EnergaG12</li><li>19: EnergaG12W</li><li>20: EnergaG12R</li><li>21: TauronDynamic</li><li>22: EneaDynamic</li><li>23: PgeDynamic</li><li>24: EonDynamic</li><li>25: EnergaDynamic</li><li>26: TauronG13S</li></ul>
 * @format int32
 */
export type TariffKindInternal =
  | 0
  | 1
  | 2
  | 3
  | 4
  | 5
  | 6
  | 7
  | 8
  | 9
  | 10
  | 11
  | 12
  | 13
  | 14
  | 15
  | 16
  | 17
  | 18
  | 19
  | 20
  | 21
  | 22
  | 23
  | 24
  | 25
  | 26;

/**
 * <p>Members:</p><ul><li>0: Unknown</li><li>1: Toggle</li><li>1000: Advanced</li></ul>
 * @format int32
 */
export type SwitchSupportedSlotsInternal = 0 | 1 | 1000;

/**
 * <p>Members:</p><ul><li>0: Unknown</li><li>1: Off</li><li>2: On</li></ul>
 * @format int32
 */
export type SwitchStateInternal = 0 | 1 | 2;

/**
 * <p>Members:</p><ul><li>0: AlwaysOff</li><li>1: AlwaysOn</li><li>2: KeepState</li></ul>
 * @format int32
 */
export type SupplyReturnBehaviorInternal = 0 | 1 | 2;

/**
 * <p>Members:</p><ul><li>0: Unknown</li><li>1: Voltage</li><li>2: Current</li><li>3: ActivePower</li><li>4: BalancedPower</li><li>5: ReactivePower</li><li>6: ApparentPower</li><li>7: PhaseAngle</li><li>8: PowerFactor</li><li>9: Frequency</li></ul>
 * @format int32
 */
export type SourceThresholdInternal = 0 | 1 | 2 | 3 | 4 | 5 | 6 | 7 | 8 | 9;

/**
 * <p>Members:</p><ul><li>0: Unknown</li><li>1: Humidity</li><li>2: Temperature</li><li>3: Wind</li><li>4: Brightness</li><li>5: Pressure</li></ul>
 * @format int32
 */
export type SensorTypeInternal = 0 | 1 | 2 | 3 | 4 | 5;

/**
 * <p>Members:</p><ul><li>0: Unknown</li><li>1: Off</li><li>2: Day</li><li>3: Night</li><li>4: Manual</li><li>5: Holiday</li><li>6: Party</li><li>7: Hometimetable</li><li>8: Outsidehometimetable</li><li>9: Holidaytimetable</li><li>10: Antifreezetimetable</li></ul>
 * @format int32
 */
export type RegulatorModeTypeInternal =
  | 0
  | 1
  | 2
  | 3
  | 4
  | 5
  | 6
  | 7
  | 8
  | 9
  | 10;

/**
 * <p>Members:</p><ul><li>0: Ok</li><li>1: DeviceOrChannelNotFound</li><li>2: DeviceDisconnected</li><li>3: ContractNotSupported</li></ul>
 * @format int32
 */
export type PublishStatus = 0 | 1 | 2 | 3;

/**
 * <p>Members:</p><ul><li>0: Unknown</li><li>1: Dynamic</li><li>2: G13S</li></ul>
 * @format int32
 */
export type PriceTriggerSubType = 0 | 1 | 2;

/**
 * <p>Members:</p><ul><li>0: T0</li><li>1: T1</li><li>2: T2</li><li>3: T3</li></ul>
 * @format int32
 */
export type PredefinedTemperatureReferenceTypeInternal = 0 | 1 | 2 | 3;

/**
 * <p>Members:</p><ul><li>0: None</li><li>1: Total</li><li>2: Weekly</li><li>4: Monthly</li><li>8: Daily</li></ul>
 * @format int32
 */
export type PeriodWeeklyPeriod = 0 | 1 | 2 | 4 | 8;

/**
 * <p>Members:</p><ul><li>0: Unknown</li><li>1: TestMode</li><li>2: Eco</li><li>3: Comfort</li><li>4: FullSelfConsumption</li><li>5: SelfConsumptionWithPowerLimit</li><li>6: SelfConsumptionWithRelays</li></ul>
 * @format int32
 */
export type OptimizerModeInternal = 0 | 1 | 2 | 3 | 4 | 5 | 6;

/**
 * <p>Members:</p><ul><li>0: Undefined</li><li>1: Subscriptions</li><li>2: Smtp</li><li>3: Push</li><li>4: QueryOnly</li></ul>
 * @format int32
 */
export type NotificationSenderType = 0 | 1 | 2 | 3 | 4;

/**
 * <p>Members:</p><ul><li>0: Undefined</li><li>1: InvitationReceived</li><li>2: InvitationAcceptedByInvitee</li><li>3: InvitationCanceledByCreator</li><li>4: InvitationRejectedByInvitee</li><li>5: InstallationAccessChanged</li><li>6: RemovedFromInstallation</li><li>7: ChannelsAccessRemoved</li><li>8: DeviceRemovedOrFactoryReset</li><li>9: DeviceAdded</li><li>10: ChannelsAdded</li><li>11: ChannelsAccessExpired</li><li>12: UserInstallationExpired</li><li>13: GroupsAccessExpired</li><li>14: ChannelsAccessAdded</li><li>15: GroupAccessAdded</li><li>16: GroupAccessRemoved</li><li>17: PublicGroupAdded</li><li>18: PublicGroupRemoved</li><li>19: PublicGroupChanged</li><li>20: ActionCreated</li><li>21: InstallationPassed</li><li>22: UsesDepleted</li><li>23: ResourceAccessModified</li><li>24: GateAlert</li><li>25: MeterAlert</li><li>26: ResetToDefaults</li><li>27: ActionRemoved</li></ul>
 * @format int32
 */
export type NotificationCode =
  | 0
  | 1
  | 2
  | 3
  | 4
  | 5
  | 6
  | 7
  | 8
  | 9
  | 10
  | 11
  | 12
  | 13
  | 14
  | 15
  | 16
  | 17
  | 18
  | 19
  | 20
  | 21
  | 22
  | 23
  | 24
  | 25
  | 26
  | 27;

/**
 * <p>Members:</p><ul><li>0: Unknown</li><li>1: Debug</li><li>2: Information</li><li>3: Warning</li><li>4: Critical</li><li>5: None</li></ul>
 * @format int32
 */
export type MetricsLevelTypeInternal = 0 | 1 | 2 | 3 | 4 | 5;

/**
 * <p>Members:</p><ul><li>0: Unknown</li><li>1: Internal</li><li>2: Standalone</li><li>3: BudgetPlug</li></ul>
 * @format int32
 */
export type MeterTypeInternal = 0 | 1 | 2 | 3;

/**
 * <p>Members:</p><ul><li>0: Unknown</li><li>1: Main</li><li>2: Pv</li><li>3: EnergyStorage</li><li>4: Consumption</li></ul>
 * @format int32
 */
export type MeterPurposeInternal = 0 | 1 | 2 | 3 | 4;

/**
 * <p>Members:</p><ul><li>0: Unknown</li><li>1: None</li><li>2: InHours</li><li>3: InDays</li><li>4: InMonths</li><li>5: InYears</li></ul>
 * @format int32
 */
export type MeasurementDataRangeInternal = 0 | 1 | 2 | 3 | 4 | 5;

/**
 * <p>Members:</p><ul><li>0: Unknown</li><li>1: Meter</li><li>2: Optimizer</li></ul>
 * @format int32
 */
export type MeasurementChannelKind = 0 | 1 | 2;

/**
 * <p>Members:</p><ul><li>0: Unknown</li><li>1: Off</li><li>2: On</li></ul>
 * @format int32
 */
export type LightToggleValueInternal = 0 | 1 | 2;

/**
 * <p>Members:</p><ul><li>0: Unknown</li><li>1: Toggle</li><li>1000: Advanced</li></ul>
 * @format int32
 */
export type LightSupportedSlotsInternal = 0 | 1 | 1000;

/**
 * <p>Members:</p><ul><li>0: Unknown</li><li>1: Toggle</li><li>2: Brightness</li><li>3: Colors</li><li>4: Temperature</li></ul>
 * @format int32
 */
export type LightModeTypeInternal = 0 | 1 | 2 | 3 | 4;

/**
 * <p>Members:</p><ul><li>0: Undefined</li><li>1: Lavva</li><li>2: Exalus</li></ul>
 * @format int32
 */
export type IntegrationType = 0 | 1 | 2;

/**
 * <p>Members:</p><ul><li>0: SingleClick</li><li>1: DoubleClick</li></ul>
 * @format int32
 */
export type InputTriggerInternal = 0 | 1;

/**
 * <p>Members:</p><ul><li>1: EveryDay</li><li>2: WorkWeek</li><li>3: Custom</li></ul>
 * @format int32
 */
export type HvacChannelTimetableRepeatType = 1 | 2 | 3;

/**
 * <p>Members:</p><ul><li>0: Ignore</li><li>1: Perform</li><li>2: DoNotPerform</li></ul>
 * @format int32
 */
export type HolidaysHandling = 0 | 1 | 2;

/**
 * <p>Members:</p><ul><li>0: Unknown</li><li>1: Monostable</li><li>2: Bistable</li></ul>
 * @format int32
 */
export type GenericInputTypeInternal = 0 | 1 | 2;

/**
 * <p>Members:</p><ul><li>0: Normal</li><li>1: Reversed</li></ul>
 * @format int32
 */
export type GenericInputMonostableModeInternal = 0 | 1;

/**
 * <p>Members:</p><ul><li>0: Normal</li><li>1: TwoWay</li></ul>
 * @format int32
 */
export type GenericInputBistableModeInternal = 0 | 1;

/**
 * <p>Members:</p><ul><li>0: Unknown</li><li>1: LimitOpen</li><li>2: LimitClose</li><li>3: OpticBarrier</li><li>4: Button</li><li>5: MultiLimitSwitch</li><li>6: DoorDailyFuncButton</li><li>7: LockSensor</li><li>8: LimitCloseOGI</li><li>1000: Advanced</li></ul>
 * @format int32
 */
export type GateSupportedSlotsInternal =
  | 0
  | 1
  | 2
  | 3
  | 4
  | 5
  | 6
  | 7
  | 8
  | 1000;

/**
 * <p>Members:</p><ul><li>0: Unknown</li><li>1: Stopped</li><li>2: Stopping</li><li>3: Open</li><li>4: Opening</li><li>5: Closed</li><li>6: Closing</li></ul>
 * @format int32
 */
export type GateStateDirectionInternal = 0 | 1 | 2 | 3 | 4 | 5 | 6;

/**
 * <p>Members:</p><ul><li>0: Unknown</li><li>1: RollUp</li><li>2: StepByStep</li></ul>
 * @format int32
 */
export type GateModeInternal = 0 | 1 | 2;

/**
 * <p>Members:</p><ul><li>0: Unknown</li><li>1: Locked</li><li>2: DailyModeAndDoorClosed</li><li>3: Opened</li></ul>
 * @format int32
 */
export type GateLockStateInternal = 0 | 1 | 2 | 3;

/**
 * <p>Members:</p><ul><li>0: Unknown</li><li>1: Sectional</li><li>2: OnePieceDoor</li><li>3: RollUp</li><li>4: SideOpeningDoor</li><li>5: DoubleLeaf</li><li>6: Sliding</li><li>7: Barrier</li><li>8: Wicket</li><li>9: Doors</li><li>10: MultiBox</li><li>11: Industrial</li></ul>
 * @format int32
 */
export type GateKindInternal = 0 | 1 | 2 | 3 | 4 | 5 | 6 | 7 | 8 | 9 | 10 | 11;

/**
 * <p>Members:</p><ul><li>0: Unknown</li><li>1: Tilt</li><li>2: SetDir</li><li>3: SetPos</li><li>4: StepByStep</li><li>5: Calibrate</li><li>6: ElectricStrike</li><li>7: PartialControlMode</li><li>8: DailyMode</li><li>9: LockReporting</li><li>10: SetTiltTime</li><li>11: SetNegativeOutput</li></ul>
 * @format int32
 */
export type GateFeatureTypeInternal =
  | 0
  | 1
  | 2
  | 3
  | 4
  | 5
  | 6
  | 7
  | 8
  | 9
  | 10
  | 11;

/**
 * <p>Members:</p><ul><li>0: Unknown</li><li>1: Stop</li><li>2: Open</li><li>3: Close</li></ul>
 * @format int32
 */
export type GateDirectionInternal = 0 | 1 | 2 | 3;

/**
 * <p>Members:</p><ul><li>0: Unknown</li><li>1: Timeout</li><li>2: WrongPosition</li><li>3: InterruptedByTheUser</li></ul>
 * @format int32
 */
export type GateChannelCalibrateErrorInternal = 0 | 1 | 2 | 3;

/**
 * <p>Members:</p><ul><li>0: Pending</li><li>1: InProgress</li><li>2: Completed</li><li>3: Failed</li></ul>
 * @format int32
 */
export type ExportStatus = 0 | 1 | 2 | 3;

/**
 * <p>Members:</p><ul><li>0: Disconnected</li><li>1: Recovery</li><li>2: Connected</li></ul>
 * @format int32
 */
export type DeviceConnectionState = 0 | 1 | 2;

/**
 * <p>Members:</p><ul><li>1: Monday</li><li>2: Tuesday</li><li>3: Wednesday</li><li>4: Thursday</li><li>5: Friday</li><li>6: Saturday</li><li>7: Sunday</li></ul>
 * @format int32
 */
export type DayOfWeekInternal = 1 | 2 | 3 | 4 | 5 | 6 | 7;

/**
 * <p>Members:</p><ul><li>0: Unknown</li><li>1: Threshold</li><li>2: DynamicPrice</li></ul>
 * @format int32
 */
export type ControlModeInternal = 0 | 1 | 2;

/**
 * <p>Members:</p><ul><li>1: Switch</li><li>2: Blind</li><li>4: Gate</li><li>8: Light</li><li>16: Hvac</li><li>32: Sensor</li><li>64: BinarySensor</li><li>128: GenericInput</li><li>256: Meter</li><li>512: Optimizer</li></ul>
 * @format int32
 */
export type ChannelTypesFlag = 1 | 2 | 4 | 8 | 16 | 32 | 64 | 128 | 256 | 512;

/**
 * <p>Members:</p><ul><li>0: Unknown</li><li>1: Switch</li><li>2: Blind</li><li>3: Gate</li><li>4: Light</li><li>5: Hvac</li><li>6: Sensor</li><li>7: BinarySensor</li><li>8: GenericInput</li><li>9: Meter</li><li>10: Optimizer</li><li>1001: Door</li><li>1002: Fence</li></ul>
 * @format int32
 */
export type ChannelTypeInternal =
  | 0
  | 1
  | 2
  | 3
  | 4
  | 5
  | 6
  | 7
  | 8
  | 9
  | 10
  | 1001
  | 1002;

/**
 * <p>Members:</p><ul><li>0: Unknown</li><li>1: Open</li><li>2: Close</li><li>3: OpenCentral</li><li>4: CloseCentral</li><li>1000: Advanced</li></ul>
 * @format int32
 */
export type BlindSupportedSlotsInternal = 0 | 1 | 2 | 3 | 4 | 1000;

/**
 * <p>Members:</p><ul><li>0: Unknown</li><li>1: Stopped</li><li>2: Stopping</li><li>3: Open</li><li>4: Opening</li><li>5: Closed</li><li>6: Closing</li></ul>
 * @format int32
 */
export type BlindStateDirectionInternal = 0 | 1 | 2 | 3 | 4 | 5 | 6;

/**
 * <p>Members:</p><ul><li>0: Unknown</li><li>1: AutoCalibration</li><li>2: ManualCalibration</li><li>3: SensitivityAOK</li></ul>
 * @format int32
 */
export type BlindFeatureTypeInternal = 0 | 1 | 2 | 3;

/**
 * <p>Members:</p><ul><li>0: Unknown</li><li>1: Stop</li><li>2: Up</li><li>3: Down</li></ul>
 * @format int32
 */
export type BlindDirectionInternal = 0 | 1 | 2 | 3;

/**
 * <p>Members:</p><ul><li>0: Unknown</li><li>1: NoCurrentDetected</li><li>2: CurrentDetected</li><li>3: CurrentOnBothChannelDetected</li><li>4: Timeout</li><li>5: InterruptedByTheUser</li></ul>
 * @format int32
 */
export type BlindChannelCalibrateErrorInternal = 0 | 1 | 2 | 3 | 4 | 5;

/**
 * <p>Members:</p><ul><li>0: Unknown</li><li>1: Input</li><li>2: Movement</li><li>3: Flood</li><li>4: ReedSwitch</li></ul>
 * @format int32
 */
export type BinarySensorTypeInternal = 0 | 1 | 2 | 3 | 4;

/**
 * <p>Members:</p><ul><li>0: Undefined</li><li>1: GoogleHome</li></ul>
 * @format int32
 */
export type AssistantType = 0 | 1;

/**
 * <p>Members:</p><ul><li>0: Unknown</li><li>1: OneHundredAmps</li><li>2: TwoHundredsAmps</li><li>3: FourHundredsAmps</li><li>4: OneThousandAmps</li></ul>
 * @format int32
 */
export type AmpTransformersInternal = 0 | 1 | 2 | 3 | 4;

/**
 * <p>Members:</p><ul><li>0: Unknown</li><li>1: VoltageAvr</li><li>2: VoltageMin</li><li>3: VoltageMax</li><li>4: ForwardActiveEnergy</li><li>5: ReverseActiveEnergy</li><li>6: ForwardReactiveEnergy</li><li>7: ReverseReactiveEnergy</li><li>8: VectorBalancedActiveEnergyIncoming</li><li>9: PredictionForwardActiveEnergy</li><li>10: PredictionVectorBalancedActiveEnergy</li><li>11: DynamicEnergyMarketPrice</li><li>12: VectorBalancedActiveEnergyOutgoing</li><li>700: Price</li><li>701: Cost</li><li>702: VectorBalancedCost</li></ul>
 * @format int32
 */
export type AggregateVectorParameterTypeInternal =
  | 0
  | 1
  | 2
  | 3
  | 4
  | 5
  | 6
  | 7
  | 8
  | 9
  | 10
  | 11
  | 12
  | 700
  | 701
  | 702;

export interface ActionBindingRequestItem {
  /** <p>Members:</p><ul><li>0: SingleClick</li><li>1: DoubleClick</li></ul> */
  inputTrigger: InputTriggerInternal;
  isDefault: boolean;
  destination?: BindingAddress;
}

export interface ActionConfigResponse {
  isDefaultAction: boolean;
  /** <p>Members:</p><ul><li>0: SingleClick</li><li>1: DoubleClick</li></ul> */
  inputTrigger: InputTriggerInternal;
  destination?: BindingAddress;
}

export interface AggregateVectorMeasurementRequestItem {
  /** <p>Members:</p><ul><li>0: Unknown</li><li>1: VoltageAvr</li><li>2: VoltageMin</li><li>3: VoltageMax</li><li>4: ForwardActiveEnergy</li><li>5: ReverseActiveEnergy</li><li>6: ForwardReactiveEnergy</li><li>7: ReverseReactiveEnergy</li><li>8: VectorBalancedActiveEnergyIncoming</li><li>9: PredictionForwardActiveEnergy</li><li>10: PredictionVectorBalancedActiveEnergy</li><li>11: DynamicEnergyMarketPrice</li><li>12: VectorBalancedActiveEnergyOutgoing</li><li>700: Price</li><li>701: Cost</li><li>702: VectorBalancedCost</li></ul> */
  type: AggregateVectorParameterTypeInternal;
  /** <p>Members:</p><ul><li>0: Unknown</li><li>1: None</li><li>2: InHours</li><li>3: InDays</li><li>4: InMonths</li><li>5: InYears</li></ul> */
  range: MeasurementDataRangeInternal;
}

export interface AggregateVectorMeasurementResponseItem {
  /** <p>Members:</p><ul><li>0: Unknown</li><li>1: VoltageAvr</li><li>2: VoltageMin</li><li>3: VoltageMax</li><li>4: ForwardActiveEnergy</li><li>5: ReverseActiveEnergy</li><li>6: ForwardReactiveEnergy</li><li>7: ReverseReactiveEnergy</li><li>8: VectorBalancedActiveEnergyIncoming</li><li>9: PredictionForwardActiveEnergy</li><li>10: PredictionVectorBalancedActiveEnergy</li><li>11: DynamicEnergyMarketPrice</li><li>12: VectorBalancedActiveEnergyOutgoing</li><li>700: Price</li><li>701: Cost</li><li>702: VectorBalancedCost</li></ul> */
  type: AggregateVectorParameterTypeInternal;
  /** <p>Members:</p><ul><li>0: Unknown</li><li>1: None</li><li>2: InHours</li><li>3: InDays</li><li>4: InMonths</li><li>5: InYears</li></ul> */
  range: MeasurementDataRangeInternal;
  /** @format int32 */
  index: number;
  values: number[];
  /** <p>Members:</p><ul><li>0: None</li><li>1: Custom</li><li>2: TauronG11</li><li>3: TauronG12</li><li>4: TauronG12W</li><li>5: TauronG13</li><li>6: EneaG11</li><li>7: EneaG12</li><li>8: EneaG12W</li><li>9: PgeG11</li><li>10: PgeG12</li><li>11: PgeG12W</li><li>12: PgeG12As</li><li>13: EonG11</li><li>14: EonG12</li><li>15: EonG12W</li><li>16: EonG12As</li><li>17: EnergaG11</li><li>18: EnergaG12</li><li>19: EnergaG12W</li><li>20: EnergaG12R</li><li>21: TauronDynamic</li><li>22: EneaDynamic</li><li>23: PgeDynamic</li><li>24: EonDynamic</li><li>25: EnergaDynamic</li><li>26: TauronG13S</li></ul> */
  tariff?: TariffKindInternal;
}

export interface AggregatedVectorMeasurementsClusterIntegrationResponse {
  /** @format date-time */
  from: string;
  /** @format date-time */
  to: string;
  aggregationSummary: AggregationSummary;
}

export interface AggregationSummary {
  purposes: {
    Unknown?: PurposeSummary;
    Main?: PurposeSummary;
    Pv?: PurposeSummary;
    EnergyStorage?: PurposeSummary;
    Consumption?: PurposeSummary;
  };
}

export interface AlertConfigRequest {
  barrierAlertEnabled: boolean;
  misdirectionAlertEnabled: boolean;
  externalSourceTriggeredAlertEnabled: boolean;
  /** @format int32 */
  openedIntervalToNotifyInMs?: number | null;
}

export interface AllBrokerBindingsResponse {
  items: BrokerBindingModel[];
  hasNext: boolean;
}

export type BaseBatchRequestItem = BaseBaseBatchRequestItem &
  (
    | BaseBaseBatchRequestItemTypeMapping<
        "BaseBatchRequestItem",
        BaseBatchRequestItem
      >
    | BaseBaseBatchRequestItemTypeMapping<
        "BatchLightToggleOnOffRequest",
        BatchLightToggleOnOffRequest
      >
    | BaseBaseBatchRequestItemTypeMapping<
        "BatchLightSetTemperatureRequest",
        BatchLightSetTemperatureRequest
      >
    | BaseBaseBatchRequestItemTypeMapping<
        "BatchLightSetRgbRequest",
        BatchLightSetRgbRequest
      >
    | BaseBaseBatchRequestItemTypeMapping<
        "BatchLightSetBrightnessRequest",
        BatchLightSetBrightnessRequest
      >
    | BaseBaseBatchRequestItemTypeMapping<
        "BatchLightSetOnTimeRequest",
        BatchLightSetOnTimeRequest
      >
    | BaseBaseBatchRequestItemTypeMapping<
        "BatchSwitchSetOnTimeRequest",
        BatchSwitchSetOnTimeRequest
      >
    | BaseBaseBatchRequestItemTypeMapping<
        "BatchSwitchToggleOnOffRequest",
        BatchSwitchToggleOnOffRequest
      >
    | BaseBaseBatchRequestItemTypeMapping<
        "BatchBlindSetPositionRequest",
        BatchBlindSetPositionRequest
      >
    | BaseBaseBatchRequestItemTypeMapping<
        "BatchBlindSetDirectionRequest",
        BatchBlindSetDirectionRequest
      >
    | BaseBaseBatchRequestItemTypeMapping<
        "BatchGateStepByStepRequest",
        BatchGateStepByStepRequest
      >
    | BaseBaseBatchRequestItemTypeMapping<
        "BatchGateTiltRequest",
        BatchGateTiltRequest
      >
    | BaseBaseBatchRequestItemTypeMapping<
        "BatchGateSetPositionRequest",
        BatchGateSetPositionRequest
      >
    | BaseBaseBatchRequestItemTypeMapping<
        "BatchGateSetDailyModeRequest",
        BatchGateSetDailyModeRequest
      >
    | BaseBaseBatchRequestItemTypeMapping<
        "BatchGateSetPartialControlModeRequest",
        BatchGateSetPartialControlModeRequest
      >
    | BaseBaseBatchRequestItemTypeMapping<
        "BatchGateSetDirectionRequest",
        BatchGateSetDirectionRequest
      >
  );

export interface BaseCreateTriggerRequest {
  /** @format uuid */
  triggerId: string;
  actions: TriggerActionRequest[];
  stateConditions: TriggerStateConditionRequest[];
  /** <p>Members:</p><ul><li>0: Undefined</li><li>1: Continue</li><li>2: StopExecution</li></ul> */
  onFailureMode: TriggerOnFailureMode;
}

export interface BaseRequest {
  /** @format uuid */
  deviceId: string;
}

export type BatchBlindSetDirectionRequest = BaseBaseBatchRequestItem & {
  /** <p>Members:</p><ul><li>0: Unknown</li><li>1: Stop</li><li>2: Up</li><li>3: Down</li></ul> */
  direction: BlindDirectionInternal;
};

export type BatchBlindSetPositionRequest = BaseBaseBatchRequestItem & {
  /** @format int32 */
  position: number;
};

export interface BatchControlRequest {
  controls: (
    | ({
        $type: "BaseBatchRequestItem";
      } & BaseBatchRequestItem)
    | ({
        $type: "BatchLightToggleOnOffRequest";
      } & BatchLightToggleOnOffRequest)
    | ({
        $type: "BatchLightSetTemperatureRequest";
      } & BatchLightSetTemperatureRequest)
    | ({
        $type: "BatchLightSetRgbRequest";
      } & BatchLightSetRgbRequest)
    | ({
        $type: "BatchLightSetBrightnessRequest";
      } & BatchLightSetBrightnessRequest)
    | ({
        $type: "BatchLightSetOnTimeRequest";
      } & BatchLightSetOnTimeRequest)
    | ({
        $type: "BatchSwitchSetOnTimeRequest";
      } & BatchSwitchSetOnTimeRequest)
    | ({
        $type: "BatchSwitchToggleOnOffRequest";
      } & BatchSwitchToggleOnOffRequest)
    | ({
        $type: "BatchBlindSetPositionRequest";
      } & BatchBlindSetPositionRequest)
    | ({
        $type: "BatchBlindSetDirectionRequest";
      } & BatchBlindSetDirectionRequest)
    | ({
        $type: "BatchGateStepByStepRequest";
      } & BatchGateStepByStepRequest)
    | ({
        $type: "BatchGateTiltRequest";
      } & BatchGateTiltRequest)
    | ({
        $type: "BatchGateSetPositionRequest";
      } & BatchGateSetPositionRequest)
    | ({
        $type: "BatchGateSetDailyModeRequest";
      } & BatchGateSetDailyModeRequest)
    | ({
        $type: "BatchGateSetPartialControlModeRequest";
      } & BatchGateSetPartialControlModeRequest)
    | ({
        $type: "BatchGateSetDirectionRequest";
      } & BatchGateSetDirectionRequest)
  )[];
}

export type BatchGateSetDailyModeRequest = BaseBaseBatchRequestItem & {
  value: boolean;
};

export type BatchGateSetDirectionRequest = BaseBaseBatchRequestItem & {
  /** <p>Members:</p><ul><li>0: Unknown</li><li>1: Stop</li><li>2: Open</li><li>3: Close</li></ul> */
  direction: GateDirectionInternal;
};

export type BatchGateSetPartialControlModeRequest = BaseBaseBatchRequestItem & {
  value: boolean;
};

export type BatchGateSetPositionRequest = BaseBaseBatchRequestItem & {
  /** @format int32 */
  position: number;
};

export type BatchGateStepByStepRequest = BaseBaseBatchRequestItem;

export type BatchGateTiltRequest = BaseBaseBatchRequestItem;

export type BatchLightSetBrightnessRequest = BaseBaseBatchRequestItem & {
  /** @format int32 */
  brightness: number;
};

export type BatchLightSetOnTimeRequest = BaseBaseBatchRequestItem & {
  /** @format int32 */
  timeInMilliseconds: number;
};

export type BatchLightSetRgbRequest = BaseBaseBatchRequestItem & {
  /** @format int32 */
  r: number;
  /** @format int32 */
  g: number;
  /** @format int32 */
  b: number;
};

export type BatchLightSetTemperatureRequest = BaseBaseBatchRequestItem & {
  /** @format int32 */
  temperature: number;
};

export type BatchLightToggleOnOffRequest = BaseBaseBatchRequestItem & {
  value: boolean;
};

export type BatchSwitchSetOnTimeRequest = BaseBaseBatchRequestItem & {
  /** @format int32 */
  timeInMilliseconds: number;
};

export type BatchSwitchToggleOnOffRequest = BaseBaseBatchRequestItem & {
  value: boolean;
};

export type BinarySensorChannelStateResponse = ChannelStateBaseResponse & {
  /** <p>Members:</p><ul><li>0: Unknown</li><li>1: Input</li><li>2: Movement</li><li>3: Flood</li><li>4: ReedSwitch</li></ul> */
  sensorType: BinarySensorTypeInternal;
  value?: boolean | null;
};

export interface BindingAddress {
  /** @format uuid */
  deviceId: string;
  /** @format uuid */
  channelId: string;
}

export interface BindingItemRequest {
  /** @format uuid */
  inputId: string;
  bindings: (
    | ActionBindingRequestItem
    | BlindActionBindingRequestItem
    | CloudActionBindingRequestItem
    | GateActionBindingRequestItem
    | LightActionBindingRequestItem
    | SwitchActionBindingRequestItem
  )[];
}

export type BlindActionBindingRequestItem = ActionBindingRequestItem & {
  /** @format int32 */
  position?: number | null;
  /** <p>Members:</p><ul><li>0: Unknown</li><li>1: Open</li><li>2: Close</li><li>3: OpenCentral</li><li>4: CloseCentral</li><li>1000: Advanced</li></ul> */
  slot: BlindSupportedSlotsInternal;
};

export type BlindActionConfigResponse = UtilRequiredKeys<
  ActionConfigResponse,
  "isDefaultAction"
> & {
  isDefaultAction: boolean;
  /** @format int32 */
  position?: number | null;
  /** <p>Members:</p><ul><li>0: Unknown</li><li>1: Open</li><li>2: Close</li><li>3: OpenCentral</li><li>4: CloseCentral</li><li>1000: Advanced</li></ul> */
  slot: BlindSupportedSlotsInternal;
};

export interface BlindChannelCalibrateStateResponse {
  started?: boolean | null;
  /** @format int32 */
  progress?: number | null;
  /** @format int32 */
  openingMilliseconds: number;
  /** @format int32 */
  closingMilliseconds: number;
  /** <p>Members:</p><ul><li>0: Unknown</li><li>1: NoCurrentDetected</li><li>2: CurrentDetected</li><li>3: CurrentOnBothChannelDetected</li><li>4: Timeout</li><li>5: InterruptedByTheUser</li></ul> */
  error?: BlindChannelCalibrateErrorInternal;
}

export type BlindChannelStateResponse = ChannelStateBaseResponse & {
  /** @format int32 */
  position?: number | null;
  /** <p>Members:</p><ul><li>0: Unknown</li><li>1: Stopped</li><li>2: Stopping</li><li>3: Open</li><li>4: Opening</li><li>5: Closed</li><li>6: Closing</li></ul> */
  direction: BlindStateDirectionInternal;
  calibrateState: BlindChannelCalibrateStateResponse;
  /** @format int32 */
  sensitivityAOK?: number | null;
  supportedSlots: BlindSupportedSlotsInternal[];
  supportedBlindFeatures: BlindFeatureTypeInternal[];
};

export interface BrokerBindingModel {
  /** @format uuid */
  installationId: string;
  /** @format int32 */
  brokerModelId: number;
  isDisbounded: boolean;
  /** @format date-time */
  disboundedAt?: string | null;
}

export interface BrokerBindingResponse {
  /** @format uuid */
  installationId: string;
  /** @format int32 */
  brokerModelId: number;
  isDisbounded: boolean;
}

export interface BrokerInfoResponse {
  /** @format int32 */
  brokerId: number;
  version: string;
  /** @format int32 */
  installationsCount: number;
}

export type BrokerInstallationFullInfoResponse =
  BrokerInstallationInfoResponse & {
    /** @format int32 */
    brokerId: number;
    timeZone: string;
    /** @format double */
    latitude?: number | null;
    /** @format double */
    longitude?: number | null;
    /** @format date-time */
    mostRecentDeviceRegistration?: string | null;
    /** @format date-time */
    mostRecentDeviceLastConnected?: string | null;
  };

export interface BrokerInstallationInfoResponse {
  /** @format uuid */
  installationId: string;
  name: string;
  /** @format int32 */
  channelsCount: number;
  /** @format int32 */
  triggersCount: number;
  /** @format int32 */
  devicesCount: number;
  /** <p>Members:</p><ul><li>0: Undefined</li><li>1: Lavva</li><li>2: Exalus</li></ul> */
  integrationType: IntegrationType;
  /** @format date-time */
  createdAt?: string | null;
  /** @format uuid */
  ownerId?: string | null;
  installationUsers: string[];
}

export interface BrokerUrlResponse {
  brokerExternalUrl: string;
  brokerMqttHostname: string;
  /** @format int32 */
  brokerMqttPort: number;
  /** @format int32 */
  brokerMqttPortTls: number;
}

export type CalibrateRequest = BaseRequest & {
  /** @format uuid */
  channelId: string;
};

export type ChangeGateQuickControlRequest = BaseRequest & {
  /** @format uuid */
  channelId: string;
  value: boolean;
};

export interface ChannelInfoResponse {
  /** @format uuid */
  channelId: string;
  /** <p>Members:</p><ul><li>0: Unknown</li><li>1: Switch</li><li>2: Blind</li><li>3: Gate</li><li>4: Light</li><li>5: Hvac</li><li>6: Sensor</li><li>7: BinarySensor</li><li>8: GenericInput</li><li>9: Meter</li><li>10: Optimizer</li><li>1001: Door</li><li>1002: Fence</li></ul> */
  channelType: ChannelTypeInternal;
  name?: string | null;
}

export interface ChannelStateBaseResponse {
  /** @format uuid */
  deviceId: string;
  /** @format uuid */
  channelId: string;
  /** <p>Members:</p><ul><li>0: Disconnected</li><li>1: Recovery</li><li>2: Connected</li></ul> */
  deviceConnectionState: DeviceConnectionState;
}

export interface ChannelsResponse {
  /** @format uuid */
  installationId: string;
  channels: (
    | ChannelStateBaseResponse
    | BinarySensorChannelStateResponse
    | BlindChannelStateResponse
    | GenericInputChannelStateResponse
    | HvacChannelFullResponse
    | HvacChannelStateBaseResponse
    | HvacChannelStateResponse
    | LightChannelStateResponse
    | MeasurementChannelStateResponse
    | MeterChannelStateResponse
    | OptimizerChannelStateResponse
    | SensorChannelStateResponse
    | SwitchChannelStateResponse
    | GateChannelStateResponse
  )[];
}

export type CloudActionBindingRequestItem = ActionBindingRequestItem & {
  offSignalActionId?: string | null;
  onSignalActionId?: string | null;
};

export type CloudActionConfigResponse = UtilRequiredKeys<
  ActionConfigResponse,
  "isDefaultAction"
> & {
  isDefaultAction: boolean;
  onSignalActionId?: string | null;
  offSignalActionId?: string | null;
};

export interface CodeWithSchema {
  /** <p>Members:</p><ul><li>0: Undefined</li><li>1: InvitationReceived</li><li>2: InvitationAcceptedByInvitee</li><li>3: InvitationCanceledByCreator</li><li>4: InvitationRejectedByInvitee</li><li>5: InstallationAccessChanged</li><li>6: RemovedFromInstallation</li><li>7: ChannelsAccessRemoved</li><li>8: DeviceRemovedOrFactoryReset</li><li>9: DeviceAdded</li><li>10: ChannelsAdded</li><li>11: ChannelsAccessExpired</li><li>12: UserInstallationExpired</li><li>13: GroupsAccessExpired</li><li>14: ChannelsAccessAdded</li><li>15: GroupAccessAdded</li><li>16: GroupAccessRemoved</li><li>17: PublicGroupAdded</li><li>18: PublicGroupRemoved</li><li>19: PublicGroupChanged</li><li>20: ActionCreated</li><li>21: InstallationPassed</li><li>22: UsesDepleted</li><li>23: ResourceAccessModified</li><li>24: GateAlert</li><li>25: MeterAlert</li><li>26: ResetToDefaults</li><li>27: ActionRemoved</li></ul> */
  code: NotificationCode;
  availableParameters: string[];
}

export interface ComfortConfig {
  /** @format double */
  tempMax: number;
  voltageThreshold: VoltageThreshold[];
  relaysConfig: RelayConfig[];
  /** @format double */
  heaterPowerLimit: number;
  /** @format double */
  tempMin: number;
  tariff: Tariff;
}

export type ConfigureBinarySensorRequest = BaseRequest & {
  /** @format uuid */
  channelId: string;
  /** <p>Members:</p><ul><li>0: Unknown</li><li>1: Input</li><li>2: Movement</li><li>3: Flood</li><li>4: ReedSwitch</li></ul> */
  value: BinarySensorTypeInternal;
};

export type ConnectToNetworkRequest = BaseRequest & {
  ssid: string;
};

export type ConnectToUnknownNetworkRequest = BaseRequest & {
  ssid: string;
  password: string;
};

export interface ConnectToUnknownNetworkRequestBatch {
  deviceIds: string[];
  ssid: string;
  password: string;
}

export interface CoordinatesRequest {
  /** @format double */
  latitude: number;
  /** @format double */
  longitude: number;
}

export interface CorrelationResponse {
  /** <p>Members:</p><ul><li>0: Ok</li><li>1: DeviceOrChannelNotFound</li><li>2: DeviceDisconnected</li><li>3: ContractNotSupported</li></ul> */
  publishStatus: PublishStatus;
  /** @format uuid */
  correlationId: string;
}

export type CreatePriceAndTimeTriggerRequest = BaseCreateTriggerRequest & {
  priceAndTimeCondition: TriggerPriceAndTimeConditionRequest;
};

export type CreateStateTriggerRequest = BaseCreateTriggerRequest;

export type CreateTimeTriggerRequest = BaseCreateTriggerRequest & {
  timeCondition: TriggerTimeConditionRequest;
};

export interface DateTimeRequest {
  /** @format date */
  date: string;
  /**
   * @format time
   * @example "13:45:42.0000000"
   */
  time: string;
}

export type DefaultActionConfigResponse = UtilRequiredKeys<
  ActionConfigResponse,
  "isDefaultAction"
> & {
  isDefaultAction: boolean;
};

export interface DemoNotificationRequest {
  /** @format uuid */
  userId: string;
  /** <p>Members:</p><ul><li>0: Undefined</li><li>1: InvitationReceived</li><li>2: InvitationAcceptedByInvitee</li><li>3: InvitationCanceledByCreator</li><li>4: InvitationRejectedByInvitee</li><li>5: InstallationAccessChanged</li><li>6: RemovedFromInstallation</li><li>7: ChannelsAccessRemoved</li><li>8: DeviceRemovedOrFactoryReset</li><li>9: DeviceAdded</li><li>10: ChannelsAdded</li><li>11: ChannelsAccessExpired</li><li>12: UserInstallationExpired</li><li>13: GroupsAccessExpired</li><li>14: ChannelsAccessAdded</li><li>15: GroupAccessAdded</li><li>16: GroupAccessRemoved</li><li>17: PublicGroupAdded</li><li>18: PublicGroupRemoved</li><li>19: PublicGroupChanged</li><li>20: ActionCreated</li><li>21: InstallationPassed</li><li>22: UsesDepleted</li><li>23: ResourceAccessModified</li><li>24: GateAlert</li><li>25: MeterAlert</li><li>26: ResetToDefaults</li><li>27: ActionRemoved</li></ul> */
  code: NotificationCode;
  /** <p>Members:</p><ul><li>0: Undefined</li><li>1: Subscriptions</li><li>2: Smtp</li><li>3: Push</li><li>4: QueryOnly</li></ul> */
  senderType: NotificationSenderType;
  params: NotificationParamRequestItem[];
}

export interface DependantChannelResponse {
  /** @format uuid */
  channelId: string;
  /** <p>Members:</p><ul><li>0: Unknown</li><li>1: Switch</li><li>2: Blind</li><li>3: Gate</li><li>4: Light</li><li>5: Hvac</li><li>6: Sensor</li><li>7: BinarySensor</li><li>8: GenericInput</li><li>9: Meter</li><li>10: Optimizer</li><li>1001: Door</li><li>1002: Fence</li></ul> */
  channelType: ChannelTypeInternal;
  /** @format int32 */
  index: number;
}

export interface DeviceCredentialsResponse {
  /** @format uuid */
  deviceId: string;
  brokerPassword: string;
  requestTopic: string;
  responseTopic: string;
}

export interface DeviceLog {
  logs: DeviceMessage[];
  /** @format uuid */
  installationId?: string | null;
}

export interface DeviceMessage {
  /** @format int64 */
  timestamp: number;
  message: string;
}

export interface DeviceStateResponse {
  /** @format uuid */
  installationId: string;
  /** @format uuid */
  deviceId: string;
  currentFirmwareVersion: string;
  newestFirmwareVersion: string;
  channelInfos: ChannelInfoResponse[];
  connectedToSsid: string;
  name?: string | null;
  model: string;
}

export interface DeviceWithVersionResponse {
  /** @format uuid */
  deviceId: string;
  macAddress: string;
  model: string;
  currentVersion: string;
  newestVersion: string;
}

export interface DumpInstallationsRequest {
  secret: string;
  /** @format uuid */
  installationId: string;
}

export interface EcoConfig {
  /** @format double */
  tempMax: number;
  voltageThreshold: VoltageThreshold[];
  relaysConfig: RelayConfig[];
}

export interface ErrorResponse {
  errorCode: string;
  description: string;
}

export interface EventingRuleState {
  /** <p>Members:</p><ul><li>0: Unknown</li><li>1: Threshold</li><li>2: DynamicPrice</li></ul> */
  controlMode: ControlModeInternal;
  thresholdEvent?: ThresholdEventState;
  priceEvent?: PriceEventState;
  enabled: boolean;
  action: TargetAction;
}

export interface ExecuteRequest {
  /** @format int32 */
  brokerId: number;
  requestId: string;
  /** @format uuid */
  userId: string;
  installationIds: string[];
  deviceWithExecution: NormalizedDto[];
}

export interface ExportDownloadResult {
  isAvailable: boolean;
  isFailed: boolean;
  errorMessage?: string | null;
  fileStream?: File | null;
  fileName?: string | null;
}

export type FactoryResetRequest = BaseRequest;

export interface FloatValidation {
  /** @format float */
  min: number;
  /** @format float */
  max: number;
  /** @format float */
  step: number;
}

export interface ForceRestartRequest {
  devicesIds: string[];
}

export interface ForceUpdateRequest {
  devicesIds: string[];
}

export interface ForceUpdateResponse {
  responses: ForceUpdateSingleResponse[];
}

export interface ForceUpdateSingleResponse {
  isSuccess: boolean;
  /** <p>Members:</p><ul><li>0: Ok</li><li>1: DeviceOrChannelNotFound</li><li>2: DeviceDisconnected</li><li>3: ContractNotSupported</li></ul> */
  error?: PublishStatus;
}

export interface FullSelfConsumptionConfig {
  /** @format double */
  tempMax: number;
  voltageThreshold: VoltageThreshold[];
  relaysConfig: RelayConfig[];
  /** @format double */
  heaterPowerLimit: number;
  /** @format double */
  tempMin: number;
  /** @format double */
  tempSelfConsumption: number;
  tempMinEnabled: boolean;
  workingHours: WorkingHours;
  tariff?: Tariff;
}

export type GateActionBindingRequestItem = ActionBindingRequestItem & {
  /** @format int32 */
  position?: number | null;
  /** <p>Members:</p><ul><li>0: Unknown</li><li>1: Stop</li><li>2: Open</li><li>3: Close</li></ul> */
  dir?: GateDirectionInternal;
  /** <p>Members:</p><ul><li>0: Unknown</li><li>1: LimitOpen</li><li>2: LimitClose</li><li>3: OpticBarrier</li><li>4: Button</li><li>5: MultiLimitSwitch</li><li>6: DoorDailyFuncButton</li><li>7: LockSensor</li><li>8: LimitCloseOGI</li><li>1000: Advanced</li></ul> */
  slot: GateSupportedSlotsInternal;
};

export type GateActionConfigResponse = UtilRequiredKeys<
  ActionConfigResponse,
  "isDefaultAction"
> & {
  isDefaultAction: boolean;
  /** @format int32 */
  position?: number | null;
  /** <p>Members:</p><ul><li>0: Unknown</li><li>1: Stop</li><li>2: Open</li><li>3: Close</li></ul> */
  dir?: GateDirectionInternal;
  /** <p>Members:</p><ul><li>0: Unknown</li><li>1: LimitOpen</li><li>2: LimitClose</li><li>3: OpticBarrier</li><li>4: Button</li><li>5: MultiLimitSwitch</li><li>6: DoorDailyFuncButton</li><li>7: LockSensor</li><li>8: LimitCloseOGI</li><li>1000: Advanced</li></ul> */
  slot: GateSupportedSlotsInternal;
};

export type GateCalibrateRequest = BaseRequest & {
  /** @format uuid */
  channelId: string;
};

export interface GateChannelAlertConfigResponse {
  barrierAlertEnabled: boolean;
  misdirectionAlertEnabled: boolean;
  externalSourceTriggeredAlertEnabled: boolean;
  /** @format int32 */
  openedIntervalToNotifyInMs?: number | null;
}

export interface GateChannelCalibrateStateResponse {
  started?: boolean | null;
  /** @format int32 */
  progress?: number | null;
  /** @format int32 */
  openingMilliseconds: number;
  /** @format int32 */
  closingMilliseconds: number;
  /** <p>Members:</p><ul><li>0: Unknown</li><li>1: Timeout</li><li>2: WrongPosition</li><li>3: InterruptedByTheUser</li></ul> */
  error?: GateChannelCalibrateErrorInternal;
}

export type GateChannelStateResponse = ChannelStateBaseResponse & {
  /** @format int32 */
  position?: number | null;
  dependantChannels: DependantChannelResponse[];
  /** <p>Members:</p><ul><li>0: Unknown</li><li>1: Stopped</li><li>2: Stopping</li><li>3: Open</li><li>4: Opening</li><li>5: Closed</li><li>6: Closing</li></ul> */
  direction: GateStateDirectionInternal;
  /** <p>Members:</p><ul><li>0: Unknown</li><li>1: RollUp</li><li>2: StepByStep</li></ul> */
  gateMode?: GateModeInternal;
  /** <p>Members:</p><ul><li>0: Unknown</li><li>1: Sectional</li><li>2: OnePieceDoor</li><li>3: RollUp</li><li>4: SideOpeningDoor</li><li>5: DoubleLeaf</li><li>6: Sliding</li><li>7: Barrier</li><li>8: Wicket</li><li>9: Doors</li><li>10: MultiBox</li><li>11: Industrial</li></ul> */
  gateKind?: GateKindInternal;
  supportedGateFeatures: GateFeatureTypeInternal[];
  calibrateState: GateChannelCalibrateStateResponse;
  /** @format int32 */
  sbsSignalTimeInMs?: number | null;
  dailyModeStatus?: boolean | null;
  partialControlModeStatus?: boolean | null;
  /** <p>Members:</p><ul><li>0: Unknown</li><li>1: Locked</li><li>2: DailyModeAndDoorClosed</li><li>3: Opened</li></ul> */
  lockStatus?: GateLockStateInternal;
  /** @format int32 */
  tiltTimeInMs?: number | null;
  /** @format int32 */
  partialSbsTimeInMs?: number | null;
  alertConfig?: GateChannelAlertConfigResponse;
  supportedSlots: GateSupportedSlotsInternal[];
  isNegativeOutput: boolean;
};

export interface GateSetAlertConfigRequest {
  /** @format uuid */
  channelId: string;
  value: AlertConfigRequest;
}

export type GateSetDailyModeStateRequest = BaseRequest & {
  /** @format uuid */
  channelId: string;
  value: boolean;
};

export type GateSetDirectionRequest = BaseRequest & {
  /** @format uuid */
  channelId: string;
  /** <p>Members:</p><ul><li>0: Unknown</li><li>1: Stop</li><li>2: Open</li><li>3: Close</li></ul> */
  direction: GateDirectionInternal;
};

export interface GateSetNegativeOutputRequest {
  /** @format uuid */
  channelId: string;
  value: boolean;
}

export type GateSetPartialControlModeStateRequest = BaseRequest & {
  /** @format uuid */
  channelId: string;
  value: boolean;
};

export type GateSetPartialSbsSignalTimeRequest = BaseRequest & {
  /** @format uuid */
  channelId: string;
  /** @format int32 */
  value?: number | null;
};

export type GateSetPositionRequest = BaseRequest & {
  /** @format uuid */
  channelId: string;
  /** @format int32 */
  position: number;
};

export type GateSetSbsSignalTimeRequest = BaseRequest & {
  /** @format uuid */
  channelId: string;
  /** @format int32 */
  value: number;
};

export type GateSetTiltTimeRequest = BaseRequest & {
  /** @format uuid */
  channelId: string;
  /** @format int32 */
  value?: number | null;
};

export type GateStepByStepRequest = BaseRequest & {
  /** @format uuid */
  channelId: string;
};

export type GateTiltRequest = BaseRequest & {
  /** @format uuid */
  channelId: string;
};

export type GenericDeviceRequest = BaseRequest;

export type GenericInputChannelStateResponse = ChannelStateBaseResponse & {
  /** <p>Members:</p><ul><li>0: Unknown</li><li>1: Monostable</li><li>2: Bistable</li></ul> */
  genericInputType: GenericInputTypeInternal;
  /** <p>Members:</p><ul><li>0: Normal</li><li>1: TwoWay</li></ul> */
  bistableMode?: GenericInputBistableModeInternal;
  /** <p>Members:</p><ul><li>0: Normal</li><li>1: Reversed</li></ul> */
  monostableMode?: GenericInputMonostableModeInternal;
  actionBindings: (
    | DefaultActionConfigResponse
    | BlindActionConfigResponse
    | GateActionConfigResponse
    | SwitchActionConfigResponse
    | CloudActionConfigResponse
    | LightActionConfigResponse
  )[];
  areCloudActionsSupported: boolean;
};

export type GetAggregateMeasurementsRequest = BaseRequest & {
  /** @format uuid */
  channelId: string;
  indices: number[];
  aggregateVectorRequestItems: AggregateVectorMeasurementRequestItem[];
  tariffs?: TariffKindInternal[] | null;
};

export interface GetAggregateVectorMeasurementResponse {
  aggregateVectorMeasurements: AggregateVectorMeasurementResponseItem[];
}

export interface GetChannelsWithBrokerRequest {
  installationIds: string[];
  supportedChannels: ChannelTypeInternal[];
}

export type GetCommonMeasurementsRequest = BaseRequest & {
  /** @format uuid */
  channelId: string;
  indices: number[];
  /** <p>Members:</p><ul><li>0: Unknown</li><li>1: Meter</li><li>2: Optimizer</li></ul> */
  kind: MeasurementChannelKind;
  advancedCommonMeasurements: boolean;
  /** <p>Members:</p><ul><li>0: None</li><li>1: Total</li><li>2: Weekly</li><li>4: Monthly</li><li>8: Daily</li></ul> */
  periods: PeriodWeeklyPeriod;
};

export interface GetCurrentMeasurementResponse {
  scalarMeasurements: ScalarMeasurementResponseItem[];
  vectorMeasurements: VectorMeasurementResponseItem[];
}

export type GetCurrentMeasurementsRequest =
  GetCurrentMeasurementsRequestBase & {
    /** @format uuid */
    deviceId: string;
  };

export interface GetCurrentMeasurementsRequestBase {
  /** @format uuid */
  channelId: string;
  indices: number[];
  vectorParameterTypes: number[];
  scalarParameterTypes: number[];
  /** <p>Members:</p><ul><li>0: Unknown</li><li>1: Meter</li><li>2: Optimizer</li></ul> */
  kind: MeasurementChannelKind;
}

export interface GetMetersDataRequest {
  meters: MeterWithInstallation[];
  /** @format date-time */
  from: string;
  /** @format date-time */
  to: string;
  /** <p>Members:</p><ul><li>0: Unknown</li><li>1: None</li><li>2: InHours</li><li>3: InDays</li><li>4: InMonths</li><li>5: InYears</li></ul> */
  range: MeasurementDataRangeInternal;
}

export type GetPersistedAggregateMeasurementsRequest = BaseRequest & {
  /** @format uuid */
  channelId: string;
  indices: number[];
  /** @format date-time */
  from: string;
  /** @format date-time */
  to: string;
  aggregateVectorRequestItems: AggregateVectorMeasurementRequestItem[];
  tariffs?: TariffKindInternal[] | null;
};

export interface GetSingleMeterDataRequest {
  /** @format uuid */
  meterId: string;
  /** @format uuid */
  installationId: string;
  /** @format date-time */
  from: string;
  /** @format date-time */
  to: string;
  /** <p>Members:</p><ul><li>0: Unknown</li><li>1: None</li><li>2: InHours</li><li>3: InDays</li><li>4: InMonths</li><li>5: InYears</li></ul> */
  range: MeasurementDataRangeInternal;
}

export type GetWifiNetworksRequest = BaseRequest;

export interface HardResetConfigurationChecksumRequest {
  /** @format uuid */
  deviceId: string;
  resetDeviceChecksum: boolean;
  resetChannelsChecksum: boolean;
}

export interface HourPriceResponse {
  /** @format int32 */
  hour: number;
  /** @format double */
  price: number;
}

export interface HoursRange {
  /** @format int32 */
  from: number;
  /** @format int32 */
  to: number;
  /** <p>Members:</p><ul><li>0: Unknown</li><li>1: Summer</li><li>2: Winter</li><li>3: All</li></ul> */
  timeZoneKind: TimeZoneKindInternal;
}

export type HttpValidationProblemDetails = ProblemDetails & {
  errors: Record<string, string[]>;
  [key: string]: any;
};

export interface HvacChannelConstantTargetTemperaturesSettingsResponse {
  /** @format float */
  day?: number | null;
  /** @format float */
  night?: number | null;
  /** @format float */
  manual?: number | null;
  /** @format float */
  holiday?: number | null;
  /** @format float */
  party?: number | null;
}

export interface HvacChannelConstantTimeSpansSettingsResponse {
  /** @format int32 */
  holidayInDays?: number | null;
  /** @format int32 */
  partyInHours?: number | null;
}

export type HvacChannelFullResponse = HvacChannelStateResponse & {
  timeZone?: string | null;
  /** @format float */
  hysteresis?: number | null;
  heatingSettings: HvacChannelWorkingModeSettingsResponse;
  collingSettings: HvacChannelWorkingModeSettingsResponse;
  screenSaverSettings: HvacChannelScreenSaverSettingsResponse;
};

export interface HvacChannelPredefinedTemperaturesSettingsResponse {
  /** @format float */
  t0?: number | null;
  /** @format float */
  t1?: number | null;
  /** @format float */
  t2?: number | null;
  /** @format float */
  t3?: number | null;
}

export interface HvacChannelScreenSaverSettingsResponse {
  temperatureEnable?: boolean | null;
  timeEnable?: boolean | null;
  modeEnable?: boolean | null;
  /** @format int32 */
  periodInSeconds?: number | null;
}

export type HvacChannelStateBaseResponse = ChannelStateBaseResponse & {
  /** <p>Members:</p><ul><li>0: Unknown</li><li>1: Celsius</li><li>2: Fahrenheit</li></ul> */
  temperatureUnit: TemperatureUnitTypeInternal;
  /** <p>Members:</p><ul><li>0: Unknown</li><li>1: Heating</li><li>2: Cooling</li></ul> */
  workingMode: WorkingModeTypeInternal;
  /** @format float */
  sensorTemperature?: number | null;
  /** @format float */
  sensorFloorTemperature?: number | null;
  /** @format int32 */
  sensorHumidity?: number | null;
  /** @format float */
  targetTemperatureInCurrentRegulatorMode?: number | null;
  /** <p>Members:</p><ul><li>0: Unknown</li><li>1: Off</li><li>2: Day</li><li>3: Night</li><li>4: Manual</li><li>5: Holiday</li><li>6: Party</li><li>7: Hometimetable</li><li>8: Outsidehometimetable</li><li>9: Holidaytimetable</li><li>10: Antifreezetimetable</li></ul> */
  regulatorModeInCurrentWorkingMode: RegulatorModeTypeInternal;
};

export type HvacChannelStateResponse = HvacChannelStateBaseResponse & {
  /** @format uuid */
  installationId: string;
};

export interface HvacChannelTimetableHourRangeItemRequest {
  /** @format int32 */
  hourFrom: number;
  /** @format int32 */
  hourTo: number;
  /** <p>Members:</p><ul><li>0: T0</li><li>1: T1</li><li>2: T2</li><li>3: T3</li></ul> */
  referenceTemperature: PredefinedTemperatureReferenceTypeInternal;
}

export interface HvacChannelTimetableResponse {
  /** <p>Members:</p><ul><li>1: EveryDay</li><li>2: WorkWeek</li><li>3: Custom</li></ul> */
  repeatType: HvacChannelTimetableRepeatType;
  weekTimetable: HvacChannelTimetableWeekRequest[];
}

export interface HvacChannelTimetableWeekRequest {
  /** <p>Members:</p><ul><li>1: Monday</li><li>2: Tuesday</li><li>3: Wednesday</li><li>4: Thursday</li><li>5: Friday</li><li>6: Saturday</li><li>7: Sunday</li></ul> */
  day: DayOfWeekInternal;
  hourRanges: HvacChannelTimetableHourRangeItemRequest[];
}

export interface HvacChannelWorkingModeSettingsResponse {
  /** @format float */
  floorMaximumTemperature?: number | null;
  constantTargetTemperatures: HvacChannelConstantTargetTemperaturesSettingsResponse;
  constantTimeSpans: HvacChannelConstantTimeSpansSettingsResponse;
  predefinedTemperatures: HvacChannelPredefinedTemperaturesSettingsResponse;
  homeTimetable: HvacChannelTimetableResponse;
  outsideHomeTimetable: HvacChannelTimetableResponse;
  holidayTimetable: HvacChannelTimetableResponse;
  antiFreezeTimetable: HvacChannelTimetableResponse;
  /** <p>Members:</p><ul><li>0: Unknown</li><li>1: Off</li><li>2: Day</li><li>3: Night</li><li>4: Manual</li><li>5: Holiday</li><li>6: Party</li><li>7: Hometimetable</li><li>8: Outsidehometimetable</li><li>9: Holidaytimetable</li><li>10: Antifreezetimetable</li></ul> */
  regulatorMode: RegulatorModeTypeInternal;
}

export interface InstallationCoordinatesResponse {
  /** @format double */
  latitude: number;
  /** @format double */
  longitude: number;
}

export interface InstallationDeviceVersionsResponse {
  /** @format uuid */
  installationId: string;
  devices: DeviceWithVersionResponse[];
  binding?: BrokerBindingResponse;
}

export interface InstallationModelResponse {
  /** @format uuid */
  installationId: string;
  timeZone: string;
  coordinates?: InstallationCoordinatesResponse;
}

export interface IntValidation {
  /** @format int32 */
  min: number;
  /** @format int32 */
  max: number;
  /** @format int32 */
  step: number;
}

export interface LavvaMigrationResponse {
  /** @format uuid */
  id: string;
  migrationName: string;
  httpRoute: string;
  /** @format date-time */
  createdAt: string;
}

export type LightActionBindingRequestItem = ActionBindingRequestItem & {
  /** @format int32 */
  setOnTimeValue?: number | null;
  /** @format int32 */
  r?: number | null;
  /** @format int32 */
  g?: number | null;
  /** @format int32 */
  b?: number | null;
  /** @format int32 */
  brightness?: number | null;
  /** @format int32 */
  temperature?: number | null;
  /** <p>Members:</p><ul><li>0: Unknown</li><li>1: Toggle</li><li>1000: Advanced</li></ul> */
  slot: LightSupportedSlotsInternal;
};

export type LightActionConfigResponse = UtilRequiredKeys<
  ActionConfigResponse,
  "isDefaultAction"
> & {
  isDefaultAction: boolean;
  /** @format int32 */
  r?: number | null;
  /** @format int32 */
  g?: number | null;
  /** @format int32 */
  b?: number | null;
  /** @format int32 */
  brightness?: number | null;
  /** @format int32 */
  temperature?: number | null;
  /** @format int32 */
  setOnTimeValue?: number | null;
  /** <p>Members:</p><ul><li>0: Unknown</li><li>1: Toggle</li><li>1000: Advanced</li></ul> */
  slot: LightSupportedSlotsInternal;
};

export interface LightChannelColorStateResponse {
  /** @format int32 */
  r: number;
  /** @format int32 */
  g: number;
  /** @format int32 */
  b: number;
}

export type LightChannelStateResponse = ChannelStateBaseResponse & {
  supportedModes: LightModeTypeInternal[];
  /** <p>Members:</p><ul><li>0: Unknown</li><li>1: Off</li><li>2: On</li></ul> */
  toggleValue: LightToggleValueInternal;
  /** @format int32 */
  brightness: number;
  /** @format int32 */
  temperature: number;
  color?: LightChannelColorStateResponse;
  /** <p>Members:</p><ul><li>0: AlwaysOff</li><li>1: AlwaysOn</li><li>2: KeepState</li></ul> */
  supplyReturnBehavior: SupplyReturnBehaviorInternal;
  supportedSlots: LightSupportedSlotsInternal[];
};

export type LightToggleOnOffRequest = BaseRequest & {
  /** @format uuid */
  channelId: string;
  value: boolean;
};

export type ManuallyCalibrateRequest = BaseRequest & {
  /** @format uuid */
  channelId: string;
  /** @format int32 */
  openingMs: number;
  /** @format int32 */
  closingMs: number;
};

export interface MeasuredBy {
  /** @format uuid */
  meterChannelId: string;
  /** @format int32 */
  phase: number;
}

export interface MeasuredChannelResponse {
  /** @format uuid */
  channelId: string;
  /** @format int32 */
  phase: number;
}

export type MeasurementChannelStateResponse = ChannelStateBaseResponse & {
  supportedVectorParameters: number[];
  supportedScalarParameters: number[];
  supportedAggregateVectorParameters: number[];
};

export type MeterChannelStateResponse = MeasurementChannelStateResponse & {
  /** <p>Members:</p><ul><li>0: Unknown</li><li>1: Internal</li><li>2: Standalone</li><li>3: BudgetPlug</li></ul> */
  meterType: MeterTypeInternal;
  /** @format int32 */
  originYear: number;
  measuredChannels: MeasuredChannelResponse[];
  /** <p>Members:</p><ul><li>0: Unknown</li><li>1: Main</li><li>2: Pv</li><li>3: EnergyStorage</li><li>4: Consumption</li></ul> */
  meterPurpose: MeterPurposeInternal;
  /** <p>Members:</p><ul><li>0: Unknown</li><li>1: OneHundredAmps</li><li>2: TwoHundredsAmps</li><li>3: FourHundredsAmps</li><li>4: OneThousandAmps</li></ul> */
  ampTransformers: AmpTransformersInternal;
  /** @format uuid */
  parentMeterId?: string | null;
  tariff?: MeterTariffConfig;
  eventing?: MeterEventingState;
};

export interface MeterDefinition {
  /** @format uuid */
  id: string;
  macAddress: string;
  syncDate: string;
  timeZone: string;
  /** <p>Members:</p><ul><li>0: Unknown</li><li>1: Internal</li><li>2: Standalone</li><li>3: BudgetPlug</li></ul> */
  meterType: MeterTypeInternal;
}

export interface MeterEventingState {
  rules: EventingRuleState[];
  supportedRelaysIndices: number[];
  supportedSourceThresholds: SourceThresholdInternal[];
  supportedControlModes: ControlModeInternal[];
}

export interface MeterHoursRange {
  /** @format int32 */
  from: number;
  /** @format int32 */
  to: number;
  /** <p>Members:</p><ul><li>0: Unknown</li><li>1: Summer</li><li>2: Winter</li><li>3: All</li></ul> */
  timeZoneKind: TimeZoneKindInternal;
  /** @format int32 */
  pricingTier: number;
}

export interface MeterTariffConfig {
  hoursRanges: MeterHoursRange[];
  wholeWeekendCheaper: boolean;
  wholeHolidaysCheaper: boolean;
  ignoreSummerTimeChanges: boolean;
  /** <p>Members:</p><ul><li>0: None</li><li>1: Custom</li><li>2: TauronG11</li><li>3: TauronG12</li><li>4: TauronG12W</li><li>5: TauronG13</li><li>6: EneaG11</li><li>7: EneaG12</li><li>8: EneaG12W</li><li>9: PgeG11</li><li>10: PgeG12</li><li>11: PgeG12W</li><li>12: PgeG12As</li><li>13: EonG11</li><li>14: EonG12</li><li>15: EonG12W</li><li>16: EonG12As</li><li>17: EnergaG11</li><li>18: EnergaG12</li><li>19: EnergaG12W</li><li>20: EnergaG12R</li><li>21: TauronDynamic</li><li>22: EneaDynamic</li><li>23: PgeDynamic</li><li>24: EonDynamic</li><li>25: EnergaDynamic</li><li>26: TauronG13S</li></ul> */
  kind: TariffKindInternal;
}

export interface MeterWithInstallation {
  /** @format uuid */
  meterId: string;
  /** @format uuid */
  installationId: string;
}

export interface MetricsRule {
  /** @format uuid */
  ruleId: string;
  /** @format uuid */
  installationId?: string | null;
  /** @format int32 */
  metricsIntervalInSeconds: number;
  /** <p>Members:</p><ul><li>0: Unknown</li><li>1: Debug</li><li>2: Information</li><li>3: Warning</li><li>4: Critical</li><li>5: None</li></ul> */
  levelType: MetricsLevelTypeInternal;
}

export interface MigrateAddMeterGroupsRequest {
  installationIds: string[];
}

export interface MigrateAddMissingFavsGroupsRequest {
  installationIds: string[];
}

export interface MigrateGenericInputNamesRequest {
  installationIds: string[];
}

export interface MigrateSwitchFromGateOriginatedChannelsRequest {
  installationIds: string[];
}

export interface MultiParameterAggregatedItem {
  /** @format date-time */
  dateAtUtc: string;
  measurements: any;
}

export interface NormalizedDto {
  deviceId: string;
  command: string;
  params: Record<string, any>;
}

export interface NotificationMapUpdateRequest {
  /** @format uuid */
  id: string;
  codes: NotificationCode[];
}

export interface NotificationParamRequestItem {
  name: string;
  value?: string | null;
}

export interface NotificationTypesAndSenders {
  senders: NotificationSenderType[];
  codes: CodeWithSchema[];
}

export type OptimizerChannelStateResponse = MeasurementChannelStateResponse & {
  /** <p>Members:</p><ul><li>0: Unknown</li><li>1: TestMode</li><li>2: Eco</li><li>3: Comfort</li><li>4: FullSelfConsumption</li><li>5: SelfConsumptionWithPowerLimit</li><li>6: SelfConsumptionWithRelays</li></ul> */
  mode: OptimizerModeInternal;
  configValidation: OptimizerConfigValidation;
  comfort: ComfortConfig;
  eco: EcoConfig;
  fullSelfConsumption: FullSelfConsumptionConfig;
  workingHours: WorkingHours;
  selfConsumptionWithRelays: SelfConsumptionWithRelaysConfig;
  selfConsumptionWithPowerLimit: SelfConsumptionWithPowerLimitConfig;
};

export interface OptimizerConfigValidation {
  relay: RelayValidation;
  voltageThreshold: FloatValidation;
  tempMax: FloatValidation;
  tempMin: FloatValidation;
  tempSelfConsumptionMin: FloatValidation;
  heaterPowerLimit: FloatValidation;
  powerLimit: FloatValidation;
}

export interface OrderResult {
  /** @format uuid */
  exportId: string;
  /** <p>Members:</p><ul><li>0: Pending</li><li>1: InProgress</li><li>2: Completed</li><li>3: Failed</li></ul> */
  status: ExportStatus;
  error?: string | null;
}

export interface PriceEventState {
  /** @format float */
  minPrice?: number | null;
  /** @format float */
  maxPrice?: number | null;
  /**
   * for e.g. 01.5:20:24 - 1 day 5 hours 20 minutes 24 seconds
   * @example "00:00:00"
   */
  startAt?: string | null;
  /**
   * for e.g. 01.5:20:24 - 1 day 5 hours 20 minutes 24 seconds
   * @example "00:00:00"
   */
  endAt?: string | null;
  /** @format int32 */
  cheapestPeriods?: number | null;
}

export interface PriceWithDateResponse {
  /** @format date */
  date: string;
  prices: HourPriceResponse[];
}

export interface ProblemDetails {
  type?: string | null;
  title?: string | null;
  /** @format int32 */
  status?: number | null;
  detail?: string | null;
  instance?: string | null;
  [key: string]: any;
}

export interface PublishTestRequest {
  /** @format int32 */
  switchPublishCountPerTick: number;
  /** @format int32 */
  tickRatePerSecond: number;
  /** @format int32 */
  maxDegreeOfParallelism: number;
  secret: string;
}

export interface PurposeSummary {
  total: Record<string, Record<string, number>>;
  items: MultiParameterAggregatedItem[];
}

export interface RebindRandomInstallationsRequest {
  /** @format int32 */
  sourceBrokerId: number;
  /** @format int32 */
  destinationBrokerId: number;
  /** @format int32 */
  count: number;
}

export interface RegisterInstallationRequest {
  /** @format uuid */
  installationId: string;
  name: string;
  timeZone: string;
  coordinates?: CoordinatesRequest;
}

export interface RelayConfig {
  /** @format int32 */
  index: number;
  enabled: boolean;
  /** @format double */
  thresholdValue: number;
  /** @format int32 */
  timeOn: number;
  /** @format int32 */
  timeOff: number;
}

export interface RelayValidation {
  thresholdPercent: FloatValidation;
  thresholdPower: FloatValidation;
  timeOn: IntValidation;
  timeOff: IntValidation;
}

export interface ResetAggregateMeasurementsRequest {
  /** @format uuid */
  channelId: string;
  /** <p>Members:</p><ul><li>0: Unknown</li><li>1: Meter</li><li>2: Optimizer</li></ul> */
  kind: MeasurementChannelKind;
}

export interface ResetConfigurationChecksumRequest {
  /** @format uuid */
  deviceId: string;
  resetDeviceChecksum: boolean;
  resetChannelsChecksum: boolean;
}

export type ResetToDefaultsRequest = BaseRequest;

export type RestartDeviceRequest = BaseRequest;

export interface ScalarMeasurementResponseItem {
  /** @format int32 */
  type: number;
  /** @format float */
  value: number;
}

export interface SecretRequest {
  secret: string;
}

export interface SelectedBucket {
  /** @format int32 */
  from: number;
  /** @format int32 */
  to: number;
}

export interface SelfConsumptionWithPowerLimitConfig {
  /** @format double */
  tempMax: number;
  voltageThreshold: VoltageThreshold[];
  relaysConfig: RelayConfig[];
  /** @format double */
  heaterPowerLimit: number;
  /** @format double */
  tempMin: number;
  /** @format double */
  tempSelfConsumption: number;
  /** @format double */
  powerLimit: number;
  tempMinEnabled: boolean;
  workingHours: WorkingHours;
  tariff?: Tariff;
}

export interface SelfConsumptionWithRelaysConfig {
  relaysConfig: RelayConfig[];
  workingHours: WorkingHours;
}

export type SensorChannelStateResponse = ChannelStateBaseResponse & {
  /** <p>Members:</p><ul><li>0: Unknown</li><li>1: Humidity</li><li>2: Temperature</li><li>3: Wind</li><li>4: Brightness</li><li>5: Pressure</li></ul> */
  sensorType: SensorTypeInternal;
  unit: string;
  /** @format float */
  value?: number | null;
};

export type SetActionBindingsRequest = BaseRequest & {
  bindings: BindingItemRequest[];
};

export interface SetAmpTransformersRequest {
  /** @format uuid */
  channelId: string;
  /** <p>Members:</p><ul><li>0: Unknown</li><li>1: OneHundredAmps</li><li>2: TwoHundredsAmps</li><li>3: FourHundredsAmps</li><li>4: OneThousandAmps</li></ul> */
  value: AmpTransformersInternal;
}

export type SetBrightnessRequest = BaseRequest & {
  /** @format uuid */
  channelId: string;
  /** @format int32 */
  brightness: number;
};

export type SetChannelNameRequest = BaseRequest & {
  /** @format uuid */
  channelId: string;
  name: string;
};

export type SetConstantTargetTemperaturesRequest = BaseRequest & {
  /** @format uuid */
  channelId: string;
  /** <p>Members:</p><ul><li>0: Unknown</li><li>1: Heating</li><li>2: Cooling</li></ul> */
  workingMode: WorkingModeTypeInternal;
  /** @format float */
  day?: number | null;
  /** @format float */
  night?: number | null;
  /** @format float */
  manual?: number | null;
  /** @format float */
  holiday?: number | null;
  /** @format float */
  party?: number | null;
};

export type SetConstantTimeSpansRequest = BaseRequest & {
  /** @format uuid */
  channelId: string;
  /** <p>Members:</p><ul><li>0: Unknown</li><li>1: Heating</li><li>2: Cooling</li></ul> */
  workingMode: WorkingModeTypeInternal;
  /** @format int32 */
  holidayInDays?: number | null;
  /** @format int32 */
  partyInHours?: number | null;
};

export type SetDateTimeWithTimeZoneRequest = BaseRequest & {
  /** @format uuid */
  channelId: string;
  dateTime?: DateTimeRequest;
  timeZone: string;
};

export type SetDeviceNameRequest = BaseRequest & {
  name: string;
};

export type SetDirectionRequest = BaseRequest & {
  /** @format uuid */
  channelId: string;
  /** <p>Members:</p><ul><li>0: Unknown</li><li>1: Stop</li><li>2: Up</li><li>3: Down</li></ul> */
  direction: BlindDirectionInternal;
};

export type SetFloorMaxTemperatureRequest = BaseRequest & {
  /** @format uuid */
  channelId: string;
  /** <p>Members:</p><ul><li>0: Unknown</li><li>1: Heating</li><li>2: Cooling</li></ul> */
  workingMode: WorkingModeTypeInternal;
  /** @format float */
  floorMaxTemperature: number;
};

export type SetHysteresisRequest = BaseRequest & {
  /** @format uuid */
  channelId: string;
  /** @format float */
  hysteresis: number;
};

export interface SetInputTypeItem {
  /** @format uuid */
  channelId: string;
  /** <p>Members:</p><ul><li>0: Unknown</li><li>1: Monostable</li><li>2: Bistable</li></ul> */
  genericInputType: GenericInputTypeInternal;
  /** <p>Members:</p><ul><li>0: Normal</li><li>1: Reversed</li></ul> */
  monostableMode?: GenericInputMonostableModeInternal;
  /** <p>Members:</p><ul><li>0: Normal</li><li>1: TwoWay</li></ul> */
  bistableMode?: GenericInputBistableModeInternal;
}

export type SetInputTypeRequest = BaseRequest & {
  /** @format uuid */
  channelId: string;
  /** <p>Members:</p><ul><li>0: Unknown</li><li>1: Monostable</li><li>2: Bistable</li></ul> */
  genericInputType: GenericInputTypeInternal;
  /** <p>Members:</p><ul><li>0: Normal</li><li>1: Reversed</li></ul> */
  monostableMode?: GenericInputMonostableModeInternal;
  /** <p>Members:</p><ul><li>0: Normal</li><li>1: TwoWay</li></ul> */
  bistableMode?: GenericInputBistableModeInternal;
};

export type SetInputTypesBatchRequest = BaseRequest & {
  items: SetInputTypeItem[];
};

export interface SetInstallationGeolocationRequest {
  coordinates?: CoordinatesRequest;
}

export interface SetInstallationTimeZoneRequest {
  timeZone: string;
}

export interface SetMeterEventingRulesRequest {
  /** @format uuid */
  installationId: string;
  /** @format uuid */
  channelId: string;
  eventingRules: EventingRuleState[];
}

export interface SetMeterParentIdRequest {
  /** @format uuid */
  channelId: string;
  /** @format uuid */
  parentMeterChannelId: string;
}

export interface SetMeterPurposeRequest {
  /** @format uuid */
  channelId: string;
  /** <p>Members:</p><ul><li>0: Unknown</li><li>1: Main</li><li>2: Pv</li><li>3: EnergyStorage</li><li>4: Consumption</li></ul> */
  value: MeterPurposeInternal;
}

export interface SetMeterTariffRequest {
  /** @format uuid */
  channelId: string;
  tariff?: MeterTariffConfig;
}

export type SetOnOffRequest = BaseRequest & {
  /** @format uuid */
  channelId: string;
};

export type SetOnTimeRequest = BaseRequest & {
  /** @format uuid */
  channelId: string;
  /** @format int32 */
  timeInMilliseconds: number;
};

export type SetOptimizerConfigRequest = BaseRequest & {
  /** @format uuid */
  channelId: string;
  eco?: EcoConfig;
  comfort?: ComfortConfig;
  fullSelfConsumption?: FullSelfConsumptionConfig;
  selfConsumptionWithPowerLimit?: SelfConsumptionWithPowerLimitConfig;
  selfConsumptionWithRelays?: SelfConsumptionWithRelaysConfig;
};

export type SetOptimizerModeRequest = BaseRequest & {
  /** @format uuid */
  channelId: string;
  /** <p>Members:</p><ul><li>0: Unknown</li><li>1: TestMode</li><li>2: Eco</li><li>3: Comfort</li><li>4: FullSelfConsumption</li><li>5: SelfConsumptionWithPowerLimit</li><li>6: SelfConsumptionWithRelays</li></ul> */
  mode: OptimizerModeInternal;
};

export type SetOptimizerTestModeLoadRequest = BaseRequest & {
  /** @format uuid */
  channelId: string;
  scr: number[];
};

export type SetPositionRequest = BaseRequest & {
  /** @format uuid */
  channelId: string;
  /** @format int32 */
  position: number;
};

export type SetPredefinedTemperaturesRequest = BaseRequest & {
  /** @format uuid */
  channelId: string;
  /** <p>Members:</p><ul><li>0: Unknown</li><li>1: Heating</li><li>2: Cooling</li></ul> */
  workingMode: WorkingModeTypeInternal;
  /** @format float */
  t0: number;
  /** @format float */
  t1: number;
  /** @format float */
  t2: number;
  /** @format float */
  t3: number;
};

export type SetRegulatorModeRequest = BaseRequest & {
  /** @format uuid */
  channelId: string;
  /** <p>Members:</p><ul><li>0: Unknown</li><li>1: Heating</li><li>2: Cooling</li></ul> */
  workingMode: WorkingModeTypeInternal;
  /** <p>Members:</p><ul><li>0: Unknown</li><li>1: Off</li><li>2: Day</li><li>3: Night</li><li>4: Manual</li><li>5: Holiday</li><li>6: Party</li><li>7: Hometimetable</li><li>8: Outsidehometimetable</li><li>9: Holidaytimetable</li><li>10: Antifreezetimetable</li></ul> */
  regulatorMode: RegulatorModeTypeInternal;
};

export type SetRgbRequest = BaseRequest & {
  /** @format uuid */
  channelId: string;
  /** @format int32 */
  r: number;
  /** @format int32 */
  g: number;
  /** @format int32 */
  b: number;
};

export type SetScreenSaverSettingsRequest = BaseRequest & {
  /** @format uuid */
  channelId: string;
  temperatureEnable?: boolean | null;
  timeEnable?: boolean | null;
  modeEnable?: boolean | null;
  /** @format int32 */
  periodInSeconds?: number | null;
};

export type SetSensitivityRequest = BaseRequest & {
  /** @format uuid */
  channelId: string;
  /** @format int32 */
  sensitivity: number;
};

export type SetSupplyReturnBehaviourRequest = BaseRequest & {
  /** @format uuid */
  channelId: string;
  /** <p>Members:</p><ul><li>0: AlwaysOff</li><li>1: AlwaysOn</li><li>2: KeepState</li></ul> */
  value: SupplyReturnBehaviorInternal;
};

export type SetTemperatureRequest = BaseRequest & {
  /** @format uuid */
  channelId: string;
  /** @format int32 */
  temperature: number;
};

export type SetTemperatureUnitRequest = BaseRequest & {
  /** @format uuid */
  channelId: string;
  /** <p>Members:</p><ul><li>0: Unknown</li><li>1: Celsius</li><li>2: Fahrenheit</li></ul> */
  temperatureUnit: TemperatureUnitTypeInternal;
};

export type SetTimetableTemperaturesRequest = BaseRequest & {
  /** @format uuid */
  channelId: string;
  /** <p>Members:</p><ul><li>0: Unknown</li><li>1: Heating</li><li>2: Cooling</li></ul> */
  workingMode: WorkingModeTypeInternal;
  home: HvacChannelTimetableWeekRequest[];
  outsideHome: HvacChannelTimetableWeekRequest[];
  holiday: HvacChannelTimetableWeekRequest[];
  antiFreeze: HvacChannelTimetableWeekRequest[];
};

export type SetWorkingModeRequest = BaseRequest & {
  /** @format uuid */
  channelId: string;
  /** <p>Members:</p><ul><li>0: Unknown</li><li>1: Heating</li><li>2: Cooling</li></ul> */
  workingMode: WorkingModeTypeInternal;
};

export interface SetWorkloadProtocolVersionRequest {
  secret: string;
  /** @format int32 */
  minimumWorkloadProtocolVersion: number;
  /** @format int32 */
  currentWorkloadProtocolVersion: number;
}

export type SwapInRequest = BaseRequest;

export type SwapOutRequest = BaseRequest & {
  /** @format uuid */
  channelId: string;
};

export type SwitchActionBindingRequestItem = ActionBindingRequestItem & {
  /** @format int32 */
  setOnTimeValue?: number | null;
  /** <p>Members:</p><ul><li>0: Unknown</li><li>1: Toggle</li><li>1000: Advanced</li></ul> */
  slot: SwitchSupportedSlotsInternal;
};

export type SwitchActionConfigResponse = UtilRequiredKeys<
  ActionConfigResponse,
  "isDefaultAction"
> & {
  isDefaultAction: boolean;
  /** @format int32 */
  setOnTimeValue?: number | null;
  /** <p>Members:</p><ul><li>0: Unknown</li><li>1: Toggle</li><li>1000: Advanced</li></ul> */
  slot: SwitchSupportedSlotsInternal;
};

export type SwitchChannelStateResponse = ChannelStateBaseResponse & {
  /** <p>Members:</p><ul><li>0: Unknown</li><li>1: Off</li><li>2: On</li></ul> */
  state: SwitchStateInternal;
  measuredBy: MeasuredBy;
  /** <p>Members:</p><ul><li>0: AlwaysOff</li><li>1: AlwaysOn</li><li>2: KeepState</li></ul> */
  supplyReturnBehavior: SupplyReturnBehaviorInternal;
  supportedSlots: SwitchSupportedSlotsInternal[];
};

export type SwitchToggleOnOffRequest = BaseRequest & {
  /** @format uuid */
  channelId: string;
  value: boolean;
};

export interface SyncOrQueryRequest {
  /** @format int32 */
  brokerId: number;
  requestId: string;
  /** @format uuid */
  userId: string;
  installationIds: string[];
  devicesIds: string[];
}

export interface TargetAction {
  /** @format int32 */
  index: number;
  isDefaultAction: boolean;
  isNotifyAction: boolean;
}

export interface Tariff {
  hoursRanges: HoursRange[];
  wholeWeekendCheaper: boolean;
  wholeHolidaysCheaper: boolean;
  ignoreSummerTimeChanges: boolean;
  /** <p>Members:</p><ul><li>0: None</li><li>1: Custom</li><li>2: TauronG11</li><li>3: TauronG12</li><li>4: TauronG12W</li><li>5: TauronG13</li><li>6: EneaG11</li><li>7: EneaG12</li><li>8: EneaG12W</li><li>9: PgeG11</li><li>10: PgeG12</li><li>11: PgeG12W</li><li>12: PgeG12As</li><li>13: EonG11</li><li>14: EonG12</li><li>15: EonG12W</li><li>16: EonG12As</li><li>17: EnergaG11</li><li>18: EnergaG12</li><li>19: EnergaG12W</li><li>20: EnergaG12R</li><li>21: TauronDynamic</li><li>22: EneaDynamic</li><li>23: PgeDynamic</li><li>24: EonDynamic</li><li>25: EnergaDynamic</li><li>26: TauronG13S</li></ul> */
  kind: TariffKindInternal;
}

export interface ThresholdEventState {
  /** <p>Members:</p><ul><li>0: Unknown</li><li>1: Voltage</li><li>2: Current</li><li>3: ActivePower</li><li>4: BalancedPower</li><li>5: ReactivePower</li><li>6: ApparentPower</li><li>7: PhaseAngle</li><li>8: PowerFactor</li><li>9: Frequency</li></ul> */
  source: SourceThresholdInternal;
  /** @format int32 */
  deadTimeInMs: number;
  /** @format float */
  hysteresis: number;
  /** @format float */
  minValue?: number | null;
  /** @format float */
  maxValue?: number | null;
}

export type ToggleOnOffRequest = BaseRequest & {
  /** @format uuid */
  channelId: string;
};

export interface TriggerActionRequest {
  /** <p>Members:</p><ul><li>1: SetBlindPosition</li><li>2: SetBlindDirection</li><li>3: SetGateStepByStep</li><li>4: SetLightState</li><li>5: SetLightColor</li><li>6: SetLightBrightness</li><li>7: SetLightSetOnTime</li><li>8: SetSwitchState</li><li>9: SetSwitchSetOnTime</li><li>10: DelayInSeconds</li><li>11: GateSetPosition</li><li>12: GateSetDirection</li><li>13: GateTilt</li></ul> */
  actionType: TriggerActionType;
  /** @format uuid */
  id: string;
  /** @format int32 */
  integerValue?: number | null;
  booleanValue?: boolean | null;
  lightColorValue?: TriggerLightColorRequest;
}

export interface TriggerCreateResponse {
  /** @format uuid */
  triggerId: string;
}

export interface TriggerDateTimeRequest {
  /** @format date */
  date: string;
  /**
   * @format time
   * @example "13:45:42.0000000"
   */
  time: string;
}

export type TriggerDateTimeResponse = TriggerDateTimeRequest;

export interface TriggerExecutionActionResultResponse {
  /** <p>Members:</p><ul><li>1: SetBlindPosition</li><li>2: SetBlindDirection</li><li>3: SetGateStepByStep</li><li>4: SetLightState</li><li>5: SetLightColor</li><li>6: SetLightBrightness</li><li>7: SetLightSetOnTime</li><li>8: SetSwitchState</li><li>9: SetSwitchSetOnTime</li><li>10: DelayInSeconds</li><li>11: GateSetPosition</li><li>12: GateSetDirection</li><li>13: GateTilt</li></ul> */
  actionType: TriggerActionType;
  /** @format uuid */
  id: string;
  isSuccessful: boolean;
}

export interface TriggerExecutionInfoResponse {
  executedAt: TriggerDateTimeResponse;
  plannedExecutionAt: TriggerDateTimeResponse;
  isSuccessful: boolean;
  actionsResults?: TriggerExecutionActionResultResponse[] | null;
}

export interface TriggerLightColorRequest {
  /** @format int32 */
  r: number;
  /** @format int32 */
  g: number;
  /** @format int32 */
  b: number;
}

export interface TriggerModelResponse {
  /** @format uuid */
  triggerId: string;
  /** @format uuid */
  installationId: string;
  timeCondition?: TriggerTimeConditionResponse;
  priceAndTimeCondition?: TriggerPriceAndTimeConditionResponse;
  stateConditions: TriggerStateConditionRequest[];
  actions: TriggerActionRequest[];
  isActive: boolean;
  isValid: boolean;
  validationErrors: TriggerValidationErrorModelResponse[];
  createdAt: TriggerDateTimeResponse;
  executionInfo: TriggerExecutionInfoResponse[];
  /** <p>Members:</p><ul><li>0: Undefined</li><li>1: Continue</li><li>2: StopExecution</li></ul> */
  onFailureMode: TriggerOnFailureMode;
}

export interface TriggerNextFireTimeResponse {
  nextFireTime?: TriggerDateTimeResponse;
}

export type TriggerPriceAndTimeConditionRequest =
  TriggerTimeConditionRequestBase & {
    /** @format double */
    priceGreaterThanOrEqual?: number | null;
    /** @format double */
    priceLesserThanOrEqual?: number | null;
    /** @format int32 */
    numberOfCheapestPeriodsInDay?: number | null;
    /** @format int32 */
    betweenHoursFromInclusive?: number | null;
    /** @format int32 */
    betweenHoursToInclusive?: number | null;
    /** <p>Members:</p><ul><li>0: Unknown</li><li>1: Dynamic</li><li>2: G13S</li></ul> */
    subType: PriceTriggerSubType;
    selectedBuckets?: SelectedBucket[] | null;
  };

export type TriggerPriceAndTimeConditionResponse =
  TriggerTimeConditionResponseBase & {
    /** <p>Members:</p><ul><li>0: Unknown</li><li>1: Dynamic</li><li>2: G13S</li></ul> */
    subType: PriceTriggerSubType;
    /** @format double */
    priceGreaterThanOrEqual?: number | null;
    /** @format double */
    priceLesserThanOrEqual?: number | null;
    /** @format int32 */
    numberOfCheapestPeriodsInDay?: number | null;
    /** @format int32 */
    betweenHoursFromInclusive?: number | null;
    /** @format int32 */
    betweenHoursToInclusive?: number | null;
    selectedBuckets?: SelectedBucket[] | null;
  };

export interface TriggerStateConditionRequest {
  /** <p>Members:</p><ul><li>1: BlindDirectionIs</li><li>2: BlindPositionIsGreaterThanOrEqualTo</li><li>3: BlindPositionIsLessThanOrEqualTo</li><li>4: GateDirectionIs</li><li>5: LightStateIs</li><li>6: SwitchStateIs</li><li>7: IsInTimeInterval</li><li>8: GatePositionIsGreaterThanOrEqualTo</li><li>9: GatePositionIsLessThanOrEqualTo</li></ul> */
  conditionType: TriggerConditionType;
  /** @format uuid */
  id: string;
  /** @format int32 */
  integerValue?: number | null;
  booleanValue?: boolean | null;
  timeIntervalValue?: TriggerTimeIntervalRequest;
}

export type TriggerTimeConditionRequest = TriggerTimeConditionRequestBase & {
  atSunrise?: boolean | null;
  /**
   * @format time
   * @example "13:45:42.0000000"
   */
  sunriseAdvance?: string | null;
  /**
   * @format time
   * @example "13:45:42.0000000"
   */
  sunriseDelay?: string | null;
  atSunset?: boolean | null;
  /**
   * @format time
   * @example "13:45:42.0000000"
   */
  sunsetAdvance?: string | null;
  /**
   * @format time
   * @example "13:45:42.0000000"
   */
  sunsetDelay?: string | null;
  /**
   * @format time
   * @example "13:45:42.0000000"
   */
  timeOfDay?: string | null;
};

export interface TriggerTimeConditionRequestBase {
  startAt: TriggerDateTimeRequest | TriggerDateTimeResponse;
  endAt?: TriggerDateTimeRequest | TriggerDateTimeResponse | null;
  /** @format int32 */
  targetExecutionCount?: number | null;
  daysOfWeek?: DayOfWeekInternal[] | null;
  /** <p>Members:</p><ul><li>0: Ignore</li><li>1: Perform</li><li>2: DoNotPerform</li></ul> */
  holidaysHandling: HolidaysHandling;
  everyMonth?: boolean | null;
  everyYear?: boolean | null;
}

export type TriggerTimeConditionResponse = TriggerTimeConditionResponseBase & {
  atSunrise?: boolean | null;
  /**
   * @format time
   * @example "13:45:42.0000000"
   */
  sunriseAdvance?: string | null;
  /**
   * @format time
   * @example "13:45:42.0000000"
   */
  sunriseDelay?: string | null;
  atSunset?: boolean | null;
  /**
   * @format time
   * @example "13:45:42.0000000"
   */
  sunsetAdvance?: string | null;
  /**
   * @format time
   * @example "13:45:42.0000000"
   */
  sunsetDelay?: string | null;
  /**
   * @format time
   * @example "13:45:42.0000000"
   */
  timeOfDay?: string | null;
};

export interface TriggerTimeConditionResponseBase {
  startAt: TriggerDateTimeResponse;
  endAt?: TriggerDateTimeResponse;
  /** @format int32 */
  currentExecutionCount?: number | null;
  /** @format int32 */
  targetExecutionCount?: number | null;
  daysOfWeek?: DayOfWeekInternal[] | null;
  /** <p>Members:</p><ul><li>0: Ignore</li><li>1: Perform</li><li>2: DoNotPerform</li></ul> */
  holidaysHandling: HolidaysHandling;
  everyMonth?: boolean | null;
  everyYear?: boolean | null;
  nextFireTime?: TriggerDateTimeResponse;
}

export interface TriggerTimeIntervalRequest {
  /**
   * @format time
   * @example "13:45:42.0000000"
   */
  timeFrom?: string | null;
  /**
   * @format time
   * @example "13:45:42.0000000"
   */
  timeTo?: string | null;
  daysOfWeek?: DayOfWeekInternal[] | null;
}

export interface TriggerValidationErrorModelResponse {
  /** <p>Members:</p><ul><li>1: StateCondition</li><li>2: Action</li></ul> */
  partType: TriggerValidationPartType;
  /** <p>Members:</p><ul><li>0: General</li><li>1: ChannelNotFound</li><li>2: CircularExecution</li></ul> */
  errorType: TriggerValidationErrorType;
  value: string;
}

export type UpdateFirmwareRequest = BaseRequest;

export interface UrlsResponse {
  brokerExternalUrl: string;
  brokerMqttHostname: string;
  /** @format int32 */
  brokerMqttPort: number;
  /** @format int32 */
  brokerMqttPortTls: number;
  deployedServiceName: string;
}

export interface VectorMeasurementResponseItem {
  /** @format int32 */
  type: number;
  /** @format int32 */
  index: number;
  /** @format float */
  value: number;
}

export interface VectorMeasurementsClusterIntegrationResponse {
  /** @format uuid */
  meterId: string;
  /** @format uuid */
  installationId: string;
  isSuccessfulFromStorage: boolean;
  isSuccessfulFromDevice: boolean;
  /** @format date-time */
  oldestAtUtc?: string | null;
  /** @format date-time */
  from: string;
  /** @format date-time */
  to: string;
  items: MultiParameterAggregatedItem[];
}

export interface VoltageThreshold {
  /** @format int32 */
  index: number;
  /** @format double */
  value: number;
}

export interface WifiNetworkResponse {
  ssid: string;
  /** @format int32 */
  rssi: number;
  remembered: boolean;
  supportedAuth: boolean;
}

export interface WifiNetworksResponse {
  /** @format uuid */
  deviceId: string;
  networks: WifiNetworkResponse[];
}

export interface WorkingHours {
  /**
   * for e.g. 01.5:20:24 - 1 day 5 hours 20 minutes 24 seconds
   * @example "00:00:00"
   */
  from: string;
  /**
   * for e.g. 01.5:20:24 - 1 day 5 hours 20 minutes 24 seconds
   * @example "00:00:00"
   */
  to: string;
}

interface BaseBaseBatchRequestItem {
  /** @format uuid */
  deviceId: string;
  /** @format uuid */
  channelId: string;
}

type BaseBaseBatchRequestItemTypeMapping<Key, Type> = {
  $type: Key;
} & Type;

export type BatchControlBatchData = CorrelationResponse[];

export type BinarySensorConfigureData = any;

export type BlindCalibrateStatusData = BlindChannelCalibrateStateResponse;

export type BlindSetPositionData = CorrelationResponse;

export type BlindSetDirectionData = CorrelationResponse;

export type BlindSetSensitivityData = any;

export type BlindSetSensitivityError = ErrorResponse;

export type BlindCalibrateData = CorrelationResponse;

export type BlindCalibrateError = ErrorResponse;

export type BlindCalibrateManuallyData = CorrelationResponse;

export type BlindCalibrateManuallyError = ErrorResponse;

export type BlindSwapOutData = CorrelationResponse;

export type BrokerInfoStateData = BrokerInfoResponse;

/** @format int32 */
export type BrokerInfoInstallationCountData = number;

export type BrokerInfoAverageConnectionTimeData = any;

export type BrokerInfoNextBrokersData = UrlsResponse[];

export type BrokerInfoInstallationInfoData = (
  | BrokerInstallationInfoResponse
  | BrokerInstallationFullInfoResponse
)[];

export type BrokerInfoDisboundedInstallationsData = BrokerBindingResponse[];

export type BrokerInfoDisboundInstallationsPayload = string[];

export type BrokerInfoDisboundInstallationsData = any;

export type BrokerInfoDisboundEmptyInstallationsData = string[];

export type BrokerInfoExalusInstallationInfoData = (
  | BrokerInstallationInfoResponse
  | BrokerInstallationFullInfoResponse
)[];

export type BrokerInfoByMacAddressData = any;

export type BrokerInfoByInstallationIdData = any;

export type BrokerInfoInstallationFullInfoData =
  BrokerInstallationFullInfoResponse;

export type BrokerInfoResetConfigurationChecksumData = any;

export type BrokerInfoKnedlikyManeveurData = any;

export type BrokerInfoResetToDefaultsData = any;

export type ClusteringIntegrationMetersData = any;

export type ClusteringIntegrationMetersdataData =
  VectorMeasurementsClusterIntegrationResponse[];

export type ClusteringIntegrationMetersaggregatedDataData =
  AggregatedVectorMeasurementsClusterIntegrationResponse;

export type ClusteringIntegrationMetersdatasingleData = any;

export type ClusteringIntegrationDynamicMarketPricesData =
  PriceWithDateResponse[];

export type ClusteringIntegrationInstallationsData = any;

export type CsvExportOrderData = OrderResult;

export type CsvExportOrderError = ProblemDetails | HttpValidationProblemDetails;

/** @format binary */
export type CsvExportDownloadData = File;

export type CsvExportDownloadError = ExportDownloadResult;

export type DebugDumpInstallationsData = any;

export type DebugLiveMetricsData = any;

export type DebugPublishTesterData = any;

export type DebugGetWorkloadProtocolVersionData = any;

export type DebugSetWorkloadProtocolVersionData = any;

export type DeviceCredentialsData = DeviceCredentialsResponse;

export type DeviceGetData = DeviceStateResponse;

export type DeviceGetError = ErrorResponse;

export type DeviceFilterData = DeviceStateResponse[];

export type DeviceConnectToNetworkData = CorrelationResponse;

export type DeviceConnectToUnknownNetworkData = CorrelationResponse;

export type DeviceUpdateFirmwareData = CorrelationResponse;

export type DeviceSetDeviceNameData = CorrelationResponse;

export type DeviceSetChannelNameData = CorrelationResponse;

export type DeviceSwapInData = CorrelationResponse;

export type DeviceSwapInError = ErrorResponse;

export type DeviceFactoryResetData = CorrelationResponse;

export type DeviceGetWifiNetworksData = CorrelationResponse;

export type DeviceGetWifiNetworksBatchData = WifiNetworksResponse[];

export type DeviceConnectToUnknownNetworkBatchData = CorrelationResponse[];

export type DeviceRestartData = CorrelationResponse;

export type DeviceResetToDefaultsData = CorrelationResponse;

export type DeviceSetActionBindingsData = any;

export type DeviceSetActionBindingsError = ErrorResponse;

export type DeviceLogsLogData = any;

export type DeviceUpdateDetailData = InstallationDeviceVersionsResponse;

export type DeviceUpdateCreateData = ForceUpdateResponse;

export type DeviceUpdateForceRestartData = ForceUpdateResponse;

export type ExportMetersData = MeterDefinition[];

export type ExportDataData = any;

export type ExportInternalDataData = any;

export type ExportPlugDataData = any;

export type GateStepByStepData = CorrelationResponse;

export type GateTiltData = CorrelationResponse;

export type GateSetPositionData = CorrelationResponse;

export type GateSetDirectionData = CorrelationResponse;

export type GateSetSbsSignalTimeData = any;

export type GateSetSbsSignalTimeError = ErrorResponse;

export type GateSetPartialControlModeData = any;

export type GateSetPartialControlModeError = ErrorResponse;

export type GateSetDailyModeData = any;

export type GateSetDailyModeError = ErrorResponse;

export type GateSetPartialSbsSignalTimeData = any;

export type GateSetPartialSbsSignalTimeError = ErrorResponse;

export type GateSetTiltTimeData = any;

export type GateSetTiltTimeError = ErrorResponse;

export type GateSetAlertConfigData = any;

export type GateSetAlertConfigError = ErrorResponse;

export type GateSetNegativeOutputData = any;

export type GateSetNegativeOutputError = ErrorResponse;

export type GateCalibrateData = CorrelationResponse;

export type GenericInputSetInputTypeData = any;

export type GenericInputSetInputTypeError = ErrorResponse;

export type GenericInputSetInputTypesBatchData = any;

export type GenericInputSetInputTypesBatchError = ErrorResponse;

export type InstallationChannelsData = ChannelsResponse;

export type InstallationRegisterData = InstallationModelResponse;

export type InstallationSetTimeZoneData = any;

export type InstallationSetGeolocationData = any;

export type InstallationDeleteData = any;

export type BrokerInstanceDetailData = BrokerUrlResponse;

export type BrokerInstanceDetailError = ErrorResponse;

export type BrokerInstanceDeviceData = BrokerUrlResponse;

export type BrokerInstanceDeviceError = ErrorResponse;

export type BrokerInstanceBindToInstallationData = BrokerUrlResponse;

export type BrokerInstanceBindToInstallationError = ErrorResponse;

export type BrokerInstanceDevicebyDiscoveryData = BrokerBindingModel;

export type BrokerInstanceDevicebyDiscoveryError = ErrorResponse;

export type BrokerInstanceAllBindingsData = AllBrokerBindingsResponse;

export type BrokerInstanceAllBindingsError = ErrorResponse;

export type BrokerInstanceBindToInstallationbyDiscoveryData = BrokerUrlResponse;

export type BrokerInstanceBindToInstallationbyDiscoveryError = ErrorResponse;

export type InstallationBindingRebindError = ErrorResponse;

export type InstallationBindingRebindRandomData = string[];

export type InstallationBindingAttachData = any;

export type InstallationBindingBindAndAttachData = any;

export type InstallationBindingClearCacheData = any;

export type IntegrationsInstallationsData = any;

export type IntegrationsChannelsWithBrokerData = any;

export type IntegrationsSyncData = any;

export type IntegrationsQueryData = any;

export type IntegrationsExecuteData = any;

export type LightToggleOnData = CorrelationResponse;

export type LightToggleOffData = CorrelationResponse;

export type LightSetBrightnessData = CorrelationResponse;

export type LightSetTemperatureData = CorrelationResponse;

export type LightSetRgbData = CorrelationResponse;

export type LightSupplyReturnBehaviorData = any;

export type LightSupplyReturnBehaviorError = ErrorResponse;

export type LightSetOnTimeData = CorrelationResponse;

export type MeterCommonMeasurementsData = GetCurrentMeasurementResponse;

export type MeterCommonMeasurementsError = ErrorResponse;

export type MeterCurrentMeasurementsData = GetCurrentMeasurementResponse;

export type MeterCurrentMeasurementsError = ErrorResponse;

export type MeterAggregateMeasurementsData =
  GetAggregateVectorMeasurementResponse;

export type MeterAggregateMeasurementsError = ErrorResponse;

export type MeterResetAggregateMeasurementsData = any;

export type MeterResetAggregateMeasurementsError = ErrorResponse;

export type MeterSetAmpTransformersData = any;

export type MeterSetAmpTransformersError = ErrorResponse;

export type MeterSetMeterPurposeData = any;

export type MeterSetMeterPurposeError = ErrorResponse;

export type MeterSetMeterParentIdData = any;

export type MeterSetMeterParentIdError = ErrorResponse;

export type MeterSetMeterTariffData = any;

export type MeterSetMeterTariffError = ErrorResponse;

export type MeterSetMeterEventingRulesData = any;

export type MeterSetMeterEventingRulesError = ErrorResponse;

export type MetricsRuleListData = MetricsRule[];

export type MetricsRuleCreateData = any;

export type MetricsRulePartialUpdateData = any;

export type MetricsRuleNotifyData = any;

export type MetricsRuleDeleteData = any;

export type MigrationsListData = LavvaMigrationResponse[];

export type MigrationsGenericInputNames1Data = any;

export type MigrationsSwitchFromGateOriginatedHiddenData = any;

export type MigrationsMigrateAddMissingFavsGroupsData = any;

export type MigrationsMigrateAddMeterGroupsData = any;

export type NotificationsCreateData = any;

export type NotificationsListData = NotificationTypesAndSenders;

export type NotificationsPartialUpdateData = any;

export type NotificationsBySenderData = any;

export type OptimizerSetModeData = any;

export type OptimizerSetModeError = ErrorResponse;

export type OptimizerSetTestModeLoadData = boolean;

export type OptimizerSetTestModeLoadError = ErrorResponse;

export type OptimizerSetConfigData = any;

export type OptimizerSetConfigError = ErrorResponse;

export type RecoveryGetDeviceStatusData = PublishStatus;

export type RecoveryUpdateFirmwareData = PublishStatus;

export type SwitchSetOnData = CorrelationResponse;

export type SwitchSetOffData = CorrelationResponse;

export type SwitchSetOnTimeData = CorrelationResponse;

export type SwitchSupplyReturnBehaviorData = any;

export type SwitchSupplyReturnBehaviorError = ErrorResponse;

export type TriggerFilterData = TriggerModelResponse[];

export type TriggerDetailData = TriggerModelResponse;

export type TriggerDeleteData = any;

export type TriggerCreateStateTriggerData = TriggerCreateResponse;

export type TriggerCreateStateTriggerError = ErrorResponse;

export type TriggerEditStateTriggerData = TriggerCreateResponse;

export type TriggerEditStateTriggerError = ErrorResponse;

export type TriggerCreateTimeTriggerData = TriggerCreateResponse;

export type TriggerCreateTimeTriggerError = ErrorResponse;

export type TriggerEditTimeTriggerData = TriggerCreateResponse;

export type TriggerEditTimeTriggerError = ErrorResponse;

export type TriggerCalculateNextFireTimeData = TriggerNextFireTimeResponse;

export type TriggerCalculateNextFireTimeError = ErrorResponse;

export type TriggerActivateData = any;

export type TriggerDeactivateData = any;

export type TriggerRunData = any;

export interface UploadProfilePayload {
  /** @format binary */
  file?: File;
}

export type UploadProfileData = any;

export type UsersDeleteData = any;

export namespace BatchControl {
  /**
   * No description
   * @tags BatchControl
   * @name BatchControlBatch
   * @request POST:/batchControl/batch
   * @secure
   */
  export namespace BatchControlBatch {
    export type RequestParams = {};
    export type RequestQuery = {};
    export type RequestBody = BatchControlRequest;
    export type RequestHeaders = {
      /**
       * Enter installationId
       * @format uuid
       */
      installationId: string;
    };
    export type ResponseBody = BatchControlBatchData;
  }
}

export namespace BinarySensor {
  /**
   * No description
   * @tags BinarySensor
   * @name BinarySensorConfigure
   * @request POST:/binarySensor/configure
   * @secure
   */
  export namespace BinarySensorConfigure {
    export type RequestParams = {};
    export type RequestQuery = {};
    export type RequestBody = ConfigureBinarySensorRequest;
    export type RequestHeaders = {
      /**
       * Enter installationId
       * @format uuid
       */
      installationId: string;
    };
    export type ResponseBody = BinarySensorConfigureData;
  }
}

export namespace Blind {
  /**
   * No description
   * @tags Blind
   * @name BlindCalibrateStatus
   * @request GET:/blind/calibrateStatus
   * @secure
   */
  export namespace BlindCalibrateStatus {
    export type RequestParams = {};
    export type RequestQuery = {
      /** @format uuid */
      channelId?: string;
    };
    export type RequestBody = never;
    export type RequestHeaders = {
      /**
       * Enter installationId
       * @format uuid
       */
      installationId: string;
    };
    export type ResponseBody = BlindCalibrateStatusData;
  }

  /**
   * No description
   * @tags Blind
   * @name BlindSetPosition
   * @request POST:/blind/setPosition
   * @secure
   */
  export namespace BlindSetPosition {
    export type RequestParams = {};
    export type RequestQuery = {};
    export type RequestBody = SetPositionRequest;
    export type RequestHeaders = {
      /**
       * Enter installationId
       * @format uuid
       */
      installationId: string;
    };
    export type ResponseBody = BlindSetPositionData;
  }

  /**
   * No description
   * @tags Blind
   * @name BlindSetDirection
   * @request POST:/blind/setDirection
   * @secure
   */
  export namespace BlindSetDirection {
    export type RequestParams = {};
    export type RequestQuery = {};
    export type RequestBody = SetDirectionRequest;
    export type RequestHeaders = {
      /**
       * Enter installationId
       * @format uuid
       */
      installationId: string;
    };
    export type ResponseBody = BlindSetDirectionData;
  }

  /**
   * No description
   * @tags Blind
   * @name BlindSetSensitivity
   * @request POST:/blind/setSensitivity
   * @secure
   */
  export namespace BlindSetSensitivity {
    export type RequestParams = {};
    export type RequestQuery = {};
    export type RequestBody = SetSensitivityRequest;
    export type RequestHeaders = {
      /**
       * Enter installationId
       * @format uuid
       */
      installationId: string;
    };
    export type ResponseBody = BlindSetSensitivityData;
  }

  /**
   * No description
   * @tags Blind
   * @name BlindCalibrate
   * @request POST:/blind/calibrate
   * @secure
   */
  export namespace BlindCalibrate {
    export type RequestParams = {};
    export type RequestQuery = {};
    export type RequestBody = CalibrateRequest;
    export type RequestHeaders = {
      /**
       * Enter installationId
       * @format uuid
       */
      installationId: string;
    };
    export type ResponseBody = BlindCalibrateData;
  }

  /**
   * No description
   * @tags Blind
   * @name BlindCalibrateManually
   * @request POST:/blind/calibrateManually
   * @secure
   */
  export namespace BlindCalibrateManually {
    export type RequestParams = {};
    export type RequestQuery = {};
    export type RequestBody = ManuallyCalibrateRequest;
    export type RequestHeaders = {
      /**
       * Enter installationId
       * @format uuid
       */
      installationId: string;
    };
    export type ResponseBody = BlindCalibrateManuallyData;
  }

  /**
   * No description
   * @tags Blind
   * @name BlindSwapOut
   * @request POST:/blind/swapOut
   * @secure
   */
  export namespace BlindSwapOut {
    export type RequestParams = {};
    export type RequestQuery = {};
    export type RequestBody = SwapOutRequest;
    export type RequestHeaders = {
      /**
       * Enter installationId
       * @format uuid
       */
      installationId: string;
    };
    export type ResponseBody = BlindSwapOutData;
  }
}

export namespace BrokerInfo {
  /**
   * No description
   * @tags BrokerInfo
   * @name BrokerInfoState
   * @request GET:/brokerInfo/state
   * @secure
   */
  export namespace BrokerInfoState {
    export type RequestParams = {};
    export type RequestQuery = {};
    export type RequestBody = never;
    export type RequestHeaders = {};
    export type ResponseBody = BrokerInfoStateData;
  }

  /**
   * No description
   * @tags BrokerInfo
   * @name BrokerInfoInstallationCount
   * @request GET:/brokerInfo/installationCount
   * @secure
   */
  export namespace BrokerInfoInstallationCount {
    export type RequestParams = {};
    export type RequestQuery = {
      /** @format int32 */
      brokerId?: number;
    };
    export type RequestBody = never;
    export type RequestHeaders = {};
    export type ResponseBody = BrokerInfoInstallationCountData;
  }

  /**
   * No description
   * @tags BrokerInfo
   * @name BrokerInfoAverageConnectionTime
   * @request GET:/brokerInfo/averageConnectionTime
   * @secure
   */
  export namespace BrokerInfoAverageConnectionTime {
    export type RequestParams = {};
    export type RequestQuery = {};
    export type RequestBody = never;
    export type RequestHeaders = {};
    export type ResponseBody = BrokerInfoAverageConnectionTimeData;
  }

  /**
   * No description
   * @tags BrokerInfo
   * @name BrokerInfoNextBrokers
   * @request GET:/brokerInfo/nextBrokers/{count}
   * @secure
   */
  export namespace BrokerInfoNextBrokers {
    export type RequestParams = {
      /**
       * @format int32
       * @default 1
       */
      count: number;
    };
    export type RequestQuery = {};
    export type RequestBody = never;
    export type RequestHeaders = {};
    export type ResponseBody = BrokerInfoNextBrokersData;
  }

  /**
   * No description
   * @tags BrokerInfo
   * @name BrokerInfoInstallationInfo
   * @request GET:/brokerInfo/installationInfo
   * @secure
   */
  export namespace BrokerInfoInstallationInfo {
    export type RequestParams = {};
    export type RequestQuery = {
      /** @format int32 */
      brokerId?: number;
    };
    export type RequestBody = never;
    export type RequestHeaders = {};
    export type ResponseBody = BrokerInfoInstallationInfoData;
  }

  /**
   * No description
   * @tags BrokerInfo
   * @name BrokerInfoDisboundedInstallations
   * @request GET:/brokerInfo/disboundedInstallations
   * @secure
   */
  export namespace BrokerInfoDisboundedInstallations {
    export type RequestParams = {};
    export type RequestQuery = {};
    export type RequestBody = never;
    export type RequestHeaders = {};
    export type ResponseBody = BrokerInfoDisboundedInstallationsData;
  }

  /**
   * No description
   * @tags BrokerInfo
   * @name BrokerInfoDisboundInstallations
   * @request POST:/brokerInfo/disboundInstallations
   * @secure
   */
  export namespace BrokerInfoDisboundInstallations {
    export type RequestParams = {};
    export type RequestQuery = {};
    export type RequestBody = BrokerInfoDisboundInstallationsPayload;
    export type RequestHeaders = {};
    export type ResponseBody = BrokerInfoDisboundInstallationsData;
  }

  /**
   * No description
   * @tags BrokerInfo
   * @name BrokerInfoDisboundEmptyInstallations
   * @request POST:/brokerInfo/disboundEmptyInstallations
   * @secure
   */
  export namespace BrokerInfoDisboundEmptyInstallations {
    export type RequestParams = {};
    export type RequestQuery = {};
    export type RequestBody = never;
    export type RequestHeaders = {};
    export type ResponseBody = BrokerInfoDisboundEmptyInstallationsData;
  }

  /**
   * No description
   * @tags BrokerInfo
   * @name BrokerInfoExalusInstallationInfo
   * @request GET:/brokerInfo/exalusInstallationInfo
   * @secure
   */
  export namespace BrokerInfoExalusInstallationInfo {
    export type RequestParams = {};
    export type RequestQuery = {};
    export type RequestBody = never;
    export type RequestHeaders = {};
    export type ResponseBody = BrokerInfoExalusInstallationInfoData;
  }

  /**
   * No description
   * @tags BrokerInfo
   * @name BrokerInfoByMacAddress
   * @request GET:/brokerInfo/byMacAddress/{macAddress}
   * @secure
   */
  export namespace BrokerInfoByMacAddress {
    export type RequestParams = {
      macAddress: string;
    };
    export type RequestQuery = {};
    export type RequestBody = never;
    export type RequestHeaders = {};
    export type ResponseBody = BrokerInfoByMacAddressData;
  }

  /**
   * No description
   * @tags BrokerInfo
   * @name BrokerInfoByInstallationId
   * @request GET:/brokerInfo/byInstallationId/{installationId}
   * @secure
   */
  export namespace BrokerInfoByInstallationId {
    export type RequestParams = {
      /** @format uuid */
      installationId: string;
    };
    export type RequestQuery = {};
    export type RequestBody = never;
    export type RequestHeaders = {};
    export type ResponseBody = BrokerInfoByInstallationIdData;
  }

  /**
   * No description
   * @tags BrokerInfo
   * @name BrokerInfoInstallationFullInfo
   * @request GET:/brokerInfo/installationFullInfo
   * @secure
   */
  export namespace BrokerInfoInstallationFullInfo {
    export type RequestParams = {};
    export type RequestQuery = {
      /** @format uuid */
      installationId?: string;
    };
    export type RequestBody = never;
    export type RequestHeaders = {};
    export type ResponseBody = BrokerInfoInstallationFullInfoData;
  }

  /**
   * No description
   * @tags BrokerInfo
   * @name BrokerInfoResetConfigurationChecksum
   * @request POST:/brokerInfo/resetConfigurationChecksum
   * @secure
   */
  export namespace BrokerInfoResetConfigurationChecksum {
    export type RequestParams = {};
    export type RequestQuery = {};
    export type RequestBody = ResetConfigurationChecksumRequest;
    export type RequestHeaders = {};
    export type ResponseBody = BrokerInfoResetConfigurationChecksumData;
  }

  /**
   * No description
   * @tags BrokerInfo
   * @name BrokerInfoKnedlikyManeveur
   * @request POST:/brokerInfo/knedlikyManeveur
   * @secure
   */
  export namespace BrokerInfoKnedlikyManeveur {
    export type RequestParams = {};
    export type RequestQuery = {};
    export type RequestBody = HardResetConfigurationChecksumRequest;
    export type RequestHeaders = {};
    export type ResponseBody = BrokerInfoKnedlikyManeveurData;
  }

  /**
   * No description
   * @tags BrokerInfo
   * @name BrokerInfoResetToDefaults
   * @request POST:/brokerInfo/resetToDefaults
   * @secure
   */
  export namespace BrokerInfoResetToDefaults {
    export type RequestParams = {};
    export type RequestQuery = {};
    export type RequestBody = ResetToDefaultsRequest;
    export type RequestHeaders = {};
    export type ResponseBody = BrokerInfoResetToDefaultsData;
  }
}

export namespace ClusteringIntegration {
  /**
   * No description
   * @tags ClusteringIntegration
   * @name ClusteringIntegrationMeters
   * @request GET:/clusteringIntegration/{installationId}/meters
   * @secure
   */
  export namespace ClusteringIntegrationMeters {
    export type RequestParams = {
      /** @format uuid */
      installationId: string;
    };
    export type RequestQuery = {};
    export type RequestBody = never;
    export type RequestHeaders = {};
    export type ResponseBody = ClusteringIntegrationMetersData;
  }

  /**
   * No description
   * @tags ClusteringIntegration
   * @name ClusteringIntegrationMetersdata
   * @request POST:/clusteringIntegration/meters/data
   * @secure
   */
  export namespace ClusteringIntegrationMetersdata {
    export type RequestParams = {};
    export type RequestQuery = {};
    export type RequestBody = GetMetersDataRequest;
    export type RequestHeaders = {};
    export type ResponseBody = ClusteringIntegrationMetersdataData;
  }

  /**
   * No description
   * @tags ClusteringIntegration
   * @name ClusteringIntegrationMetersaggregatedData
   * @request POST:/clusteringIntegration/meters/aggregatedData
   * @secure
   */
  export namespace ClusteringIntegrationMetersaggregatedData {
    export type RequestParams = {};
    export type RequestQuery = {};
    export type RequestBody = GetMetersDataRequest;
    export type RequestHeaders = {};
    export type ResponseBody = ClusteringIntegrationMetersaggregatedDataData;
  }

  /**
   * No description
   * @tags ClusteringIntegration
   * @name ClusteringIntegrationMetersdatasingle
   * @request POST:/clusteringIntegration/meters/data/single
   * @secure
   */
  export namespace ClusteringIntegrationMetersdatasingle {
    export type RequestParams = {};
    export type RequestQuery = {};
    export type RequestBody = GetSingleMeterDataRequest;
    export type RequestHeaders = {};
    export type ResponseBody = ClusteringIntegrationMetersdatasingleData;
  }

  /**
   * No description
   * @tags ClusteringIntegration
   * @name ClusteringIntegrationDynamicMarketPrices
   * @request GET:/clusteringIntegration/dynamicMarketPrices
   * @secure
   */
  export namespace ClusteringIntegrationDynamicMarketPrices {
    export type RequestParams = {};
    export type RequestQuery = {};
    export type RequestBody = never;
    export type RequestHeaders = {};
    export type ResponseBody = ClusteringIntegrationDynamicMarketPricesData;
  }

  /**
   * No description
   * @tags ClusteringIntegration
   * @name ClusteringIntegrationInstallations
   * @request GET:/clusteringIntegration/installations/{id}
   * @secure
   */
  export namespace ClusteringIntegrationInstallations {
    export type RequestParams = {
      /** @format uuid */
      id: string;
    };
    export type RequestQuery = {};
    export type RequestBody = never;
    export type RequestHeaders = {};
    export type ResponseBody = ClusteringIntegrationInstallationsData;
  }
}

export namespace CsvExport {
  /**
   * No description
   * @tags CsvExport
   * @name CsvExportOrder
   * @request POST:/csvExport/order/{meterId}
   * @secure
   */
  export namespace CsvExportOrder {
    export type RequestParams = {
      /** @format uuid */
      meterId: string;
    };
    export type RequestQuery = {};
    export type RequestBody = never;
    export type RequestHeaders = {};
    export type ResponseBody = CsvExportOrderData;
  }

  /**
   * No description
   * @tags CsvExport
   * @name CsvExportDownload
   * @request GET:/csvExport/download/{exportId}
   * @secure
   */
  export namespace CsvExportDownload {
    export type RequestParams = {
      /** @format uuid */
      exportId: string;
    };
    export type RequestQuery = {};
    export type RequestBody = never;
    export type RequestHeaders = {};
    export type ResponseBody = CsvExportDownloadData;
  }
}

export namespace Debug {
  /**
   * No description
   * @tags Debug
   * @name DebugDumpInstallations
   * @request POST:/debug/dumpInstallations
   * @secure
   */
  export namespace DebugDumpInstallations {
    export type RequestParams = {};
    export type RequestQuery = {};
    export type RequestBody = DumpInstallationsRequest;
    export type RequestHeaders = {
      /**
       * Enter installationId
       * @format uuid
       */
      installationId: string;
    };
    export type ResponseBody = DebugDumpInstallationsData;
  }

  /**
   * No description
   * @tags Debug
   * @name DebugLiveMetrics
   * @request POST:/debug/liveMetrics
   * @secure
   */
  export namespace DebugLiveMetrics {
    export type RequestParams = {};
    export type RequestQuery = {};
    export type RequestBody = SecretRequest;
    export type RequestHeaders = {
      /**
       * Enter installationId
       * @format uuid
       */
      installationId: string;
    };
    export type ResponseBody = DebugLiveMetricsData;
  }

  /**
   * No description
   * @tags Debug
   * @name DebugPublishTester
   * @request POST:/debug/publishTester
   * @secure
   */
  export namespace DebugPublishTester {
    export type RequestParams = {};
    export type RequestQuery = {};
    export type RequestBody = PublishTestRequest;
    export type RequestHeaders = {
      /**
       * Enter installationId
       * @format uuid
       */
      installationId: string;
    };
    export type ResponseBody = DebugPublishTesterData;
  }

  /**
   * No description
   * @tags Debug
   * @name DebugGetWorkloadProtocolVersion
   * @request POST:/debug/getWorkloadProtocolVersion
   * @secure
   */
  export namespace DebugGetWorkloadProtocolVersion {
    export type RequestParams = {};
    export type RequestQuery = {};
    export type RequestBody = SecretRequest;
    export type RequestHeaders = {
      /**
       * Enter installationId
       * @format uuid
       */
      installationId: string;
    };
    export type ResponseBody = DebugGetWorkloadProtocolVersionData;
  }

  /**
   * No description
   * @tags Debug
   * @name DebugSetWorkloadProtocolVersion
   * @request POST:/debug/setWorkloadProtocolVersion
   * @secure
   */
  export namespace DebugSetWorkloadProtocolVersion {
    export type RequestParams = {};
    export type RequestQuery = {};
    export type RequestBody = SetWorkloadProtocolVersionRequest;
    export type RequestHeaders = {
      /**
       * Enter installationId
       * @format uuid
       */
      installationId: string;
    };
    export type ResponseBody = DebugSetWorkloadProtocolVersionData;
  }
}

export namespace Device {
  /**
   * No description
   * @tags Device
   * @name DeviceCredentials
   * @request GET:/device/credentials
   * @secure
   */
  export namespace DeviceCredentials {
    export type RequestParams = {};
    export type RequestQuery = {};
    export type RequestBody = never;
    export type RequestHeaders = {
      /**
       * Enter installationId
       * @format uuid
       */
      installationId: string;
    };
    export type ResponseBody = DeviceCredentialsData;
  }

  /**
   * No description
   * @tags Device
   * @name DeviceGet
   * @request GET:/device/get
   * @secure
   */
  export namespace DeviceGet {
    export type RequestParams = {};
    export type RequestQuery = {
      /** @format uuid */
      deviceId?: string;
    };
    export type RequestBody = never;
    export type RequestHeaders = {
      /**
       * Enter installationId
       * @format uuid
       */
      installationId: string;
    };
    export type ResponseBody = DeviceGetData;
  }

  /**
   * No description
   * @tags Device
   * @name DeviceFilter
   * @request GET:/device/filter
   * @secure
   */
  export namespace DeviceFilter {
    export type RequestParams = {};
    export type RequestQuery = {};
    export type RequestBody = never;
    export type RequestHeaders = {
      /**
       * Enter installationId
       * @format uuid
       */
      installationId: string;
    };
    export type ResponseBody = DeviceFilterData;
  }

  /**
   * No description
   * @tags Device
   * @name DeviceConnectToNetwork
   * @request POST:/device/connectToNetwork
   * @secure
   */
  export namespace DeviceConnectToNetwork {
    export type RequestParams = {};
    export type RequestQuery = {};
    export type RequestBody = ConnectToNetworkRequest;
    export type RequestHeaders = {
      /**
       * Enter installationId
       * @format uuid
       */
      installationId: string;
    };
    export type ResponseBody = DeviceConnectToNetworkData;
  }

  /**
   * No description
   * @tags Device
   * @name DeviceConnectToUnknownNetwork
   * @request POST:/device/connectToUnknownNetwork
   * @secure
   */
  export namespace DeviceConnectToUnknownNetwork {
    export type RequestParams = {};
    export type RequestQuery = {};
    export type RequestBody = ConnectToUnknownNetworkRequest;
    export type RequestHeaders = {
      /**
       * Enter installationId
       * @format uuid
       */
      installationId: string;
    };
    export type ResponseBody = DeviceConnectToUnknownNetworkData;
  }

  /**
   * No description
   * @tags Device
   * @name DeviceUpdateFirmware
   * @request POST:/device/updateFirmware
   * @secure
   */
  export namespace DeviceUpdateFirmware {
    export type RequestParams = {};
    export type RequestQuery = {};
    export type RequestBody = GenericDeviceRequest;
    export type RequestHeaders = {
      /**
       * Enter installationId
       * @format uuid
       */
      installationId: string;
    };
    export type ResponseBody = DeviceUpdateFirmwareData;
  }

  /**
   * No description
   * @tags Device
   * @name DeviceSetDeviceName
   * @request POST:/device/setDeviceName
   * @secure
   */
  export namespace DeviceSetDeviceName {
    export type RequestParams = {};
    export type RequestQuery = {};
    export type RequestBody = SetDeviceNameRequest;
    export type RequestHeaders = {
      /**
       * Enter installationId
       * @format uuid
       */
      installationId: string;
    };
    export type ResponseBody = DeviceSetDeviceNameData;
  }

  /**
   * No description
   * @tags Device
   * @name DeviceSetChannelName
   * @request POST:/device/setChannelName
   * @secure
   */
  export namespace DeviceSetChannelName {
    export type RequestParams = {};
    export type RequestQuery = {};
    export type RequestBody = SetChannelNameRequest;
    export type RequestHeaders = {
      /**
       * Enter installationId
       * @format uuid
       */
      installationId: string;
    };
    export type ResponseBody = DeviceSetChannelNameData;
  }

  /**
   * No description
   * @tags Device
   * @name DeviceSwapIn
   * @request POST:/device/swapIn
   * @secure
   */
  export namespace DeviceSwapIn {
    export type RequestParams = {};
    export type RequestQuery = {};
    export type RequestBody = SwapInRequest;
    export type RequestHeaders = {
      /**
       * Enter installationId
       * @format uuid
       */
      installationId: string;
    };
    export type ResponseBody = DeviceSwapInData;
  }

  /**
   * No description
   * @tags Device
   * @name DeviceFactoryReset
   * @request POST:/device/factoryReset
   * @secure
   */
  export namespace DeviceFactoryReset {
    export type RequestParams = {};
    export type RequestQuery = {};
    export type RequestBody = FactoryResetRequest;
    export type RequestHeaders = {
      /**
       * Enter installationId
       * @format uuid
       */
      installationId: string;
    };
    export type ResponseBody = DeviceFactoryResetData;
  }

  /**
   * No description
   * @tags Device
   * @name DeviceGetWifiNetworks
   * @request POST:/device/getWifiNetworks
   * @secure
   */
  export namespace DeviceGetWifiNetworks {
    export type RequestParams = {};
    export type RequestQuery = {};
    export type RequestBody = GetWifiNetworksRequest;
    export type RequestHeaders = {
      /**
       * Enter installationId
       * @format uuid
       */
      installationId: string;
    };
    export type ResponseBody = DeviceGetWifiNetworksData;
  }

  /**
   * No description
   * @tags Device
   * @name DeviceGetWifiNetworksBatch
   * @request GET:/device/getWifiNetworksBatch
   * @secure
   */
  export namespace DeviceGetWifiNetworksBatch {
    export type RequestParams = {};
    export type RequestQuery = {};
    export type RequestBody = never;
    export type RequestHeaders = {
      /**
       * Enter installationId
       * @format uuid
       */
      installationId: string;
    };
    export type ResponseBody = DeviceGetWifiNetworksBatchData;
  }

  /**
   * No description
   * @tags Device
   * @name DeviceConnectToUnknownNetworkBatch
   * @request POST:/device/connectToUnknownNetworkBatch
   * @secure
   */
  export namespace DeviceConnectToUnknownNetworkBatch {
    export type RequestParams = {};
    export type RequestQuery = {};
    export type RequestBody = ConnectToUnknownNetworkRequestBatch;
    export type RequestHeaders = {
      /**
       * Enter installationId
       * @format uuid
       */
      installationId: string;
    };
    export type ResponseBody = DeviceConnectToUnknownNetworkBatchData;
  }

  /**
   * No description
   * @tags Device
   * @name DeviceRestart
   * @request POST:/device/restart
   * @secure
   */
  export namespace DeviceRestart {
    export type RequestParams = {};
    export type RequestQuery = {};
    export type RequestBody = RestartDeviceRequest;
    export type RequestHeaders = {
      /**
       * Enter installationId
       * @format uuid
       */
      installationId: string;
    };
    export type ResponseBody = DeviceRestartData;
  }

  /**
   * No description
   * @tags Device
   * @name DeviceResetToDefaults
   * @request POST:/device/resetToDefaults
   * @secure
   */
  export namespace DeviceResetToDefaults {
    export type RequestParams = {};
    export type RequestQuery = {};
    export type RequestBody = ResetToDefaultsRequest;
    export type RequestHeaders = {
      /**
       * Enter installationId
       * @format uuid
       */
      installationId: string;
    };
    export type ResponseBody = DeviceResetToDefaultsData;
  }

  /**
   * No description
   * @tags Device
   * @name DeviceSetActionBindings
   * @request POST:/device/setActionBindings
   * @secure
   */
  export namespace DeviceSetActionBindings {
    export type RequestParams = {};
    export type RequestQuery = {};
    export type RequestBody = SetActionBindingsRequest;
    export type RequestHeaders = {
      /**
       * Enter installationId
       * @format uuid
       */
      installationId: string;
    };
    export type ResponseBody = DeviceSetActionBindingsData;
  }
}

export namespace DeviceLogs {
  /**
   * No description
   * @tags DeviceLogs
   * @name DeviceLogsLog
   * @request POST:/deviceLogs/log
   * @secure
   */
  export namespace DeviceLogsLog {
    export type RequestParams = {};
    export type RequestQuery = {};
    export type RequestBody = DeviceLog;
    export type RequestHeaders = {};
    export type ResponseBody = DeviceLogsLogData;
  }
}

export namespace DeviceUpdate {
  /**
   * No description
   * @tags DeviceUpdate
   * @name DeviceUpdateDetail
   * @request GET:/deviceUpdate/{installationId}
   */
  export namespace DeviceUpdateDetail {
    export type RequestParams = {
      /** @format uuid */
      installationId: string;
    };
    export type RequestQuery = {};
    export type RequestBody = never;
    export type RequestHeaders = {};
    export type ResponseBody = DeviceUpdateDetailData;
  }

  /**
   * No description
   * @tags DeviceUpdate
   * @name DeviceUpdateCreate
   * @request POST:/deviceUpdate
   */
  export namespace DeviceUpdateCreate {
    export type RequestParams = {};
    export type RequestQuery = {};
    export type RequestBody = ForceUpdateRequest;
    export type RequestHeaders = {};
    export type ResponseBody = DeviceUpdateCreateData;
  }

  /**
   * No description
   * @tags DeviceUpdate
   * @name DeviceUpdateForceRestart
   * @request POST:/deviceUpdate/forceRestart
   */
  export namespace DeviceUpdateForceRestart {
    export type RequestParams = {};
    export type RequestQuery = {};
    export type RequestBody = ForceRestartRequest;
    export type RequestHeaders = {};
    export type ResponseBody = DeviceUpdateForceRestartData;
  }
}

export namespace Export {
  /**
   * No description
   * @tags Export
   * @name ExportMeters
   * @request GET:/export/meters
   * @secure
   */
  export namespace ExportMeters {
    export type RequestParams = {};
    export type RequestQuery = {};
    export type RequestBody = never;
    export type RequestHeaders = {};
    export type ResponseBody = ExportMetersData;
  }

  /**
   * No description
   * @tags Export
   * @name ExportData
   * @request GET:/export/data/{id}/{paramSet}
   * @secure
   */
  export namespace ExportData {
    export type RequestParams = {
      /** @format uuid */
      id: string;
      /** @format int32 */
      paramSet: number;
    };
    export type RequestQuery = {};
    export type RequestBody = never;
    export type RequestHeaders = {};
    export type ResponseBody = ExportDataData;
  }

  /**
   * No description
   * @tags Export
   * @name ExportInternalData
   * @request GET:/export/internalData/{id}
   * @secure
   */
  export namespace ExportInternalData {
    export type RequestParams = {
      /** @format uuid */
      id: string;
    };
    export type RequestQuery = {};
    export type RequestBody = never;
    export type RequestHeaders = {};
    export type ResponseBody = ExportInternalDataData;
  }

  /**
   * No description
   * @tags Export
   * @name ExportPlugData
   * @request GET:/export/plugData/{id}
   * @secure
   */
  export namespace ExportPlugData {
    export type RequestParams = {
      /** @format uuid */
      id: string;
    };
    export type RequestQuery = {};
    export type RequestBody = never;
    export type RequestHeaders = {};
    export type ResponseBody = ExportPlugDataData;
  }
}

export namespace Gate {
  /**
   * No description
   * @tags Gate
   * @name GateStepByStep
   * @request POST:/gate/stepByStep
   * @secure
   */
  export namespace GateStepByStep {
    export type RequestParams = {};
    export type RequestQuery = {};
    export type RequestBody = GateStepByStepRequest;
    export type RequestHeaders = {
      /**
       * Enter installationId
       * @format uuid
       */
      installationId: string;
    };
    export type ResponseBody = GateStepByStepData;
  }

  /**
   * No description
   * @tags Gate
   * @name GateTilt
   * @request POST:/gate/tilt
   * @secure
   */
  export namespace GateTilt {
    export type RequestParams = {};
    export type RequestQuery = {};
    export type RequestBody = GateTiltRequest;
    export type RequestHeaders = {
      /**
       * Enter installationId
       * @format uuid
       */
      installationId: string;
    };
    export type ResponseBody = GateTiltData;
  }

  /**
   * No description
   * @tags Gate
   * @name GateSetPosition
   * @request POST:/gate/setPosition
   * @secure
   */
  export namespace GateSetPosition {
    export type RequestParams = {};
    export type RequestQuery = {};
    export type RequestBody = GateSetPositionRequest;
    export type RequestHeaders = {
      /**
       * Enter installationId
       * @format uuid
       */
      installationId: string;
    };
    export type ResponseBody = GateSetPositionData;
  }

  /**
   * No description
   * @tags Gate
   * @name GateSetDirection
   * @request POST:/gate/setDirection
   * @secure
   */
  export namespace GateSetDirection {
    export type RequestParams = {};
    export type RequestQuery = {};
    export type RequestBody = GateSetDirectionRequest;
    export type RequestHeaders = {
      /**
       * Enter installationId
       * @format uuid
       */
      installationId: string;
    };
    export type ResponseBody = GateSetDirectionData;
  }

  /**
   * No description
   * @tags Gate
   * @name GateSetSbsSignalTime
   * @request POST:/gate/setSbsSignalTime
   * @secure
   */
  export namespace GateSetSbsSignalTime {
    export type RequestParams = {};
    export type RequestQuery = {};
    export type RequestBody = GateSetSbsSignalTimeRequest;
    export type RequestHeaders = {
      /**
       * Enter installationId
       * @format uuid
       */
      installationId: string;
    };
    export type ResponseBody = GateSetSbsSignalTimeData;
  }

  /**
   * No description
   * @tags Gate
   * @name GateSetPartialControlMode
   * @request POST:/gate/setPartialControlMode
   * @secure
   */
  export namespace GateSetPartialControlMode {
    export type RequestParams = {};
    export type RequestQuery = {};
    export type RequestBody = GateSetPartialControlModeStateRequest;
    export type RequestHeaders = {
      /**
       * Enter installationId
       * @format uuid
       */
      installationId: string;
    };
    export type ResponseBody = GateSetPartialControlModeData;
  }

  /**
   * No description
   * @tags Gate
   * @name GateSetDailyMode
   * @request POST:/gate/setDailyMode
   * @secure
   */
  export namespace GateSetDailyMode {
    export type RequestParams = {};
    export type RequestQuery = {};
    export type RequestBody = GateSetDailyModeStateRequest;
    export type RequestHeaders = {
      /**
       * Enter installationId
       * @format uuid
       */
      installationId: string;
    };
    export type ResponseBody = GateSetDailyModeData;
  }

  /**
   * No description
   * @tags Gate
   * @name GateSetPartialSbsSignalTime
   * @request POST:/gate/setPartialSbsSignalTime
   * @secure
   */
  export namespace GateSetPartialSbsSignalTime {
    export type RequestParams = {};
    export type RequestQuery = {};
    export type RequestBody = GateSetPartialSbsSignalTimeRequest;
    export type RequestHeaders = {
      /**
       * Enter installationId
       * @format uuid
       */
      installationId: string;
    };
    export type ResponseBody = GateSetPartialSbsSignalTimeData;
  }

  /**
   * No description
   * @tags Gate
   * @name GateSetTiltTime
   * @request POST:/gate/setTiltTime
   * @secure
   */
  export namespace GateSetTiltTime {
    export type RequestParams = {};
    export type RequestQuery = {};
    export type RequestBody = GateSetTiltTimeRequest;
    export type RequestHeaders = {
      /**
       * Enter installationId
       * @format uuid
       */
      installationId: string;
    };
    export type ResponseBody = GateSetTiltTimeData;
  }

  /**
   * No description
   * @tags Gate
   * @name GateSetAlertConfig
   * @request POST:/gate/setAlertConfig
   * @secure
   */
  export namespace GateSetAlertConfig {
    export type RequestParams = {};
    export type RequestQuery = {};
    export type RequestBody = GateSetAlertConfigRequest;
    export type RequestHeaders = {
      /**
       * Enter installationId
       * @format uuid
       */
      installationId: string;
    };
    export type ResponseBody = GateSetAlertConfigData;
  }

  /**
   * No description
   * @tags Gate
   * @name GateSetNegativeOutput
   * @request POST:/gate/setNegativeOutput
   * @secure
   */
  export namespace GateSetNegativeOutput {
    export type RequestParams = {};
    export type RequestQuery = {};
    export type RequestBody = GateSetNegativeOutputRequest;
    export type RequestHeaders = {
      /**
       * Enter installationId
       * @format uuid
       */
      installationId: string;
    };
    export type ResponseBody = GateSetNegativeOutputData;
  }

  /**
   * No description
   * @tags Gate
   * @name GateCalibrate
   * @request POST:/gate/calibrate
   * @secure
   */
  export namespace GateCalibrate {
    export type RequestParams = {};
    export type RequestQuery = {};
    export type RequestBody = GateCalibrateRequest;
    export type RequestHeaders = {
      /**
       * Enter installationId
       * @format uuid
       */
      installationId: string;
    };
    export type ResponseBody = GateCalibrateData;
  }
}

export namespace GenericInput {
  /**
   * No description
   * @tags GenericInput
   * @name GenericInputSetInputType
   * @request POST:/genericInput/setInputType
   * @secure
   */
  export namespace GenericInputSetInputType {
    export type RequestParams = {};
    export type RequestQuery = {};
    export type RequestBody = SetInputTypeRequest;
    export type RequestHeaders = {
      /**
       * Enter installationId
       * @format uuid
       */
      installationId: string;
    };
    export type ResponseBody = GenericInputSetInputTypeData;
  }

  /**
   * No description
   * @tags GenericInput
   * @name GenericInputSetInputTypesBatch
   * @request POST:/genericInput/setInputTypesBatch
   * @secure
   */
  export namespace GenericInputSetInputTypesBatch {
    export type RequestParams = {};
    export type RequestQuery = {};
    export type RequestBody = SetInputTypesBatchRequest;
    export type RequestHeaders = {
      /**
       * Enter installationId
       * @format uuid
       */
      installationId: string;
    };
    export type ResponseBody = GenericInputSetInputTypesBatchData;
  }
}

export namespace Installation {
  /**
   * No description
   * @tags Installation
   * @name InstallationChannels
   * @request GET:/installation/channels
   * @secure
   */
  export namespace InstallationChannels {
    export type RequestParams = {};
    export type RequestQuery = {
      /** <p>Members:</p><ul><li>1: Switch</li><li>2: Blind</li><li>4: Gate</li><li>8: Light</li><li>16: Hvac</li><li>32: Sensor</li><li>64: BinarySensor</li><li>128: GenericInput</li><li>256: Meter</li><li>512: Optimizer</li></ul> */
      channelTypes?: ChannelTypesFlag;
    };
    export type RequestBody = never;
    export type RequestHeaders = {
      /**
       * Enter installationId
       * @format uuid
       */
      installationId: string;
    };
    export type ResponseBody = InstallationChannelsData;
  }

  /**
   * No description
   * @tags Installation
   * @name InstallationRegister
   * @request POST:/installation/register
   * @secure
   */
  export namespace InstallationRegister {
    export type RequestParams = {};
    export type RequestQuery = {};
    export type RequestBody = RegisterInstallationRequest;
    export type RequestHeaders = {
      /**
       * Enter installationId
       * @format uuid
       */
      installationId: string;
    };
    export type ResponseBody = InstallationRegisterData;
  }

  /**
   * No description
   * @tags Installation
   * @name InstallationSetTimeZone
   * @request POST:/installation/setTimeZone
   * @secure
   */
  export namespace InstallationSetTimeZone {
    export type RequestParams = {};
    export type RequestQuery = {};
    export type RequestBody = SetInstallationTimeZoneRequest;
    export type RequestHeaders = {
      /**
       * Enter installationId
       * @format uuid
       */
      installationId: string;
    };
    export type ResponseBody = InstallationSetTimeZoneData;
  }

  /**
   * No description
   * @tags Installation
   * @name InstallationSetGeolocation
   * @request POST:/installation/setGeolocation
   * @secure
   */
  export namespace InstallationSetGeolocation {
    export type RequestParams = {};
    export type RequestQuery = {};
    export type RequestBody = SetInstallationGeolocationRequest;
    export type RequestHeaders = {
      /**
       * Enter installationId
       * @format uuid
       */
      installationId: string;
    };
    export type ResponseBody = InstallationSetGeolocationData;
  }

  /**
   * No description
   * @tags Installation
   * @name InstallationDelete
   * @request DELETE:/installation
   * @secure
   */
  export namespace InstallationDelete {
    export type RequestParams = {};
    export type RequestQuery = {};
    export type RequestBody = never;
    export type RequestHeaders = {
      /**
       * Enter installationId
       * @format uuid
       */
      installationId: string;
    };
    export type ResponseBody = InstallationDeleteData;
  }
}

export namespace BrokerInstance {
  /**
   * No description
   * @tags InstallationBinding
   * @name BrokerInstanceDetail
   * @request GET:/brokerInstance/{installationId}
   */
  export namespace BrokerInstanceDetail {
    export type RequestParams = {
      /** @format uuid */
      installationId: string;
    };
    export type RequestQuery = {};
    export type RequestBody = never;
    export type RequestHeaders = {};
    export type ResponseBody = BrokerInstanceDetailData;
  }

  /**
   * No description
   * @tags InstallationBinding
   * @name BrokerInstanceDevice
   * @request GET:/brokerInstance/device/{installationId}
   * @secure
   */
  export namespace BrokerInstanceDevice {
    export type RequestParams = {
      /** @format uuid */
      installationId: string;
    };
    export type RequestQuery = {};
    export type RequestBody = never;
    export type RequestHeaders = {};
    export type ResponseBody = BrokerInstanceDeviceData;
  }

  /**
   * No description
   * @tags InstallationBinding
   * @name BrokerInstanceBindToInstallation
   * @request GET:/brokerInstance/bindToInstallation/{installationId}
   * @secure
   */
  export namespace BrokerInstanceBindToInstallation {
    export type RequestParams = {
      /** @format uuid */
      installationId: string;
    };
    export type RequestQuery = {};
    export type RequestBody = never;
    export type RequestHeaders = {};
    export type ResponseBody = BrokerInstanceBindToInstallationData;
  }

  /**
   * No description
   * @tags InstallationBinding
   * @name BrokerInstanceDevicebyDiscovery
   * @request GET:/brokerInstance/device/byDiscovery/{installationId}
   * @secure
   */
  export namespace BrokerInstanceDevicebyDiscovery {
    export type RequestParams = {
      /** @format uuid */
      installationId: string;
    };
    export type RequestQuery = {};
    export type RequestBody = never;
    export type RequestHeaders = {};
    export type ResponseBody = BrokerInstanceDevicebyDiscoveryData;
  }

  /**
   * No description
   * @tags InstallationBinding
   * @name BrokerInstanceAllBindings
   * @request GET:/brokerInstance/allBindings
   * @secure
   */
  export namespace BrokerInstanceAllBindings {
    export type RequestParams = {};
    export type RequestQuery = {
      /** @format int32 */
      page?: number;
      /** @format int32 */
      pageSize?: number;
    };
    export type RequestBody = never;
    export type RequestHeaders = {};
    export type ResponseBody = BrokerInstanceAllBindingsData;
  }

  /**
   * No description
   * @tags InstallationBinding
   * @name BrokerInstanceBindToInstallationbyDiscovery
   * @request GET:/brokerInstance/bindToInstallation/byDiscovery/{installationId}
   * @secure
   */
  export namespace BrokerInstanceBindToInstallationbyDiscovery {
    export type RequestParams = {
      /** @format uuid */
      installationId: string;
    };
    export type RequestQuery = {
      /** @format uuid */
      deviceId?: string;
    };
    export type RequestBody = never;
    export type RequestHeaders = {};
    export type ResponseBody = BrokerInstanceBindToInstallationbyDiscoveryData;
  }
}

export namespace InstallationBinding {
  /**
   * No description
   * @tags InstallationBinding
   * @name InstallationBindingRebind
   * @request POST:/installationBinding/rebind/{installationId}/{brokerId}
   * @secure
   */
  export namespace InstallationBindingRebind {
    export type RequestParams = {
      /** @format uuid */
      installationId: string;
      /** @format int32 */
      brokerId: number;
    };
    export type RequestQuery = {};
    export type RequestBody = never;
    export type RequestHeaders = {};
    export type ResponseBody = any;
  }

  /**
   * No description
   * @tags InstallationBinding
   * @name InstallationBindingRebindRandom
   * @request POST:/installationBinding/rebindRandom
   * @secure
   */
  export namespace InstallationBindingRebindRandom {
    export type RequestParams = {};
    export type RequestQuery = {};
    export type RequestBody = RebindRandomInstallationsRequest;
    export type RequestHeaders = {};
    export type ResponseBody = InstallationBindingRebindRandomData;
  }

  /**
   * No description
   * @tags InstallationBinding
   * @name InstallationBindingAttach
   * @request POST:/installationBinding/attach/{installationId}
   * @secure
   */
  export namespace InstallationBindingAttach {
    export type RequestParams = {
      /** @format uuid */
      installationId: string;
    };
    export type RequestQuery = {};
    export type RequestBody = never;
    export type RequestHeaders = {};
    export type ResponseBody = InstallationBindingAttachData;
  }

  /**
   * No description
   * @tags InstallationBinding
   * @name InstallationBindingBindAndAttach
   * @request POST:/installationBinding/bindAndAttach/{installationId}
   * @secure
   */
  export namespace InstallationBindingBindAndAttach {
    export type RequestParams = {
      /** @format uuid */
      installationId: string;
    };
    export type RequestQuery = {};
    export type RequestBody = never;
    export type RequestHeaders = {};
    export type ResponseBody = InstallationBindingBindAndAttachData;
  }

  /**
   * No description
   * @tags InstallationBinding
   * @name InstallationBindingClearCache
   * @request POST:/installationBinding/clearCache/{installationId}
   * @secure
   */
  export namespace InstallationBindingClearCache {
    export type RequestParams = {
      /** @format uuid */
      installationId: string;
    };
    export type RequestQuery = {};
    export type RequestBody = never;
    export type RequestHeaders = {};
    export type ResponseBody = InstallationBindingClearCacheData;
  }
}

export namespace Integrations {
  /**
   * No description
   * @tags Integration
   * @name IntegrationsInstallations
   * @request GET:/integrations/installations/{userId}/{assistantType}
   * @secure
   */
  export namespace IntegrationsInstallations {
    export type RequestParams = {
      /** @format uuid */
      userId: string;
      /** <p>Members:</p><ul><li>0: Undefined</li><li>1: GoogleHome</li></ul> */
      assistantType: AssistantType;
    };
    export type RequestQuery = {};
    export type RequestBody = never;
    export type RequestHeaders = {};
    export type ResponseBody = IntegrationsInstallationsData;
  }

  /**
   * No description
   * @tags Integration
   * @name IntegrationsChannelsWithBroker
   * @request GET:/integrations/channelsWithBroker
   * @secure
   */
  export namespace IntegrationsChannelsWithBroker {
    export type RequestParams = {};
    export type RequestQuery = {};
    export type RequestBody = GetChannelsWithBrokerRequest;
    export type RequestHeaders = {};
    export type ResponseBody = IntegrationsChannelsWithBrokerData;
  }

  /**
   * No description
   * @tags Integration
   * @name IntegrationsSync
   * @request GET:/integrations/sync
   * @secure
   */
  export namespace IntegrationsSync {
    export type RequestParams = {};
    export type RequestQuery = {};
    export type RequestBody = SyncOrQueryRequest;
    export type RequestHeaders = {};
    export type ResponseBody = IntegrationsSyncData;
  }

  /**
   * No description
   * @tags Integration
   * @name IntegrationsQuery
   * @request GET:/integrations/query
   * @secure
   */
  export namespace IntegrationsQuery {
    export type RequestParams = {};
    export type RequestQuery = {};
    export type RequestBody = SyncOrQueryRequest;
    export type RequestHeaders = {};
    export type ResponseBody = IntegrationsQueryData;
  }

  /**
   * No description
   * @tags Integration
   * @name IntegrationsExecute
   * @request POST:/integrations/execute
   * @secure
   */
  export namespace IntegrationsExecute {
    export type RequestParams = {};
    export type RequestQuery = {};
    export type RequestBody = ExecuteRequest;
    export type RequestHeaders = {};
    export type ResponseBody = IntegrationsExecuteData;
  }
}

export namespace Light {
  /**
   * No description
   * @tags Light
   * @name LightToggleOn
   * @request POST:/light/toggleOn
   * @secure
   */
  export namespace LightToggleOn {
    export type RequestParams = {};
    export type RequestQuery = {};
    export type RequestBody = ToggleOnOffRequest;
    export type RequestHeaders = {
      /**
       * Enter installationId
       * @format uuid
       */
      installationId: string;
    };
    export type ResponseBody = LightToggleOnData;
  }

  /**
   * No description
   * @tags Light
   * @name LightToggleOff
   * @request POST:/light/toggleOff
   * @secure
   */
  export namespace LightToggleOff {
    export type RequestParams = {};
    export type RequestQuery = {};
    export type RequestBody = ToggleOnOffRequest;
    export type RequestHeaders = {
      /**
       * Enter installationId
       * @format uuid
       */
      installationId: string;
    };
    export type ResponseBody = LightToggleOffData;
  }

  /**
   * No description
   * @tags Light
   * @name LightSetBrightness
   * @request POST:/light/setBrightness
   * @secure
   */
  export namespace LightSetBrightness {
    export type RequestParams = {};
    export type RequestQuery = {};
    export type RequestBody = SetBrightnessRequest;
    export type RequestHeaders = {
      /**
       * Enter installationId
       * @format uuid
       */
      installationId: string;
    };
    export type ResponseBody = LightSetBrightnessData;
  }

  /**
   * No description
   * @tags Light
   * @name LightSetTemperature
   * @request POST:/light/setTemperature
   * @secure
   */
  export namespace LightSetTemperature {
    export type RequestParams = {};
    export type RequestQuery = {};
    export type RequestBody = SetTemperatureRequest;
    export type RequestHeaders = {
      /**
       * Enter installationId
       * @format uuid
       */
      installationId: string;
    };
    export type ResponseBody = LightSetTemperatureData;
  }

  /**
   * No description
   * @tags Light
   * @name LightSetRgb
   * @request POST:/light/setRgb
   * @secure
   */
  export namespace LightSetRgb {
    export type RequestParams = {};
    export type RequestQuery = {};
    export type RequestBody = SetRgbRequest;
    export type RequestHeaders = {
      /**
       * Enter installationId
       * @format uuid
       */
      installationId: string;
    };
    export type ResponseBody = LightSetRgbData;
  }

  /**
   * No description
   * @tags Light
   * @name LightSupplyReturnBehavior
   * @request POST:/light/supplyReturnBehavior
   * @secure
   */
  export namespace LightSupplyReturnBehavior {
    export type RequestParams = {};
    export type RequestQuery = {};
    export type RequestBody = SetSupplyReturnBehaviourRequest;
    export type RequestHeaders = {
      /**
       * Enter installationId
       * @format uuid
       */
      installationId: string;
    };
    export type ResponseBody = LightSupplyReturnBehaviorData;
  }

  /**
   * No description
   * @tags Light
   * @name LightSetOnTime
   * @request POST:/light/setOnTime
   * @secure
   */
  export namespace LightSetOnTime {
    export type RequestParams = {};
    export type RequestQuery = {};
    export type RequestBody = SetOnTimeRequest;
    export type RequestHeaders = {
      /**
       * Enter installationId
       * @format uuid
       */
      installationId: string;
    };
    export type ResponseBody = LightSetOnTimeData;
  }
}

export namespace Meter {
  /**
   * No description
   * @tags Meter
   * @name MeterCommonMeasurements
   * @request POST:/meter/commonMeasurements
   * @secure
   */
  export namespace MeterCommonMeasurements {
    export type RequestParams = {};
    export type RequestQuery = {};
    export type RequestBody = GetCommonMeasurementsRequest;
    export type RequestHeaders = {
      /**
       * Enter installationId
       * @format uuid
       */
      installationId: string;
    };
    export type ResponseBody = MeterCommonMeasurementsData;
  }

  /**
   * No description
   * @tags Meter
   * @name MeterCurrentMeasurements
   * @request POST:/meter/currentMeasurements
   * @secure
   */
  export namespace MeterCurrentMeasurements {
    export type RequestParams = {};
    export type RequestQuery = {};
    export type RequestBody = GetCurrentMeasurementsRequest;
    export type RequestHeaders = {
      /**
       * Enter installationId
       * @format uuid
       */
      installationId: string;
    };
    export type ResponseBody = MeterCurrentMeasurementsData;
  }

  /**
   * No description
   * @tags Meter
   * @name MeterAggregateMeasurements
   * @request POST:/meter/aggregateMeasurements
   * @secure
   */
  export namespace MeterAggregateMeasurements {
    export type RequestParams = {};
    export type RequestQuery = {};
    export type RequestBody = GetAggregateMeasurementsRequest;
    export type RequestHeaders = {
      /**
       * Enter installationId
       * @format uuid
       */
      installationId: string;
    };
    export type ResponseBody = MeterAggregateMeasurementsData;
  }

  /**
   * No description
   * @tags Meter
   * @name MeterResetAggregateMeasurements
   * @request POST:/meter/resetAggregateMeasurements
   * @secure
   */
  export namespace MeterResetAggregateMeasurements {
    export type RequestParams = {};
    export type RequestQuery = {};
    export type RequestBody = ResetAggregateMeasurementsRequest;
    export type RequestHeaders = {
      /**
       * Enter installationId
       * @format uuid
       */
      installationId: string;
    };
    export type ResponseBody = MeterResetAggregateMeasurementsData;
  }

  /**
   * No description
   * @tags Meter
   * @name MeterSetAmpTransformers
   * @request POST:/meter/setAmpTransformers
   * @secure
   */
  export namespace MeterSetAmpTransformers {
    export type RequestParams = {};
    export type RequestQuery = {};
    export type RequestBody = SetAmpTransformersRequest;
    export type RequestHeaders = {
      /**
       * Enter installationId
       * @format uuid
       */
      installationId: string;
    };
    export type ResponseBody = MeterSetAmpTransformersData;
  }

  /**
   * No description
   * @tags Meter
   * @name MeterSetMeterPurpose
   * @request POST:/meter/setMeterPurpose
   * @secure
   */
  export namespace MeterSetMeterPurpose {
    export type RequestParams = {};
    export type RequestQuery = {};
    export type RequestBody = SetMeterPurposeRequest;
    export type RequestHeaders = {
      /**
       * Enter installationId
       * @format uuid
       */
      installationId: string;
    };
    export type ResponseBody = MeterSetMeterPurposeData;
  }

  /**
   * No description
   * @tags Meter
   * @name MeterSetMeterParentId
   * @request POST:/meter/setMeterParentId
   * @secure
   */
  export namespace MeterSetMeterParentId {
    export type RequestParams = {};
    export type RequestQuery = {};
    export type RequestBody = SetMeterParentIdRequest;
    export type RequestHeaders = {
      /**
       * Enter installationId
       * @format uuid
       */
      installationId: string;
    };
    export type ResponseBody = MeterSetMeterParentIdData;
  }

  /**
   * No description
   * @tags Meter
   * @name MeterSetMeterTariff
   * @request POST:/meter/setMeterTariff
   * @secure
   */
  export namespace MeterSetMeterTariff {
    export type RequestParams = {};
    export type RequestQuery = {};
    export type RequestBody = SetMeterTariffRequest;
    export type RequestHeaders = {
      /**
       * Enter installationId
       * @format uuid
       */
      installationId: string;
    };
    export type ResponseBody = MeterSetMeterTariffData;
  }

  /**
   * No description
   * @tags Meter
   * @name MeterSetMeterEventingRules
   * @request POST:/meter/setMeterEventingRules
   * @secure
   */
  export namespace MeterSetMeterEventingRules {
    export type RequestParams = {};
    export type RequestQuery = {};
    export type RequestBody = SetMeterEventingRulesRequest;
    export type RequestHeaders = {
      /**
       * Enter installationId
       * @format uuid
       */
      installationId: string;
    };
    export type ResponseBody = MeterSetMeterEventingRulesData;
  }
}

export namespace MetricsRule {
  /**
   * No description
   * @tags MetricsRule
   * @name MetricsRuleList
   * @request GET:/metricsRule
   * @secure
   */
  export namespace MetricsRuleList {
    export type RequestParams = {};
    export type RequestQuery = {};
    export type RequestBody = never;
    export type RequestHeaders = {};
    export type ResponseBody = MetricsRuleListData;
  }

  /**
   * No description
   * @tags MetricsRule
   * @name MetricsRuleCreate
   * @request POST:/metricsRule
   * @secure
   */
  export namespace MetricsRuleCreate {
    export type RequestParams = {};
    export type RequestQuery = {};
    export type RequestBody = MetricsRule;
    export type RequestHeaders = {};
    export type ResponseBody = MetricsRuleCreateData;
  }

  /**
   * No description
   * @tags MetricsRule
   * @name MetricsRulePartialUpdate
   * @request PATCH:/metricsRule
   * @secure
   */
  export namespace MetricsRulePartialUpdate {
    export type RequestParams = {};
    export type RequestQuery = {};
    export type RequestBody = MetricsRule;
    export type RequestHeaders = {};
    export type ResponseBody = MetricsRulePartialUpdateData;
  }

  /**
   * No description
   * @tags MetricsRule
   * @name MetricsRuleNotify
   * @request POST:/metricsRule/notify/{ruleId}
   * @secure
   */
  export namespace MetricsRuleNotify {
    export type RequestParams = {
      /** @format uuid */
      ruleId: string;
    };
    export type RequestQuery = {};
    export type RequestBody = never;
    export type RequestHeaders = {};
    export type ResponseBody = MetricsRuleNotifyData;
  }

  /**
   * No description
   * @tags MetricsRule
   * @name MetricsRuleDelete
   * @request DELETE:/metricsRule/{ruleId}
   * @secure
   */
  export namespace MetricsRuleDelete {
    export type RequestParams = {
      /** @format uuid */
      ruleId: string;
    };
    export type RequestQuery = {};
    export type RequestBody = never;
    export type RequestHeaders = {};
    export type ResponseBody = MetricsRuleDeleteData;
  }
}

export namespace Migrations {
  /**
   * No description
   * @tags Migration
   * @name MigrationsList
   * @request GET:/migrations
   * @secure
   */
  export namespace MigrationsList {
    export type RequestParams = {};
    export type RequestQuery = {};
    export type RequestBody = never;
    export type RequestHeaders = {};
    export type ResponseBody = MigrationsListData;
  }

  /**
   * No description
   * @tags Migration
   * @name MigrationsGenericInputNames1
   * @request POST:/migrations/GenericInputNames1
   * @secure
   */
  export namespace MigrationsGenericInputNames1 {
    export type RequestParams = {};
    export type RequestQuery = {};
    export type RequestBody = MigrateGenericInputNamesRequest;
    export type RequestHeaders = {};
    export type ResponseBody = MigrationsGenericInputNames1Data;
  }

  /**
   * No description
   * @tags Migration
   * @name MigrationsSwitchFromGateOriginatedHidden
   * @request POST:/migrations/SwitchFromGateOriginatedHidden
   * @secure
   */
  export namespace MigrationsSwitchFromGateOriginatedHidden {
    export type RequestParams = {};
    export type RequestQuery = {};
    export type RequestBody = MigrateSwitchFromGateOriginatedChannelsRequest;
    export type RequestHeaders = {};
    export type ResponseBody = MigrationsSwitchFromGateOriginatedHiddenData;
  }

  /**
   * No description
   * @tags Migration
   * @name MigrationsMigrateAddMissingFavsGroups
   * @request POST:/migrations/MigrateAddMissingFavsGroups
   * @secure
   */
  export namespace MigrationsMigrateAddMissingFavsGroups {
    export type RequestParams = {};
    export type RequestQuery = {};
    export type RequestBody = MigrateAddMissingFavsGroupsRequest;
    export type RequestHeaders = {};
    export type ResponseBody = MigrationsMigrateAddMissingFavsGroupsData;
  }

  /**
   * No description
   * @tags Migration
   * @name MigrationsMigrateAddMeterGroups
   * @request POST:/migrations/MigrateAddMeterGroups
   * @secure
   */
  export namespace MigrationsMigrateAddMeterGroups {
    export type RequestParams = {};
    export type RequestQuery = {};
    export type RequestBody = MigrateAddMeterGroupsRequest;
    export type RequestHeaders = {};
    export type ResponseBody = MigrationsMigrateAddMeterGroupsData;
  }
}

export namespace Notifications {
  /**
   * No description
   * @tags Notifications
   * @name NotificationsCreate
   * @request POST:/notifications
   * @secure
   */
  export namespace NotificationsCreate {
    export type RequestParams = {};
    export type RequestQuery = {};
    export type RequestBody = DemoNotificationRequest;
    export type RequestHeaders = {};
    export type ResponseBody = NotificationsCreateData;
  }

  /**
   * No description
   * @tags Notifications
   * @name NotificationsList
   * @request GET:/notifications
   * @secure
   */
  export namespace NotificationsList {
    export type RequestParams = {};
    export type RequestQuery = {};
    export type RequestBody = never;
    export type RequestHeaders = {};
    export type ResponseBody = NotificationsListData;
  }

  /**
   * No description
   * @tags Notifications
   * @name NotificationsPartialUpdate
   * @request PATCH:/notifications
   * @secure
   */
  export namespace NotificationsPartialUpdate {
    export type RequestParams = {};
    export type RequestQuery = {};
    export type RequestBody = NotificationMapUpdateRequest;
    export type RequestHeaders = {};
    export type ResponseBody = NotificationsPartialUpdateData;
  }

  /**
   * No description
   * @tags Notifications
   * @name NotificationsBySender
   * @request GET:/notifications/bySender/{senderType}
   * @secure
   */
  export namespace NotificationsBySender {
    export type RequestParams = {
      /** <p>Members:</p><ul><li>0: Undefined</li><li>1: Subscriptions</li><li>2: Smtp</li><li>3: Push</li><li>4: QueryOnly</li></ul> */
      senderType: NotificationSenderType;
    };
    export type RequestQuery = {};
    export type RequestBody = never;
    export type RequestHeaders = {};
    export type ResponseBody = NotificationsBySenderData;
  }
}

export namespace Optimizer {
  /**
   * No description
   * @tags Optimizer
   * @name OptimizerSetMode
   * @request POST:/optimizer/setMode
   * @secure
   */
  export namespace OptimizerSetMode {
    export type RequestParams = {};
    export type RequestQuery = {};
    export type RequestBody = SetOptimizerModeRequest;
    export type RequestHeaders = {
      /**
       * Enter installationId
       * @format uuid
       */
      installationId: string;
    };
    export type ResponseBody = OptimizerSetModeData;
  }

  /**
   * No description
   * @tags Optimizer
   * @name OptimizerSetTestModeLoad
   * @request POST:/optimizer/setTestModeLoad
   * @secure
   */
  export namespace OptimizerSetTestModeLoad {
    export type RequestParams = {};
    export type RequestQuery = {};
    export type RequestBody = SetOptimizerTestModeLoadRequest;
    export type RequestHeaders = {
      /**
       * Enter installationId
       * @format uuid
       */
      installationId: string;
    };
    export type ResponseBody = OptimizerSetTestModeLoadData;
  }

  /**
   * No description
   * @tags Optimizer
   * @name OptimizerSetConfig
   * @request POST:/optimizer/setConfig
   * @secure
   */
  export namespace OptimizerSetConfig {
    export type RequestParams = {};
    export type RequestQuery = {};
    export type RequestBody = SetOptimizerConfigRequest;
    export type RequestHeaders = {
      /**
       * Enter installationId
       * @format uuid
       */
      installationId: string;
    };
    export type ResponseBody = OptimizerSetConfigData;
  }
}

export namespace Recovery {
  /**
   * No description
   * @tags Recovery
   * @name RecoveryGetDeviceStatus
   * @request POST:/recovery/getDeviceStatus
   * @secure
   */
  export namespace RecoveryGetDeviceStatus {
    export type RequestParams = {};
    export type RequestQuery = {};
    export type RequestBody = GenericDeviceRequest;
    export type RequestHeaders = {
      /**
       * Enter installationId
       * @format uuid
       */
      installationId: string;
    };
    export type ResponseBody = RecoveryGetDeviceStatusData;
  }

  /**
   * No description
   * @tags Recovery
   * @name RecoveryUpdateFirmware
   * @request POST:/recovery/updateFirmware
   * @secure
   */
  export namespace RecoveryUpdateFirmware {
    export type RequestParams = {};
    export type RequestQuery = {};
    export type RequestBody = GenericDeviceRequest;
    export type RequestHeaders = {
      /**
       * Enter installationId
       * @format uuid
       */
      installationId: string;
    };
    export type ResponseBody = RecoveryUpdateFirmwareData;
  }
}

export namespace Switch {
  /**
   * No description
   * @tags Switch
   * @name SwitchSetOn
   * @request POST:/switch/setOn
   * @secure
   */
  export namespace SwitchSetOn {
    export type RequestParams = {};
    export type RequestQuery = {};
    export type RequestBody = SetOnOffRequest;
    export type RequestHeaders = {
      /**
       * Enter installationId
       * @format uuid
       */
      installationId: string;
    };
    export type ResponseBody = SwitchSetOnData;
  }

  /**
   * No description
   * @tags Switch
   * @name SwitchSetOff
   * @request POST:/switch/setOff
   * @secure
   */
  export namespace SwitchSetOff {
    export type RequestParams = {};
    export type RequestQuery = {};
    export type RequestBody = SetOnOffRequest;
    export type RequestHeaders = {
      /**
       * Enter installationId
       * @format uuid
       */
      installationId: string;
    };
    export type ResponseBody = SwitchSetOffData;
  }

  /**
   * No description
   * @tags Switch
   * @name SwitchSetOnTime
   * @request POST:/switch/setOnTime
   * @secure
   */
  export namespace SwitchSetOnTime {
    export type RequestParams = {};
    export type RequestQuery = {};
    export type RequestBody = SetOnTimeRequest;
    export type RequestHeaders = {
      /**
       * Enter installationId
       * @format uuid
       */
      installationId: string;
    };
    export type ResponseBody = SwitchSetOnTimeData;
  }

  /**
   * No description
   * @tags Switch
   * @name SwitchSupplyReturnBehavior
   * @request POST:/switch/supplyReturnBehavior
   * @secure
   */
  export namespace SwitchSupplyReturnBehavior {
    export type RequestParams = {};
    export type RequestQuery = {};
    export type RequestBody = SetSupplyReturnBehaviourRequest;
    export type RequestHeaders = {
      /**
       * Enter installationId
       * @format uuid
       */
      installationId: string;
    };
    export type ResponseBody = SwitchSupplyReturnBehaviorData;
  }
}

export namespace Trigger {
  /**
   * No description
   * @tags Trigger
   * @name TriggerFilter
   * @request GET:/trigger/filter
   * @secure
   */
  export namespace TriggerFilter {
    export type RequestParams = {};
    export type RequestQuery = {};
    export type RequestBody = never;
    export type RequestHeaders = {
      /**
       * Enter installationId
       * @format uuid
       */
      installationId: string;
    };
    export type ResponseBody = TriggerFilterData;
  }

  /**
   * No description
   * @tags Trigger
   * @name TriggerDetail
   * @request GET:/trigger/{triggerId}
   * @secure
   */
  export namespace TriggerDetail {
    export type RequestParams = {
      /** @format uuid */
      triggerId: string;
    };
    export type RequestQuery = {};
    export type RequestBody = never;
    export type RequestHeaders = {
      /**
       * Enter installationId
       * @format uuid
       */
      installationId: string;
    };
    export type ResponseBody = TriggerDetailData;
  }

  /**
   * No description
   * @tags Trigger
   * @name TriggerDelete
   * @request DELETE:/trigger/{triggerId}
   * @secure
   */
  export namespace TriggerDelete {
    export type RequestParams = {
      /** @format uuid */
      triggerId: string;
    };
    export type RequestQuery = {};
    export type RequestBody = never;
    export type RequestHeaders = {
      /**
       * Enter installationId
       * @format uuid
       */
      installationId: string;
    };
    export type ResponseBody = TriggerDeleteData;
  }

  /**
   * No description
   * @tags Trigger
   * @name TriggerCreateStateTrigger
   * @request POST:/trigger/createStateTrigger
   * @secure
   */
  export namespace TriggerCreateStateTrigger {
    export type RequestParams = {};
    export type RequestQuery = {};
    export type RequestBody = CreateStateTriggerRequest;
    export type RequestHeaders = {
      /**
       * Enter installationId
       * @format uuid
       */
      installationId: string;
    };
    export type ResponseBody = TriggerCreateStateTriggerData;
  }

  /**
   * No description
   * @tags Trigger
   * @name TriggerEditStateTrigger
   * @request POST:/trigger/editStateTrigger
   * @secure
   */
  export namespace TriggerEditStateTrigger {
    export type RequestParams = {};
    export type RequestQuery = {};
    export type RequestBody = CreateStateTriggerRequest;
    export type RequestHeaders = {
      /**
       * Enter installationId
       * @format uuid
       */
      installationId: string;
    };
    export type ResponseBody = TriggerEditStateTriggerData;
  }

  /**
   * No description
   * @tags Trigger
   * @name TriggerCreateTimeTrigger
   * @request POST:/trigger/createTimeTrigger
   * @secure
   */
  export namespace TriggerCreateTimeTrigger {
    export type RequestParams = {};
    export type RequestQuery = {};
    export type RequestBody = CreateTimeTriggerRequest;
    export type RequestHeaders = {
      /**
       * Enter installationId
       * @format uuid
       */
      installationId: string;
    };
    export type ResponseBody = TriggerCreateTimeTriggerData;
  }

  /**
   * No description
   * @tags Trigger
   * @name TriggerEditTimeTrigger
   * @request POST:/trigger/editTimeTrigger
   * @secure
   */
  export namespace TriggerEditTimeTrigger {
    export type RequestParams = {};
    export type RequestQuery = {};
    export type RequestBody = CreateTimeTriggerRequest;
    export type RequestHeaders = {
      /**
       * Enter installationId
       * @format uuid
       */
      installationId: string;
    };
    export type ResponseBody = TriggerEditTimeTriggerData;
  }

  /**
   * No description
   * @tags Trigger
   * @name TriggerCalculateNextFireTime
   * @request POST:/trigger/calculateNextFireTime
   * @secure
   */
  export namespace TriggerCalculateNextFireTime {
    export type RequestParams = {};
    export type RequestQuery = {};
    export type RequestBody = TriggerTimeConditionRequest;
    export type RequestHeaders = {
      /**
       * Enter installationId
       * @format uuid
       */
      installationId: string;
    };
    export type ResponseBody = TriggerCalculateNextFireTimeData;
  }

  /**
   * No description
   * @tags Trigger
   * @name TriggerActivate
   * @request POST:/trigger/{triggerId}/activate
   * @secure
   */
  export namespace TriggerActivate {
    export type RequestParams = {
      /** @format uuid */
      triggerId: string;
    };
    export type RequestQuery = {};
    export type RequestBody = never;
    export type RequestHeaders = {
      /**
       * Enter installationId
       * @format uuid
       */
      installationId: string;
    };
    export type ResponseBody = TriggerActivateData;
  }

  /**
   * No description
   * @tags Trigger
   * @name TriggerDeactivate
   * @request POST:/trigger/{triggerId}/deactivate
   * @secure
   */
  export namespace TriggerDeactivate {
    export type RequestParams = {
      /** @format uuid */
      triggerId: string;
    };
    export type RequestQuery = {};
    export type RequestBody = never;
    export type RequestHeaders = {
      /**
       * Enter installationId
       * @format uuid
       */
      installationId: string;
    };
    export type ResponseBody = TriggerDeactivateData;
  }

  /**
   * No description
   * @tags Trigger
   * @name TriggerRun
   * @request POST:/trigger/{triggerId}/run
   * @secure
   */
  export namespace TriggerRun {
    export type RequestParams = {
      /** @format uuid */
      triggerId: string;
    };
    export type RequestQuery = {
      ignoreStateConditions?: boolean;
    };
    export type RequestBody = never;
    export type RequestHeaders = {
      /**
       * Enter installationId
       * @format uuid
       */
      installationId: string;
    };
    export type ResponseBody = TriggerRunData;
  }
}

export namespace Upload {
  /**
   * No description
   * @tags Upload
   * @name UploadProfile
   * @request POST:/upload/profile
   * @secure
   */
  export namespace UploadProfile {
    export type RequestParams = {};
    export type RequestQuery = {};
    export type RequestBody = UploadProfilePayload;
    export type RequestHeaders = {};
    export type ResponseBody = UploadProfileData;
  }
}

export namespace Users {
  /**
   * No description
   * @tags Users
   * @name UsersDelete
   * @request DELETE:/users/delete
   * @secure
   */
  export namespace UsersDelete {
    export type RequestParams = {};
    export type RequestQuery = {};
    export type RequestBody = never;
    export type RequestHeaders = {};
    export type ResponseBody = UsersDeleteData;
  }
}

import type {
  AxiosInstance,
  AxiosRequestConfig,
  AxiosResponse,
  HeadersDefaults,
  ResponseType,
} from "axios";
import axios from "axios";

export type QueryParamsType = Record<string | number, any>;

export interface FullRequestParams
  extends Omit<AxiosRequestConfig, "data" | "params" | "url" | "responseType"> {
  /** set parameter to `true` for call `securityWorker` for this request */
  secure?: boolean;
  /** request path */
  path: string;
  /** content type of request body */
  type?: ContentType;
  /** query params */
  query?: QueryParamsType;
  /** format of response (i.e. response.json() -> format: "json") */
  format?: ResponseType;
  /** request body */
  body?: unknown;
}

export type RequestParams = Omit<
  FullRequestParams,
  "body" | "method" | "query" | "path"
>;

export interface ApiConfig<SecurityDataType = unknown>
  extends Omit<AxiosRequestConfig, "data" | "cancelToken"> {
  securityWorker?: (
    securityData: SecurityDataType | null,
  ) => Promise<AxiosRequestConfig | void> | AxiosRequestConfig | void;
  secure?: boolean;
  format?: ResponseType;
}

export enum ContentType {
  Json = "application/json",
  JsonApi = "application/vnd.api+json",
  FormData = "multipart/form-data",
  UrlEncoded = "application/x-www-form-urlencoded",
  Text = "text/plain",
}

export class HttpClient<SecurityDataType = unknown> {
  public instance: AxiosInstance;
  private securityData: SecurityDataType | null = null;
  private securityWorker?: ApiConfig<SecurityDataType>["securityWorker"];
  private secure?: boolean;
  private format?: ResponseType;

  constructor({
    securityWorker,
    secure,
    format,
    ...axiosConfig
  }: ApiConfig<SecurityDataType> = {}) {
    this.instance = axios.create({
      ...axiosConfig,
      baseURL: axiosConfig.baseURL || "",
    });
    this.secure = secure;
    this.format = format;
    this.securityWorker = securityWorker;
  }

  public setSecurityData = (data: SecurityDataType | null) => {
    this.securityData = data;
  };

  protected mergeRequestParams(
    params1: AxiosRequestConfig,
    params2?: AxiosRequestConfig,
  ): AxiosRequestConfig {
    const method = params1.method || (params2 && params2.method);

    return {
      ...this.instance.defaults,
      ...params1,
      ...(params2 || {}),
      headers: {
        ...((method &&
          this.instance.defaults.headers[
            method.toLowerCase() as keyof HeadersDefaults
          ]) ||
          {}),
        ...(params1.headers || {}),
        ...((params2 && params2.headers) || {}),
      },
    };
  }

  protected stringifyFormItem(formItem: unknown) {
    if (typeof formItem === "object" && formItem !== null) {
      return JSON.stringify(formItem);
    } else {
      return `${formItem}`;
    }
  }

  protected createFormData(input: Record<string, unknown>): FormData {
    if (input instanceof FormData) {
      return input;
    }
    return Object.keys(input || {}).reduce((formData, key) => {
      const property = input[key];
      const propertyContent: any[] =
        property instanceof Array ? property : [property];

      for (const formItem of propertyContent) {
        const isFileType = formItem instanceof Blob || formItem instanceof File;
        formData.append(
          key,
          isFileType ? formItem : this.stringifyFormItem(formItem),
        );
      }

      return formData;
    }, new FormData());
  }

  public request = async <T = any, _E = any>({
    secure,
    path,
    type,
    query,
    format,
    body,
    ...params
  }: FullRequestParams): Promise<AxiosResponse<T>> => {
    const secureParams =
      ((typeof secure === "boolean" ? secure : this.secure) &&
        this.securityWorker &&
        (await this.securityWorker(this.securityData))) ||
      {};
    const requestParams = this.mergeRequestParams(params, secureParams);
    const responseFormat = format || this.format || undefined;

    if (
      type === ContentType.FormData &&
      body &&
      body !== null &&
      typeof body === "object"
    ) {
      body = this.createFormData(body as Record<string, unknown>);
    }

    if (
      type === ContentType.Text &&
      body &&
      body !== null &&
      typeof body !== "string"
    ) {
      body = JSON.stringify(body);
    }

    return this.instance.request({
      ...requestParams,
      headers: {
        ...(requestParams.headers || {}),
        ...(type ? { "Content-Type": type } : {}),
      },
      params: query,
      responseType: responseFormat,
      data: body,
      url: path,
    });
  };
}

/**
 * @title Lavva API
 * @version v1
 */
export class Api<SecurityDataType extends unknown> {
  http: HttpClient<SecurityDataType>;

  constructor(http: HttpClient<SecurityDataType>) {
    this.http = http;
  }

  batchControl = {
    /**
     * No description
     *
     * @tags BatchControl
     * @name BatchControlBatch
     * @request POST:/batchControl/batch
     * @secure
     */
    batchControlBatch: (
      data: BatchControlRequest,
      params: RequestParams = {},
    ) =>
      this.http.request<BatchControlBatchData, void>({
        path: `/batchControl/batch`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),
  };
  binarySensor = {
    /**
     * No description
     *
     * @tags BinarySensor
     * @name BinarySensorConfigure
     * @request POST:/binarySensor/configure
     * @secure
     */
    binarySensorConfigure: (
      data: ConfigureBinarySensorRequest,
      params: RequestParams = {},
    ) =>
      this.http.request<BinarySensorConfigureData, void>({
        path: `/binarySensor/configure`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        ...params,
      }),
  };
  blind = {
    /**
     * No description
     *
     * @tags Blind
     * @name BlindCalibrateStatus
     * @request GET:/blind/calibrateStatus
     * @secure
     */
    blindCalibrateStatus: (
      query: {
        /** @format uuid */
        channelId?: string;
      },
      params: RequestParams = {},
    ) =>
      this.http.request<BlindCalibrateStatusData, void>({
        path: `/blind/calibrateStatus`,
        method: "GET",
        query: query,
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Blind
     * @name BlindSetPosition
     * @request POST:/blind/setPosition
     * @secure
     */
    blindSetPosition: (data: SetPositionRequest, params: RequestParams = {}) =>
      this.http.request<BlindSetPositionData, void>({
        path: `/blind/setPosition`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Blind
     * @name BlindSetDirection
     * @request POST:/blind/setDirection
     * @secure
     */
    blindSetDirection: (
      data: SetDirectionRequest,
      params: RequestParams = {},
    ) =>
      this.http.request<BlindSetDirectionData, void>({
        path: `/blind/setDirection`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Blind
     * @name BlindSetSensitivity
     * @request POST:/blind/setSensitivity
     * @secure
     */
    blindSetSensitivity: (
      data: SetSensitivityRequest,
      params: RequestParams = {},
    ) =>
      this.http.request<BlindSetSensitivityData, BlindSetSensitivityError>({
        path: `/blind/setSensitivity`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        ...params,
      }),

    /**
     * No description
     *
     * @tags Blind
     * @name BlindCalibrate
     * @request POST:/blind/calibrate
     * @secure
     */
    blindCalibrate: (data: CalibrateRequest, params: RequestParams = {}) =>
      this.http.request<BlindCalibrateData, BlindCalibrateError>({
        path: `/blind/calibrate`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Blind
     * @name BlindCalibrateManually
     * @request POST:/blind/calibrateManually
     * @secure
     */
    blindCalibrateManually: (
      data: ManuallyCalibrateRequest,
      params: RequestParams = {},
    ) =>
      this.http.request<
        BlindCalibrateManuallyData,
        BlindCalibrateManuallyError
      >({
        path: `/blind/calibrateManually`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Blind
     * @name BlindSwapOut
     * @request POST:/blind/swapOut
     * @secure
     */
    blindSwapOut: (data: SwapOutRequest, params: RequestParams = {}) =>
      this.http.request<BlindSwapOutData, void>({
        path: `/blind/swapOut`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),
  };
  brokerInfo = {
    /**
     * No description
     *
     * @tags BrokerInfo
     * @name BrokerInfoState
     * @request GET:/brokerInfo/state
     * @secure
     */
    brokerInfoState: (params: RequestParams = {}) =>
      this.http.request<BrokerInfoStateData, void>({
        path: `/brokerInfo/state`,
        method: "GET",
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags BrokerInfo
     * @name BrokerInfoInstallationCount
     * @request GET:/brokerInfo/installationCount
     * @secure
     */
    brokerInfoInstallationCount: (
      query: {
        /** @format int32 */
        brokerId?: number;
      },
      params: RequestParams = {},
    ) =>
      this.http.request<BrokerInfoInstallationCountData, void>({
        path: `/brokerInfo/installationCount`,
        method: "GET",
        query: query,
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags BrokerInfo
     * @name BrokerInfoAverageConnectionTime
     * @request GET:/brokerInfo/averageConnectionTime
     * @secure
     */
    brokerInfoAverageConnectionTime: (params: RequestParams = {}) =>
      this.http.request<BrokerInfoAverageConnectionTimeData, void>({
        path: `/brokerInfo/averageConnectionTime`,
        method: "GET",
        secure: true,
        ...params,
      }),

    /**
     * No description
     *
     * @tags BrokerInfo
     * @name BrokerInfoNextBrokers
     * @request GET:/brokerInfo/nextBrokers/{count}
     * @secure
     */
    brokerInfoNextBrokers: (count: number, params: RequestParams = {}) =>
      this.http.request<BrokerInfoNextBrokersData, void>({
        path: `/brokerInfo/nextBrokers/${count}`,
        method: "GET",
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags BrokerInfo
     * @name BrokerInfoInstallationInfo
     * @request GET:/brokerInfo/installationInfo
     * @secure
     */
    brokerInfoInstallationInfo: (
      query: {
        /** @format int32 */
        brokerId?: number;
      },
      params: RequestParams = {},
    ) =>
      this.http.request<BrokerInfoInstallationInfoData, void>({
        path: `/brokerInfo/installationInfo`,
        method: "GET",
        query: query,
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags BrokerInfo
     * @name BrokerInfoDisboundedInstallations
     * @request GET:/brokerInfo/disboundedInstallations
     * @secure
     */
    brokerInfoDisboundedInstallations: (params: RequestParams = {}) =>
      this.http.request<BrokerInfoDisboundedInstallationsData, void>({
        path: `/brokerInfo/disboundedInstallations`,
        method: "GET",
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags BrokerInfo
     * @name BrokerInfoDisboundInstallations
     * @request POST:/brokerInfo/disboundInstallations
     * @secure
     */
    brokerInfoDisboundInstallations: (
      data: BrokerInfoDisboundInstallationsPayload,
      params: RequestParams = {},
    ) =>
      this.http.request<BrokerInfoDisboundInstallationsData, void>({
        path: `/brokerInfo/disboundInstallations`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        ...params,
      }),

    /**
     * No description
     *
     * @tags BrokerInfo
     * @name BrokerInfoDisboundEmptyInstallations
     * @request POST:/brokerInfo/disboundEmptyInstallations
     * @secure
     */
    brokerInfoDisboundEmptyInstallations: (params: RequestParams = {}) =>
      this.http.request<BrokerInfoDisboundEmptyInstallationsData, void>({
        path: `/brokerInfo/disboundEmptyInstallations`,
        method: "POST",
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags BrokerInfo
     * @name BrokerInfoExalusInstallationInfo
     * @request GET:/brokerInfo/exalusInstallationInfo
     * @secure
     */
    brokerInfoExalusInstallationInfo: (params: RequestParams = {}) =>
      this.http.request<BrokerInfoExalusInstallationInfoData, void>({
        path: `/brokerInfo/exalusInstallationInfo`,
        method: "GET",
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags BrokerInfo
     * @name BrokerInfoByMacAddress
     * @request GET:/brokerInfo/byMacAddress/{macAddress}
     * @secure
     */
    brokerInfoByMacAddress: (macAddress: string, params: RequestParams = {}) =>
      this.http.request<BrokerInfoByMacAddressData, void>({
        path: `/brokerInfo/byMacAddress/${macAddress}`,
        method: "GET",
        secure: true,
        ...params,
      }),

    /**
     * No description
     *
     * @tags BrokerInfo
     * @name BrokerInfoByInstallationId
     * @request GET:/brokerInfo/byInstallationId/{installationId}
     * @secure
     */
    brokerInfoByInstallationId: (
      installationId: string,
      params: RequestParams = {},
    ) =>
      this.http.request<BrokerInfoByInstallationIdData, void>({
        path: `/brokerInfo/byInstallationId/${installationId}`,
        method: "GET",
        secure: true,
        ...params,
      }),

    /**
     * No description
     *
     * @tags BrokerInfo
     * @name BrokerInfoInstallationFullInfo
     * @request GET:/brokerInfo/installationFullInfo
     * @secure
     */
    brokerInfoInstallationFullInfo: (
      query: {
        /** @format uuid */
        installationId?: string;
      },
      params: RequestParams = {},
    ) =>
      this.http.request<BrokerInfoInstallationFullInfoData, void>({
        path: `/brokerInfo/installationFullInfo`,
        method: "GET",
        query: query,
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags BrokerInfo
     * @name BrokerInfoResetConfigurationChecksum
     * @request POST:/brokerInfo/resetConfigurationChecksum
     * @secure
     */
    brokerInfoResetConfigurationChecksum: (
      data: ResetConfigurationChecksumRequest,
      params: RequestParams = {},
    ) =>
      this.http.request<BrokerInfoResetConfigurationChecksumData, void>({
        path: `/brokerInfo/resetConfigurationChecksum`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        ...params,
      }),

    /**
     * No description
     *
     * @tags BrokerInfo
     * @name BrokerInfoKnedlikyManeveur
     * @request POST:/brokerInfo/knedlikyManeveur
     * @secure
     */
    brokerInfoKnedlikyManeveur: (
      data: HardResetConfigurationChecksumRequest,
      params: RequestParams = {},
    ) =>
      this.http.request<BrokerInfoKnedlikyManeveurData, void>({
        path: `/brokerInfo/knedlikyManeveur`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        ...params,
      }),

    /**
     * No description
     *
     * @tags BrokerInfo
     * @name BrokerInfoResetToDefaults
     * @request POST:/brokerInfo/resetToDefaults
     * @secure
     */
    brokerInfoResetToDefaults: (
      data: ResetToDefaultsRequest,
      params: RequestParams = {},
    ) =>
      this.http.request<BrokerInfoResetToDefaultsData, void>({
        path: `/brokerInfo/resetToDefaults`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        ...params,
      }),
  };
  clusteringIntegration = {
    /**
     * No description
     *
     * @tags ClusteringIntegration
     * @name ClusteringIntegrationMeters
     * @request GET:/clusteringIntegration/{installationId}/meters
     * @secure
     */
    clusteringIntegrationMeters: (
      installationId: string,
      params: RequestParams = {},
    ) =>
      this.http.request<ClusteringIntegrationMetersData, void>({
        path: `/clusteringIntegration/${installationId}/meters`,
        method: "GET",
        secure: true,
        ...params,
      }),

    /**
     * No description
     *
     * @tags ClusteringIntegration
     * @name ClusteringIntegrationMetersdata
     * @request POST:/clusteringIntegration/meters/data
     * @secure
     */
    clusteringIntegrationMetersdata: (
      data: GetMetersDataRequest,
      params: RequestParams = {},
    ) =>
      this.http.request<ClusteringIntegrationMetersdataData, void>({
        path: `/clusteringIntegration/meters/data`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags ClusteringIntegration
     * @name ClusteringIntegrationMetersaggregatedData
     * @request POST:/clusteringIntegration/meters/aggregatedData
     * @secure
     */
    clusteringIntegrationMetersaggregatedData: (
      data: GetMetersDataRequest,
      params: RequestParams = {},
    ) =>
      this.http.request<ClusteringIntegrationMetersaggregatedDataData, void>({
        path: `/clusteringIntegration/meters/aggregatedData`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags ClusteringIntegration
     * @name ClusteringIntegrationMetersdatasingle
     * @request POST:/clusteringIntegration/meters/data/single
     * @secure
     */
    clusteringIntegrationMetersdatasingle: (
      data: GetSingleMeterDataRequest,
      params: RequestParams = {},
    ) =>
      this.http.request<ClusteringIntegrationMetersdatasingleData, void>({
        path: `/clusteringIntegration/meters/data/single`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        ...params,
      }),

    /**
     * No description
     *
     * @tags ClusteringIntegration
     * @name ClusteringIntegrationDynamicMarketPrices
     * @request GET:/clusteringIntegration/dynamicMarketPrices
     * @secure
     */
    clusteringIntegrationDynamicMarketPrices: (params: RequestParams = {}) =>
      this.http.request<ClusteringIntegrationDynamicMarketPricesData, void>({
        path: `/clusteringIntegration/dynamicMarketPrices`,
        method: "GET",
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags ClusteringIntegration
     * @name ClusteringIntegrationInstallations
     * @request GET:/clusteringIntegration/installations/{id}
     * @secure
     */
    clusteringIntegrationInstallations: (
      id: string,
      params: RequestParams = {},
    ) =>
      this.http.request<ClusteringIntegrationInstallationsData, void>({
        path: `/clusteringIntegration/installations/${id}`,
        method: "GET",
        secure: true,
        ...params,
      }),
  };
  csvExport = {
    /**
     * No description
     *
     * @tags CsvExport
     * @name CsvExportOrder
     * @request POST:/csvExport/order/{meterId}
     * @secure
     */
    csvExportOrder: (meterId: string, params: RequestParams = {}) =>
      this.http.request<CsvExportOrderData, CsvExportOrderError>({
        path: `/csvExport/order/${meterId}`,
        method: "POST",
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags CsvExport
     * @name CsvExportDownload
     * @request GET:/csvExport/download/{exportId}
     * @secure
     */
    csvExportDownload: (exportId: string, params: RequestParams = {}) =>
      this.http.request<CsvExportDownloadData, CsvExportDownloadError>({
        path: `/csvExport/download/${exportId}`,
        method: "GET",
        secure: true,
        format: "json",
        ...params,
      }),
  };
  debug = {
    /**
     * No description
     *
     * @tags Debug
     * @name DebugDumpInstallations
     * @request POST:/debug/dumpInstallations
     * @secure
     */
    debugDumpInstallations: (
      data: DumpInstallationsRequest,
      params: RequestParams = {},
    ) =>
      this.http.request<DebugDumpInstallationsData, void>({
        path: `/debug/dumpInstallations`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        ...params,
      }),

    /**
     * No description
     *
     * @tags Debug
     * @name DebugLiveMetrics
     * @request POST:/debug/liveMetrics
     * @secure
     */
    debugLiveMetrics: (data: SecretRequest, params: RequestParams = {}) =>
      this.http.request<DebugLiveMetricsData, void>({
        path: `/debug/liveMetrics`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        ...params,
      }),

    /**
     * No description
     *
     * @tags Debug
     * @name DebugPublishTester
     * @request POST:/debug/publishTester
     * @secure
     */
    debugPublishTester: (
      data: PublishTestRequest,
      params: RequestParams = {},
    ) =>
      this.http.request<DebugPublishTesterData, void>({
        path: `/debug/publishTester`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        ...params,
      }),

    /**
     * No description
     *
     * @tags Debug
     * @name DebugGetWorkloadProtocolVersion
     * @request POST:/debug/getWorkloadProtocolVersion
     * @secure
     */
    debugGetWorkloadProtocolVersion: (
      data: SecretRequest,
      params: RequestParams = {},
    ) =>
      this.http.request<DebugGetWorkloadProtocolVersionData, void>({
        path: `/debug/getWorkloadProtocolVersion`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        ...params,
      }),

    /**
     * No description
     *
     * @tags Debug
     * @name DebugSetWorkloadProtocolVersion
     * @request POST:/debug/setWorkloadProtocolVersion
     * @secure
     */
    debugSetWorkloadProtocolVersion: (
      data: SetWorkloadProtocolVersionRequest,
      params: RequestParams = {},
    ) =>
      this.http.request<DebugSetWorkloadProtocolVersionData, void>({
        path: `/debug/setWorkloadProtocolVersion`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        ...params,
      }),
  };
  device = {
    /**
     * No description
     *
     * @tags Device
     * @name DeviceCredentials
     * @request GET:/device/credentials
     * @secure
     */
    deviceCredentials: (params: RequestParams = {}) =>
      this.http.request<DeviceCredentialsData, void>({
        path: `/device/credentials`,
        method: "GET",
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Device
     * @name DeviceGet
     * @request GET:/device/get
     * @secure
     */
    deviceGet: (
      query: {
        /** @format uuid */
        deviceId?: string;
      },
      params: RequestParams = {},
    ) =>
      this.http.request<DeviceGetData, DeviceGetError>({
        path: `/device/get`,
        method: "GET",
        query: query,
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Device
     * @name DeviceFilter
     * @request GET:/device/filter
     * @secure
     */
    deviceFilter: (params: RequestParams = {}) =>
      this.http.request<DeviceFilterData, void>({
        path: `/device/filter`,
        method: "GET",
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Device
     * @name DeviceConnectToNetwork
     * @request POST:/device/connectToNetwork
     * @secure
     */
    deviceConnectToNetwork: (
      data: ConnectToNetworkRequest,
      params: RequestParams = {},
    ) =>
      this.http.request<DeviceConnectToNetworkData, void>({
        path: `/device/connectToNetwork`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Device
     * @name DeviceConnectToUnknownNetwork
     * @request POST:/device/connectToUnknownNetwork
     * @secure
     */
    deviceConnectToUnknownNetwork: (
      data: ConnectToUnknownNetworkRequest,
      params: RequestParams = {},
    ) =>
      this.http.request<DeviceConnectToUnknownNetworkData, void>({
        path: `/device/connectToUnknownNetwork`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Device
     * @name DeviceUpdateFirmware
     * @request POST:/device/updateFirmware
     * @secure
     */
    deviceUpdateFirmware: (
      data: GenericDeviceRequest,
      params: RequestParams = {},
    ) =>
      this.http.request<DeviceUpdateFirmwareData, void>({
        path: `/device/updateFirmware`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Device
     * @name DeviceSetDeviceName
     * @request POST:/device/setDeviceName
     * @secure
     */
    deviceSetDeviceName: (
      data: SetDeviceNameRequest,
      params: RequestParams = {},
    ) =>
      this.http.request<DeviceSetDeviceNameData, void>({
        path: `/device/setDeviceName`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Device
     * @name DeviceSetChannelName
     * @request POST:/device/setChannelName
     * @secure
     */
    deviceSetChannelName: (
      data: SetChannelNameRequest,
      params: RequestParams = {},
    ) =>
      this.http.request<DeviceSetChannelNameData, void>({
        path: `/device/setChannelName`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Device
     * @name DeviceSwapIn
     * @request POST:/device/swapIn
     * @secure
     */
    deviceSwapIn: (data: SwapInRequest, params: RequestParams = {}) =>
      this.http.request<DeviceSwapInData, DeviceSwapInError>({
        path: `/device/swapIn`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Device
     * @name DeviceFactoryReset
     * @request POST:/device/factoryReset
     * @secure
     */
    deviceFactoryReset: (
      data: FactoryResetRequest,
      params: RequestParams = {},
    ) =>
      this.http.request<DeviceFactoryResetData, void>({
        path: `/device/factoryReset`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Device
     * @name DeviceGetWifiNetworks
     * @request POST:/device/getWifiNetworks
     * @secure
     */
    deviceGetWifiNetworks: (
      data: GetWifiNetworksRequest,
      params: RequestParams = {},
    ) =>
      this.http.request<DeviceGetWifiNetworksData, void>({
        path: `/device/getWifiNetworks`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Device
     * @name DeviceGetWifiNetworksBatch
     * @request GET:/device/getWifiNetworksBatch
     * @secure
     */
    deviceGetWifiNetworksBatch: (params: RequestParams = {}) =>
      this.http.request<DeviceGetWifiNetworksBatchData, void>({
        path: `/device/getWifiNetworksBatch`,
        method: "GET",
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Device
     * @name DeviceConnectToUnknownNetworkBatch
     * @request POST:/device/connectToUnknownNetworkBatch
     * @secure
     */
    deviceConnectToUnknownNetworkBatch: (
      data: ConnectToUnknownNetworkRequestBatch,
      params: RequestParams = {},
    ) =>
      this.http.request<DeviceConnectToUnknownNetworkBatchData, void>({
        path: `/device/connectToUnknownNetworkBatch`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Device
     * @name DeviceRestart
     * @request POST:/device/restart
     * @secure
     */
    deviceRestart: (data: RestartDeviceRequest, params: RequestParams = {}) =>
      this.http.request<DeviceRestartData, void>({
        path: `/device/restart`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Device
     * @name DeviceResetToDefaults
     * @request POST:/device/resetToDefaults
     * @secure
     */
    deviceResetToDefaults: (
      data: ResetToDefaultsRequest,
      params: RequestParams = {},
    ) =>
      this.http.request<DeviceResetToDefaultsData, void>({
        path: `/device/resetToDefaults`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Device
     * @name DeviceSetActionBindings
     * @request POST:/device/setActionBindings
     * @secure
     */
    deviceSetActionBindings: (
      data: SetActionBindingsRequest,
      params: RequestParams = {},
    ) =>
      this.http.request<
        DeviceSetActionBindingsData,
        DeviceSetActionBindingsError
      >({
        path: `/device/setActionBindings`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        ...params,
      }),
  };
  deviceLogs = {
    /**
     * No description
     *
     * @tags DeviceLogs
     * @name DeviceLogsLog
     * @request POST:/deviceLogs/log
     * @secure
     */
    deviceLogsLog: (data: DeviceLog, params: RequestParams = {}) =>
      this.http.request<DeviceLogsLogData, void>({
        path: `/deviceLogs/log`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        ...params,
      }),
  };
  deviceUpdate = {
    /**
     * No description
     *
     * @tags DeviceUpdate
     * @name DeviceUpdateDetail
     * @request GET:/deviceUpdate/{installationId}
     */
    deviceUpdateDetail: (installationId: string, params: RequestParams = {}) =>
      this.http.request<DeviceUpdateDetailData, any>({
        path: `/deviceUpdate/${installationId}`,
        method: "GET",
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags DeviceUpdate
     * @name DeviceUpdateCreate
     * @request POST:/deviceUpdate
     */
    deviceUpdateCreate: (
      data: ForceUpdateRequest,
      params: RequestParams = {},
    ) =>
      this.http.request<DeviceUpdateCreateData, any>({
        path: `/deviceUpdate`,
        method: "POST",
        body: data,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags DeviceUpdate
     * @name DeviceUpdateForceRestart
     * @request POST:/deviceUpdate/forceRestart
     */
    deviceUpdateForceRestart: (
      data: ForceRestartRequest,
      params: RequestParams = {},
    ) =>
      this.http.request<DeviceUpdateForceRestartData, any>({
        path: `/deviceUpdate/forceRestart`,
        method: "POST",
        body: data,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),
  };
  export = {
    /**
     * No description
     *
     * @tags Export
     * @name ExportMeters
     * @request GET:/export/meters
     * @secure
     */
    exportMeters: (params: RequestParams = {}) =>
      this.http.request<ExportMetersData, void>({
        path: `/export/meters`,
        method: "GET",
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Export
     * @name ExportData
     * @request GET:/export/data/{id}/{paramSet}
     * @secure
     */
    exportData: (id: string, paramSet: number, params: RequestParams = {}) =>
      this.http.request<ExportDataData, void>({
        path: `/export/data/${id}/${paramSet}`,
        method: "GET",
        secure: true,
        ...params,
      }),

    /**
     * No description
     *
     * @tags Export
     * @name ExportInternalData
     * @request GET:/export/internalData/{id}
     * @secure
     */
    exportInternalData: (id: string, params: RequestParams = {}) =>
      this.http.request<ExportInternalDataData, void>({
        path: `/export/internalData/${id}`,
        method: "GET",
        secure: true,
        ...params,
      }),

    /**
     * No description
     *
     * @tags Export
     * @name ExportPlugData
     * @request GET:/export/plugData/{id}
     * @secure
     */
    exportPlugData: (id: string, params: RequestParams = {}) =>
      this.http.request<ExportPlugDataData, void>({
        path: `/export/plugData/${id}`,
        method: "GET",
        secure: true,
        ...params,
      }),
  };
  gate = {
    /**
     * No description
     *
     * @tags Gate
     * @name GateStepByStep
     * @request POST:/gate/stepByStep
     * @secure
     */
    gateStepByStep: (data: GateStepByStepRequest, params: RequestParams = {}) =>
      this.http.request<GateStepByStepData, void>({
        path: `/gate/stepByStep`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Gate
     * @name GateTilt
     * @request POST:/gate/tilt
     * @secure
     */
    gateTilt: (data: GateTiltRequest, params: RequestParams = {}) =>
      this.http.request<GateTiltData, void>({
        path: `/gate/tilt`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Gate
     * @name GateSetPosition
     * @request POST:/gate/setPosition
     * @secure
     */
    gateSetPosition: (
      data: GateSetPositionRequest,
      params: RequestParams = {},
    ) =>
      this.http.request<GateSetPositionData, void>({
        path: `/gate/setPosition`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Gate
     * @name GateSetDirection
     * @request POST:/gate/setDirection
     * @secure
     */
    gateSetDirection: (
      data: GateSetDirectionRequest,
      params: RequestParams = {},
    ) =>
      this.http.request<GateSetDirectionData, void>({
        path: `/gate/setDirection`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Gate
     * @name GateSetSbsSignalTime
     * @request POST:/gate/setSbsSignalTime
     * @secure
     */
    gateSetSbsSignalTime: (
      data: GateSetSbsSignalTimeRequest,
      params: RequestParams = {},
    ) =>
      this.http.request<GateSetSbsSignalTimeData, GateSetSbsSignalTimeError>({
        path: `/gate/setSbsSignalTime`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        ...params,
      }),

    /**
     * No description
     *
     * @tags Gate
     * @name GateSetPartialControlMode
     * @request POST:/gate/setPartialControlMode
     * @secure
     */
    gateSetPartialControlMode: (
      data: GateSetPartialControlModeStateRequest,
      params: RequestParams = {},
    ) =>
      this.http.request<
        GateSetPartialControlModeData,
        GateSetPartialControlModeError
      >({
        path: `/gate/setPartialControlMode`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        ...params,
      }),

    /**
     * No description
     *
     * @tags Gate
     * @name GateSetDailyMode
     * @request POST:/gate/setDailyMode
     * @secure
     */
    gateSetDailyMode: (
      data: GateSetDailyModeStateRequest,
      params: RequestParams = {},
    ) =>
      this.http.request<GateSetDailyModeData, GateSetDailyModeError>({
        path: `/gate/setDailyMode`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        ...params,
      }),

    /**
     * No description
     *
     * @tags Gate
     * @name GateSetPartialSbsSignalTime
     * @request POST:/gate/setPartialSbsSignalTime
     * @secure
     */
    gateSetPartialSbsSignalTime: (
      data: GateSetPartialSbsSignalTimeRequest,
      params: RequestParams = {},
    ) =>
      this.http.request<
        GateSetPartialSbsSignalTimeData,
        GateSetPartialSbsSignalTimeError
      >({
        path: `/gate/setPartialSbsSignalTime`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        ...params,
      }),

    /**
     * No description
     *
     * @tags Gate
     * @name GateSetTiltTime
     * @request POST:/gate/setTiltTime
     * @secure
     */
    gateSetTiltTime: (
      data: GateSetTiltTimeRequest,
      params: RequestParams = {},
    ) =>
      this.http.request<GateSetTiltTimeData, GateSetTiltTimeError>({
        path: `/gate/setTiltTime`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        ...params,
      }),

    /**
     * No description
     *
     * @tags Gate
     * @name GateSetAlertConfig
     * @request POST:/gate/setAlertConfig
     * @secure
     */
    gateSetAlertConfig: (
      data: GateSetAlertConfigRequest,
      params: RequestParams = {},
    ) =>
      this.http.request<GateSetAlertConfigData, GateSetAlertConfigError>({
        path: `/gate/setAlertConfig`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        ...params,
      }),

    /**
     * No description
     *
     * @tags Gate
     * @name GateSetNegativeOutput
     * @request POST:/gate/setNegativeOutput
     * @secure
     */
    gateSetNegativeOutput: (
      data: GateSetNegativeOutputRequest,
      params: RequestParams = {},
    ) =>
      this.http.request<GateSetNegativeOutputData, GateSetNegativeOutputError>({
        path: `/gate/setNegativeOutput`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        ...params,
      }),

    /**
     * No description
     *
     * @tags Gate
     * @name GateCalibrate
     * @request POST:/gate/calibrate
     * @secure
     */
    gateCalibrate: (data: GateCalibrateRequest, params: RequestParams = {}) =>
      this.http.request<GateCalibrateData, void>({
        path: `/gate/calibrate`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),
  };
  genericInput = {
    /**
     * No description
     *
     * @tags GenericInput
     * @name GenericInputSetInputType
     * @request POST:/genericInput/setInputType
     * @secure
     */
    genericInputSetInputType: (
      data: SetInputTypeRequest,
      params: RequestParams = {},
    ) =>
      this.http.request<
        GenericInputSetInputTypeData,
        GenericInputSetInputTypeError
      >({
        path: `/genericInput/setInputType`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        ...params,
      }),

    /**
     * No description
     *
     * @tags GenericInput
     * @name GenericInputSetInputTypesBatch
     * @request POST:/genericInput/setInputTypesBatch
     * @secure
     */
    genericInputSetInputTypesBatch: (
      data: SetInputTypesBatchRequest,
      params: RequestParams = {},
    ) =>
      this.http.request<
        GenericInputSetInputTypesBatchData,
        GenericInputSetInputTypesBatchError
      >({
        path: `/genericInput/setInputTypesBatch`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        ...params,
      }),
  };
  installation = {
    /**
     * No description
     *
     * @tags Installation
     * @name InstallationChannels
     * @request GET:/installation/channels
     * @secure
     */
    installationChannels: (
      query: {
        /** <p>Members:</p><ul><li>1: Switch</li><li>2: Blind</li><li>4: Gate</li><li>8: Light</li><li>16: Hvac</li><li>32: Sensor</li><li>64: BinarySensor</li><li>128: GenericInput</li><li>256: Meter</li><li>512: Optimizer</li></ul> */
        channelTypes?: ChannelTypesFlag;
      },
      params: RequestParams = {},
    ) =>
      this.http.request<InstallationChannelsData, void>({
        path: `/installation/channels`,
        method: "GET",
        query: query,
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Installation
     * @name InstallationRegister
     * @request POST:/installation/register
     * @secure
     */
    installationRegister: (
      data: RegisterInstallationRequest,
      params: RequestParams = {},
    ) =>
      this.http.request<InstallationRegisterData, void>({
        path: `/installation/register`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Installation
     * @name InstallationSetTimeZone
     * @request POST:/installation/setTimeZone
     * @secure
     */
    installationSetTimeZone: (
      data: SetInstallationTimeZoneRequest,
      params: RequestParams = {},
    ) =>
      this.http.request<InstallationSetTimeZoneData, void>({
        path: `/installation/setTimeZone`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        ...params,
      }),

    /**
     * No description
     *
     * @tags Installation
     * @name InstallationSetGeolocation
     * @request POST:/installation/setGeolocation
     * @secure
     */
    installationSetGeolocation: (
      data: SetInstallationGeolocationRequest,
      params: RequestParams = {},
    ) =>
      this.http.request<InstallationSetGeolocationData, void>({
        path: `/installation/setGeolocation`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        ...params,
      }),

    /**
     * No description
     *
     * @tags Installation
     * @name InstallationDelete
     * @request DELETE:/installation
     * @secure
     */
    installationDelete: (params: RequestParams = {}) =>
      this.http.request<InstallationDeleteData, void>({
        path: `/installation`,
        method: "DELETE",
        secure: true,
        ...params,
      }),
  };
  brokerInstance = {
    /**
     * No description
     *
     * @tags InstallationBinding
     * @name BrokerInstanceDetail
     * @request GET:/brokerInstance/{installationId}
     */
    brokerInstanceDetail: (
      installationId: string,
      params: RequestParams = {},
    ) =>
      this.http.request<BrokerInstanceDetailData, BrokerInstanceDetailError>({
        path: `/brokerInstance/${installationId}`,
        method: "GET",
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags InstallationBinding
     * @name BrokerInstanceDevice
     * @request GET:/brokerInstance/device/{installationId}
     * @secure
     */
    brokerInstanceDevice: (
      installationId: string,
      params: RequestParams = {},
    ) =>
      this.http.request<BrokerInstanceDeviceData, BrokerInstanceDeviceError>({
        path: `/brokerInstance/device/${installationId}`,
        method: "GET",
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags InstallationBinding
     * @name BrokerInstanceBindToInstallation
     * @request GET:/brokerInstance/bindToInstallation/{installationId}
     * @secure
     */
    brokerInstanceBindToInstallation: (
      installationId: string,
      params: RequestParams = {},
    ) =>
      this.http.request<
        BrokerInstanceBindToInstallationData,
        BrokerInstanceBindToInstallationError
      >({
        path: `/brokerInstance/bindToInstallation/${installationId}`,
        method: "GET",
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags InstallationBinding
     * @name BrokerInstanceDevicebyDiscovery
     * @request GET:/brokerInstance/device/byDiscovery/{installationId}
     * @secure
     */
    brokerInstanceDevicebyDiscovery: (
      installationId: string,
      params: RequestParams = {},
    ) =>
      this.http.request<
        BrokerInstanceDevicebyDiscoveryData,
        BrokerInstanceDevicebyDiscoveryError
      >({
        path: `/brokerInstance/device/byDiscovery/${installationId}`,
        method: "GET",
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags InstallationBinding
     * @name BrokerInstanceAllBindings
     * @request GET:/brokerInstance/allBindings
     * @secure
     */
    brokerInstanceAllBindings: (
      query: {
        /** @format int32 */
        page?: number;
        /** @format int32 */
        pageSize?: number;
      },
      params: RequestParams = {},
    ) =>
      this.http.request<
        BrokerInstanceAllBindingsData,
        BrokerInstanceAllBindingsError
      >({
        path: `/brokerInstance/allBindings`,
        method: "GET",
        query: query,
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags InstallationBinding
     * @name BrokerInstanceBindToInstallationbyDiscovery
     * @request GET:/brokerInstance/bindToInstallation/byDiscovery/{installationId}
     * @secure
     */
    brokerInstanceBindToInstallationbyDiscovery: (
      {
        installationId,
        ...query
      }: {
        /** @format uuid */
        deviceId?: string;
        /** @format uuid */
        installationId: string;
      },
      params: RequestParams = {},
    ) =>
      this.http.request<
        BrokerInstanceBindToInstallationbyDiscoveryData,
        BrokerInstanceBindToInstallationbyDiscoveryError
      >({
        path: `/brokerInstance/bindToInstallation/byDiscovery/${installationId}`,
        method: "GET",
        query: query,
        secure: true,
        format: "json",
        ...params,
      }),
  };
  installationBinding = {
    /**
     * No description
     *
     * @tags InstallationBinding
     * @name InstallationBindingRebind
     * @request POST:/installationBinding/rebind/{installationId}/{brokerId}
     * @secure
     */
    installationBindingRebind: (
      installationId: string,
      brokerId: number,
      params: RequestParams = {},
    ) =>
      this.http.request<any, InstallationBindingRebindError>({
        path: `/installationBinding/rebind/${installationId}/${brokerId}`,
        method: "POST",
        secure: true,
        ...params,
      }),

    /**
     * No description
     *
     * @tags InstallationBinding
     * @name InstallationBindingRebindRandom
     * @request POST:/installationBinding/rebindRandom
     * @secure
     */
    installationBindingRebindRandom: (
      data: RebindRandomInstallationsRequest,
      params: RequestParams = {},
    ) =>
      this.http.request<InstallationBindingRebindRandomData, void>({
        path: `/installationBinding/rebindRandom`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags InstallationBinding
     * @name InstallationBindingAttach
     * @request POST:/installationBinding/attach/{installationId}
     * @secure
     */
    installationBindingAttach: (
      installationId: string,
      params: RequestParams = {},
    ) =>
      this.http.request<InstallationBindingAttachData, void>({
        path: `/installationBinding/attach/${installationId}`,
        method: "POST",
        secure: true,
        ...params,
      }),

    /**
     * No description
     *
     * @tags InstallationBinding
     * @name InstallationBindingBindAndAttach
     * @request POST:/installationBinding/bindAndAttach/{installationId}
     * @secure
     */
    installationBindingBindAndAttach: (
      installationId: string,
      params: RequestParams = {},
    ) =>
      this.http.request<InstallationBindingBindAndAttachData, void>({
        path: `/installationBinding/bindAndAttach/${installationId}`,
        method: "POST",
        secure: true,
        ...params,
      }),

    /**
     * No description
     *
     * @tags InstallationBinding
     * @name InstallationBindingClearCache
     * @request POST:/installationBinding/clearCache/{installationId}
     * @secure
     */
    installationBindingClearCache: (
      installationId: string,
      params: RequestParams = {},
    ) =>
      this.http.request<InstallationBindingClearCacheData, void>({
        path: `/installationBinding/clearCache/${installationId}`,
        method: "POST",
        secure: true,
        ...params,
      }),
  };
  integrations = {
    /**
     * No description
     *
     * @tags Integration
     * @name IntegrationsInstallations
     * @request GET:/integrations/installations/{userId}/{assistantType}
     * @secure
     */
    integrationsInstallations: (
      userId: string,
      assistantType: AssistantType,
      params: RequestParams = {},
    ) =>
      this.http.request<IntegrationsInstallationsData, void>({
        path: `/integrations/installations/${userId}/${assistantType}`,
        method: "GET",
        secure: true,
        ...params,
      }),

    /**
     * No description
     *
     * @tags Integration
     * @name IntegrationsChannelsWithBroker
     * @request GET:/integrations/channelsWithBroker
     * @secure
     */
    integrationsChannelsWithBroker: (
      data: GetChannelsWithBrokerRequest,
      params: RequestParams = {},
    ) =>
      this.http.request<IntegrationsChannelsWithBrokerData, void>({
        path: `/integrations/channelsWithBroker`,
        method: "GET",
        body: data,
        secure: true,
        type: ContentType.Json,
        ...params,
      }),

    /**
     * No description
     *
     * @tags Integration
     * @name IntegrationsSync
     * @request GET:/integrations/sync
     * @secure
     */
    integrationsSync: (data: SyncOrQueryRequest, params: RequestParams = {}) =>
      this.http.request<IntegrationsSyncData, void>({
        path: `/integrations/sync`,
        method: "GET",
        body: data,
        secure: true,
        type: ContentType.Json,
        ...params,
      }),

    /**
     * No description
     *
     * @tags Integration
     * @name IntegrationsQuery
     * @request GET:/integrations/query
     * @secure
     */
    integrationsQuery: (data: SyncOrQueryRequest, params: RequestParams = {}) =>
      this.http.request<IntegrationsQueryData, void>({
        path: `/integrations/query`,
        method: "GET",
        body: data,
        secure: true,
        type: ContentType.Json,
        ...params,
      }),

    /**
     * No description
     *
     * @tags Integration
     * @name IntegrationsExecute
     * @request POST:/integrations/execute
     * @secure
     */
    integrationsExecute: (data: ExecuteRequest, params: RequestParams = {}) =>
      this.http.request<IntegrationsExecuteData, void>({
        path: `/integrations/execute`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        ...params,
      }),
  };
  light = {
    /**
     * No description
     *
     * @tags Light
     * @name LightToggleOn
     * @request POST:/light/toggleOn
     * @secure
     */
    lightToggleOn: (data: ToggleOnOffRequest, params: RequestParams = {}) =>
      this.http.request<LightToggleOnData, void>({
        path: `/light/toggleOn`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Light
     * @name LightToggleOff
     * @request POST:/light/toggleOff
     * @secure
     */
    lightToggleOff: (data: ToggleOnOffRequest, params: RequestParams = {}) =>
      this.http.request<LightToggleOffData, void>({
        path: `/light/toggleOff`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Light
     * @name LightSetBrightness
     * @request POST:/light/setBrightness
     * @secure
     */
    lightSetBrightness: (
      data: SetBrightnessRequest,
      params: RequestParams = {},
    ) =>
      this.http.request<LightSetBrightnessData, void>({
        path: `/light/setBrightness`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Light
     * @name LightSetTemperature
     * @request POST:/light/setTemperature
     * @secure
     */
    lightSetTemperature: (
      data: SetTemperatureRequest,
      params: RequestParams = {},
    ) =>
      this.http.request<LightSetTemperatureData, void>({
        path: `/light/setTemperature`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Light
     * @name LightSetRgb
     * @request POST:/light/setRgb
     * @secure
     */
    lightSetRgb: (data: SetRgbRequest, params: RequestParams = {}) =>
      this.http.request<LightSetRgbData, void>({
        path: `/light/setRgb`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Light
     * @name LightSupplyReturnBehavior
     * @request POST:/light/supplyReturnBehavior
     * @secure
     */
    lightSupplyReturnBehavior: (
      data: SetSupplyReturnBehaviourRequest,
      params: RequestParams = {},
    ) =>
      this.http.request<
        LightSupplyReturnBehaviorData,
        LightSupplyReturnBehaviorError
      >({
        path: `/light/supplyReturnBehavior`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        ...params,
      }),

    /**
     * No description
     *
     * @tags Light
     * @name LightSetOnTime
     * @request POST:/light/setOnTime
     * @secure
     */
    lightSetOnTime: (data: SetOnTimeRequest, params: RequestParams = {}) =>
      this.http.request<LightSetOnTimeData, void>({
        path: `/light/setOnTime`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),
  };
  meter = {
    /**
     * No description
     *
     * @tags Meter
     * @name MeterCommonMeasurements
     * @request POST:/meter/commonMeasurements
     * @secure
     */
    meterCommonMeasurements: (
      data: GetCommonMeasurementsRequest,
      params: RequestParams = {},
    ) =>
      this.http.request<
        MeterCommonMeasurementsData,
        MeterCommonMeasurementsError
      >({
        path: `/meter/commonMeasurements`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Meter
     * @name MeterCurrentMeasurements
     * @request POST:/meter/currentMeasurements
     * @secure
     */
    meterCurrentMeasurements: (
      data: GetCurrentMeasurementsRequest,
      params: RequestParams = {},
    ) =>
      this.http.request<
        MeterCurrentMeasurementsData,
        MeterCurrentMeasurementsError
      >({
        path: `/meter/currentMeasurements`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Meter
     * @name MeterAggregateMeasurements
     * @request POST:/meter/aggregateMeasurements
     * @secure
     */
    meterAggregateMeasurements: (
      data: GetAggregateMeasurementsRequest,
      params: RequestParams = {},
    ) =>
      this.http.request<
        MeterAggregateMeasurementsData,
        MeterAggregateMeasurementsError
      >({
        path: `/meter/aggregateMeasurements`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Meter
     * @name MeterResetAggregateMeasurements
     * @request POST:/meter/resetAggregateMeasurements
     * @secure
     */
    meterResetAggregateMeasurements: (
      data: ResetAggregateMeasurementsRequest,
      params: RequestParams = {},
    ) =>
      this.http.request<
        MeterResetAggregateMeasurementsData,
        MeterResetAggregateMeasurementsError
      >({
        path: `/meter/resetAggregateMeasurements`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        ...params,
      }),

    /**
     * No description
     *
     * @tags Meter
     * @name MeterSetAmpTransformers
     * @request POST:/meter/setAmpTransformers
     * @secure
     */
    meterSetAmpTransformers: (
      data: SetAmpTransformersRequest,
      params: RequestParams = {},
    ) =>
      this.http.request<
        MeterSetAmpTransformersData,
        MeterSetAmpTransformersError
      >({
        path: `/meter/setAmpTransformers`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        ...params,
      }),

    /**
     * No description
     *
     * @tags Meter
     * @name MeterSetMeterPurpose
     * @request POST:/meter/setMeterPurpose
     * @secure
     */
    meterSetMeterPurpose: (
      data: SetMeterPurposeRequest,
      params: RequestParams = {},
    ) =>
      this.http.request<MeterSetMeterPurposeData, MeterSetMeterPurposeError>({
        path: `/meter/setMeterPurpose`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        ...params,
      }),

    /**
     * No description
     *
     * @tags Meter
     * @name MeterSetMeterParentId
     * @request POST:/meter/setMeterParentId
     * @secure
     */
    meterSetMeterParentId: (
      data: SetMeterParentIdRequest,
      params: RequestParams = {},
    ) =>
      this.http.request<MeterSetMeterParentIdData, MeterSetMeterParentIdError>({
        path: `/meter/setMeterParentId`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        ...params,
      }),

    /**
     * No description
     *
     * @tags Meter
     * @name MeterSetMeterTariff
     * @request POST:/meter/setMeterTariff
     * @secure
     */
    meterSetMeterTariff: (
      data: SetMeterTariffRequest,
      params: RequestParams = {},
    ) =>
      this.http.request<MeterSetMeterTariffData, MeterSetMeterTariffError>({
        path: `/meter/setMeterTariff`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        ...params,
      }),

    /**
     * No description
     *
     * @tags Meter
     * @name MeterSetMeterEventingRules
     * @request POST:/meter/setMeterEventingRules
     * @secure
     */
    meterSetMeterEventingRules: (
      data: SetMeterEventingRulesRequest,
      params: RequestParams = {},
    ) =>
      this.http.request<
        MeterSetMeterEventingRulesData,
        MeterSetMeterEventingRulesError
      >({
        path: `/meter/setMeterEventingRules`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        ...params,
      }),
  };
  metricsRule = {
    /**
     * No description
     *
     * @tags MetricsRule
     * @name MetricsRuleList
     * @request GET:/metricsRule
     * @secure
     */
    metricsRuleList: (params: RequestParams = {}) =>
      this.http.request<MetricsRuleListData, void>({
        path: `/metricsRule`,
        method: "GET",
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags MetricsRule
     * @name MetricsRuleCreate
     * @request POST:/metricsRule
     * @secure
     */
    metricsRuleCreate: (data: MetricsRule, params: RequestParams = {}) =>
      this.http.request<MetricsRuleCreateData, void>({
        path: `/metricsRule`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        ...params,
      }),

    /**
     * No description
     *
     * @tags MetricsRule
     * @name MetricsRulePartialUpdate
     * @request PATCH:/metricsRule
     * @secure
     */
    metricsRulePartialUpdate: (data: MetricsRule, params: RequestParams = {}) =>
      this.http.request<MetricsRulePartialUpdateData, void>({
        path: `/metricsRule`,
        method: "PATCH",
        body: data,
        secure: true,
        type: ContentType.Json,
        ...params,
      }),

    /**
     * No description
     *
     * @tags MetricsRule
     * @name MetricsRuleNotify
     * @request POST:/metricsRule/notify/{ruleId}
     * @secure
     */
    metricsRuleNotify: (ruleId: string, params: RequestParams = {}) =>
      this.http.request<MetricsRuleNotifyData, void>({
        path: `/metricsRule/notify/${ruleId}`,
        method: "POST",
        secure: true,
        ...params,
      }),

    /**
     * No description
     *
     * @tags MetricsRule
     * @name MetricsRuleDelete
     * @request DELETE:/metricsRule/{ruleId}
     * @secure
     */
    metricsRuleDelete: (ruleId: string, params: RequestParams = {}) =>
      this.http.request<MetricsRuleDeleteData, void>({
        path: `/metricsRule/${ruleId}`,
        method: "DELETE",
        secure: true,
        ...params,
      }),
  };
  migrations = {
    /**
     * No description
     *
     * @tags Migration
     * @name MigrationsList
     * @request GET:/migrations
     * @secure
     */
    migrationsList: (params: RequestParams = {}) =>
      this.http.request<MigrationsListData, void>({
        path: `/migrations`,
        method: "GET",
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Migration
     * @name MigrationsGenericInputNames1
     * @request POST:/migrations/GenericInputNames1
     * @secure
     */
    migrationsGenericInputNames1: (
      data: MigrateGenericInputNamesRequest,
      params: RequestParams = {},
    ) =>
      this.http.request<MigrationsGenericInputNames1Data, void>({
        path: `/migrations/GenericInputNames1`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        ...params,
      }),

    /**
     * No description
     *
     * @tags Migration
     * @name MigrationsSwitchFromGateOriginatedHidden
     * @request POST:/migrations/SwitchFromGateOriginatedHidden
     * @secure
     */
    migrationsSwitchFromGateOriginatedHidden: (
      data: MigrateSwitchFromGateOriginatedChannelsRequest,
      params: RequestParams = {},
    ) =>
      this.http.request<MigrationsSwitchFromGateOriginatedHiddenData, void>({
        path: `/migrations/SwitchFromGateOriginatedHidden`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        ...params,
      }),

    /**
     * No description
     *
     * @tags Migration
     * @name MigrationsMigrateAddMissingFavsGroups
     * @request POST:/migrations/MigrateAddMissingFavsGroups
     * @secure
     */
    migrationsMigrateAddMissingFavsGroups: (
      data: MigrateAddMissingFavsGroupsRequest,
      params: RequestParams = {},
    ) =>
      this.http.request<MigrationsMigrateAddMissingFavsGroupsData, void>({
        path: `/migrations/MigrateAddMissingFavsGroups`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        ...params,
      }),

    /**
     * No description
     *
     * @tags Migration
     * @name MigrationsMigrateAddMeterGroups
     * @request POST:/migrations/MigrateAddMeterGroups
     * @secure
     */
    migrationsMigrateAddMeterGroups: (
      data: MigrateAddMeterGroupsRequest,
      params: RequestParams = {},
    ) =>
      this.http.request<MigrationsMigrateAddMeterGroupsData, void>({
        path: `/migrations/MigrateAddMeterGroups`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        ...params,
      }),
  };
  notifications = {
    /**
     * No description
     *
     * @tags Notifications
     * @name NotificationsCreate
     * @request POST:/notifications
     * @secure
     */
    notificationsCreate: (
      data: DemoNotificationRequest,
      params: RequestParams = {},
    ) =>
      this.http.request<NotificationsCreateData, void>({
        path: `/notifications`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        ...params,
      }),

    /**
     * No description
     *
     * @tags Notifications
     * @name NotificationsList
     * @request GET:/notifications
     * @secure
     */
    notificationsList: (params: RequestParams = {}) =>
      this.http.request<NotificationsListData, void>({
        path: `/notifications`,
        method: "GET",
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Notifications
     * @name NotificationsPartialUpdate
     * @request PATCH:/notifications
     * @secure
     */
    notificationsPartialUpdate: (
      data: NotificationMapUpdateRequest,
      params: RequestParams = {},
    ) =>
      this.http.request<NotificationsPartialUpdateData, void>({
        path: `/notifications`,
        method: "PATCH",
        body: data,
        secure: true,
        type: ContentType.Json,
        ...params,
      }),

    /**
     * No description
     *
     * @tags Notifications
     * @name NotificationsBySender
     * @request GET:/notifications/bySender/{senderType}
     * @secure
     */
    notificationsBySender: (
      senderType: NotificationSenderType,
      params: RequestParams = {},
    ) =>
      this.http.request<NotificationsBySenderData, void>({
        path: `/notifications/bySender/${senderType}`,
        method: "GET",
        secure: true,
        ...params,
      }),
  };
  optimizer = {
    /**
     * No description
     *
     * @tags Optimizer
     * @name OptimizerSetMode
     * @request POST:/optimizer/setMode
     * @secure
     */
    optimizerSetMode: (
      data: SetOptimizerModeRequest,
      params: RequestParams = {},
    ) =>
      this.http.request<OptimizerSetModeData, OptimizerSetModeError>({
        path: `/optimizer/setMode`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        ...params,
      }),

    /**
     * No description
     *
     * @tags Optimizer
     * @name OptimizerSetTestModeLoad
     * @request POST:/optimizer/setTestModeLoad
     * @secure
     */
    optimizerSetTestModeLoad: (
      data: SetOptimizerTestModeLoadRequest,
      params: RequestParams = {},
    ) =>
      this.http.request<
        OptimizerSetTestModeLoadData,
        OptimizerSetTestModeLoadError
      >({
        path: `/optimizer/setTestModeLoad`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Optimizer
     * @name OptimizerSetConfig
     * @request POST:/optimizer/setConfig
     * @secure
     */
    optimizerSetConfig: (
      data: SetOptimizerConfigRequest,
      params: RequestParams = {},
    ) =>
      this.http.request<OptimizerSetConfigData, OptimizerSetConfigError>({
        path: `/optimizer/setConfig`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        ...params,
      }),
  };
  recovery = {
    /**
     * No description
     *
     * @tags Recovery
     * @name RecoveryGetDeviceStatus
     * @request POST:/recovery/getDeviceStatus
     * @secure
     */
    recoveryGetDeviceStatus: (
      data: GenericDeviceRequest,
      params: RequestParams = {},
    ) =>
      this.http.request<RecoveryGetDeviceStatusData, void>({
        path: `/recovery/getDeviceStatus`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Recovery
     * @name RecoveryUpdateFirmware
     * @request POST:/recovery/updateFirmware
     * @secure
     */
    recoveryUpdateFirmware: (
      data: GenericDeviceRequest,
      params: RequestParams = {},
    ) =>
      this.http.request<RecoveryUpdateFirmwareData, void>({
        path: `/recovery/updateFirmware`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),
  };
  switch = {
    /**
     * No description
     *
     * @tags Switch
     * @name SwitchSetOn
     * @request POST:/switch/setOn
     * @secure
     */
    switchSetOn: (data: SetOnOffRequest, params: RequestParams = {}) =>
      this.http.request<SwitchSetOnData, void>({
        path: `/switch/setOn`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Switch
     * @name SwitchSetOff
     * @request POST:/switch/setOff
     * @secure
     */
    switchSetOff: (data: SetOnOffRequest, params: RequestParams = {}) =>
      this.http.request<SwitchSetOffData, void>({
        path: `/switch/setOff`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Switch
     * @name SwitchSetOnTime
     * @request POST:/switch/setOnTime
     * @secure
     */
    switchSetOnTime: (data: SetOnTimeRequest, params: RequestParams = {}) =>
      this.http.request<SwitchSetOnTimeData, void>({
        path: `/switch/setOnTime`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Switch
     * @name SwitchSupplyReturnBehavior
     * @request POST:/switch/supplyReturnBehavior
     * @secure
     */
    switchSupplyReturnBehavior: (
      data: SetSupplyReturnBehaviourRequest,
      params: RequestParams = {},
    ) =>
      this.http.request<
        SwitchSupplyReturnBehaviorData,
        SwitchSupplyReturnBehaviorError
      >({
        path: `/switch/supplyReturnBehavior`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        ...params,
      }),
  };
  trigger = {
    /**
     * No description
     *
     * @tags Trigger
     * @name TriggerFilter
     * @request GET:/trigger/filter
     * @secure
     */
    triggerFilter: (params: RequestParams = {}) =>
      this.http.request<TriggerFilterData, void>({
        path: `/trigger/filter`,
        method: "GET",
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Trigger
     * @name TriggerDetail
     * @request GET:/trigger/{triggerId}
     * @secure
     */
    triggerDetail: (triggerId: string, params: RequestParams = {}) =>
      this.http.request<TriggerDetailData, void>({
        path: `/trigger/${triggerId}`,
        method: "GET",
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Trigger
     * @name TriggerDelete
     * @request DELETE:/trigger/{triggerId}
     * @secure
     */
    triggerDelete: (triggerId: string, params: RequestParams = {}) =>
      this.http.request<TriggerDeleteData, void>({
        path: `/trigger/${triggerId}`,
        method: "DELETE",
        secure: true,
        ...params,
      }),

    /**
     * No description
     *
     * @tags Trigger
     * @name TriggerCreateStateTrigger
     * @request POST:/trigger/createStateTrigger
     * @secure
     */
    triggerCreateStateTrigger: (
      data: CreateStateTriggerRequest,
      params: RequestParams = {},
    ) =>
      this.http.request<
        TriggerCreateStateTriggerData,
        TriggerCreateStateTriggerError
      >({
        path: `/trigger/createStateTrigger`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Trigger
     * @name TriggerEditStateTrigger
     * @request POST:/trigger/editStateTrigger
     * @secure
     */
    triggerEditStateTrigger: (
      data: CreateStateTriggerRequest,
      params: RequestParams = {},
    ) =>
      this.http.request<
        TriggerEditStateTriggerData,
        TriggerEditStateTriggerError
      >({
        path: `/trigger/editStateTrigger`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Trigger
     * @name TriggerCreateTimeTrigger
     * @request POST:/trigger/createTimeTrigger
     * @secure
     */
    triggerCreateTimeTrigger: (
      data: CreateTimeTriggerRequest,
      params: RequestParams = {},
    ) =>
      this.http.request<
        TriggerCreateTimeTriggerData,
        TriggerCreateTimeTriggerError
      >({
        path: `/trigger/createTimeTrigger`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Trigger
     * @name TriggerEditTimeTrigger
     * @request POST:/trigger/editTimeTrigger
     * @secure
     */
    triggerEditTimeTrigger: (
      data: CreateTimeTriggerRequest,
      params: RequestParams = {},
    ) =>
      this.http.request<
        TriggerEditTimeTriggerData,
        TriggerEditTimeTriggerError
      >({
        path: `/trigger/editTimeTrigger`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Trigger
     * @name TriggerCalculateNextFireTime
     * @request POST:/trigger/calculateNextFireTime
     * @secure
     */
    triggerCalculateNextFireTime: (
      data: TriggerTimeConditionRequest,
      params: RequestParams = {},
    ) =>
      this.http.request<
        TriggerCalculateNextFireTimeData,
        TriggerCalculateNextFireTimeError
      >({
        path: `/trigger/calculateNextFireTime`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Trigger
     * @name TriggerActivate
     * @request POST:/trigger/{triggerId}/activate
     * @secure
     */
    triggerActivate: (triggerId: string, params: RequestParams = {}) =>
      this.http.request<TriggerActivateData, void>({
        path: `/trigger/${triggerId}/activate`,
        method: "POST",
        secure: true,
        ...params,
      }),

    /**
     * No description
     *
     * @tags Trigger
     * @name TriggerDeactivate
     * @request POST:/trigger/{triggerId}/deactivate
     * @secure
     */
    triggerDeactivate: (triggerId: string, params: RequestParams = {}) =>
      this.http.request<TriggerDeactivateData, void>({
        path: `/trigger/${triggerId}/deactivate`,
        method: "POST",
        secure: true,
        ...params,
      }),

    /**
     * No description
     *
     * @tags Trigger
     * @name TriggerRun
     * @request POST:/trigger/{triggerId}/run
     * @secure
     */
    triggerRun: (
      {
        triggerId,
        ...query
      }: {
        ignoreStateConditions?: boolean;
        /** @format uuid */
        triggerId: string;
      },
      params: RequestParams = {},
    ) =>
      this.http.request<TriggerRunData, void>({
        path: `/trigger/${triggerId}/run`,
        method: "POST",
        query: query,
        secure: true,
        ...params,
      }),
  };
  upload = {
    /**
     * No description
     *
     * @tags Upload
     * @name UploadProfile
     * @request POST:/upload/profile
     * @secure
     */
    uploadProfile: (data: UploadProfilePayload, params: RequestParams = {}) =>
      this.http.request<UploadProfileData, void>({
        path: `/upload/profile`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.FormData,
        ...params,
      }),
  };
  users = {
    /**
     * No description
     *
     * @tags Users
     * @name UsersDelete
     * @request DELETE:/users/delete
     * @secure
     */
    usersDelete: (params: RequestParams = {}) =>
      this.http.request<UsersDeleteData, void>({
        path: `/users/delete`,
        method: "DELETE",
        secure: true,
        ...params,
      }),
  };
}
